import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: any;
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: string;
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: number;
  /** Integers that will have a value greater than 0. */
  PositiveInt: number;
  /** Sort order */
  SortOrder: any;
  /** Sort order */
  SportEquipmentListSortOrder: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: string;
};

export type AcceptByMaintananceDepartmentInput = {
  comments?: InputMaybe<Scalars['String']>;
  equipmentRelocationRequestId: Scalars['String'];
  hasTransportRequest: Scalars['Boolean'];
  transportRequest?: InputMaybe<SendRequestToTransportDepartmentInput>;
};

export type AcceptExternalOrdersInput = {
  externalOrderId: Scalars['Float'];
  sendToTransportService: Scalars['Boolean'];
};

export type AcceptRequestBySportObjectInput = {
  comments?: InputMaybe<Scalars['String']>;
  equipmentRelocationRequestId: Scalars['String'];
  targetSportObjectId: Scalars['String'];
  targetSportSubZoneId?: InputMaybe<Scalars['String']>;
  targetSportZoneId?: InputMaybe<Scalars['String']>;
};

export type AcceptRequestInput = {
  comments?: InputMaybe<Scalars['String']>;
  equipmentRelocationRequestId: Scalars['String'];
  notifiableUserIds: Array<Scalars['String']>;
  targetSportObjectId: Scalars['String'];
};

/** Input тип для обновления заявок на оборудование при принятии оборудования */
export type AcceptedEquipmentRequestsInput = {
  /** ID заявки на оборудование */
  equipmentRequestId: Scalars['ID'];
  /** Наименование оборудования */
  name?: InputMaybe<Scalars['String']>;
  /** Новое количество оборудования */
  quantity: Scalars['Float'];
};

export type AddNotExistingEquipmentToCartInput = {
  description?: InputMaybe<Scalars['String']>;
  equipmentCount: Scalars['Float'];
  imageIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

/** Input для добавления заявок в объединенную заявку */
export type AddRequestsToCombinedRequestInput = {
  /** ID объединенной заявки */
  combinedRequestId: Scalars['ID'];
  /** Список ID заявок, которые нужно добавить */
  equipmentRequestIds: Array<Scalars['ID']>;
};

export type AddToCartInput = {
  equipmentCount: Scalars['Float'];
  equipmentId: Scalars['String'];
};

export type CancelRequestInput = {
  equipmentRelocationRequestId: Scalars['String'];
  sportObjectId: Scalars['String'];
};

export type CartEntity = {
  __typename?: 'CartEntity';
  cartOwner: UserEntity;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  notExistingEquipmentRecords?: Maybe<Array<NotExistingCartRecordEntity>>;
  records?: Maybe<Array<CartRecordEntity>>;
};

export type CartRecordEntity = {
  __typename?: 'CartRecordEntity';
  cart: CartEntity;
  equipment?: Maybe<SportEquipmentEntity>;
  equipmentCount: Scalars['Float'];
  id: Scalars['ID'];
};

export type ChangeCategoriesInput = {
  sportEquipmentIds: Array<Scalars['String']>;
  toEquipmentTypeId: Scalars['String'];
  toSportCategoryId: Scalars['String'];
  toSportKindId: Scalars['String'];
};

export type ChangeSportObjectInput = {
  sportEquipmentIds: Array<Scalars['String']>;
  toSportObjectId: Scalars['String'];
  toSportSubZoneId: Scalars['String'];
  toSportZoneId: Scalars['String'];
};

/** Поля для создания объединенной заявки на оборудование */
export type CombineRequestsInput = {
  /** Id родительских заявок */
  childRequestsId?: InputMaybe<Array<Scalars['ID']>>;
  /** Дополнительная информация по заявке */
  description?: InputMaybe<Scalars['String']>;
  /** Наименование объединенной заявки */
  name: Scalars['String'];
  /** Стоимость оборудования в заявке */
  price?: InputMaybe<Scalars['Float']>;
  /** Статус заявки (Submitted - ... - Rejected) */
  requestStatus: EquipmentRequestStatusEnum;
  /** Скан служебной записки (id файла) */
  serviceNoteScanFileId?: InputMaybe<Scalars['String']>;
  /** Комментарий в случае, если обррудование необходимо срочно */
  urgentRequirementComment?: InputMaybe<Scalars['String']>;
};

/** Объединенная заявка на оборудование */
export type CombinedEquipmentRequestEntity = {
  __typename?: 'CombinedEquipmentRequestEntity';
  /** Акт приема оборудования */
  acceptanceCertificate?: Maybe<FileStoreEntity>;
  acceptanceCertificateId?: Maybe<Scalars['String']>;
  /** Дочерние запросы */
  childRequests?: Maybe<Array<EquipmentRequestEntity>>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Наименование объединенной заявки */
  name: Scalars['String'];
  /** Стоимость оборудования в заявке */
  price?: Maybe<Scalars['Float']>;
  /** Статус заявки (Подана - ... - Отклонена) */
  requestStatus: EquipmentRequestStatusEnum;
  /** Скан служебной записки */
  serviceNoteScanFile?: Maybe<FileStoreEntity>;
  serviceNoteScanFileId?: Maybe<Scalars['String']>;
  /** Комментарий в случае, если обррудование необходимо срочно */
  urgentRequirementComment?: Maybe<Scalars['String']>;
};

export type Contract = {
  __typename?: 'Contract';
  NMCK?: Maybe<Scalars['String']>;
  applicationStatus?: Maybe<Scalars['String']>;
  approvalMRG?: Maybe<Scalars['String']>;
  approvalNMCK_Directorate?: Maybe<Scalars['String']>;
  approvalNMCK_GAUI?: Maybe<Scalars['String']>;
  approvalPublish?: Maybe<Scalars['String']>;
  approvalRG_GRBS?: Maybe<Scalars['String']>;
  auctionResultsDate?: Maybe<Scalars['String']>;
  basisDocument?: Maybe<Scalars['String']>;
  basisForSigning?: Maybe<Scalars['String']>;
  contractDate?: Maybe<Scalars['String']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractPrice?: Maybe<Scalars['String']>;
  contractor?: Maybe<Scalars['String']>;
  executionPeriod?: Maybe<Scalars['String']>;
  executor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  initiator?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  purchaseStatus?: Maybe<Scalars['String']>;
  receiptDate?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  validity?: Maybe<Scalars['String']>;
};

export type ContractInput = {
  NMCK?: InputMaybe<Scalars['String']>;
  applicationStatus?: InputMaybe<Scalars['String']>;
  approvalMRG?: InputMaybe<Scalars['String']>;
  approvalNMCK_Directorate?: InputMaybe<Scalars['String']>;
  approvalNMCK_GAUI?: InputMaybe<Scalars['String']>;
  approvalPublish?: InputMaybe<Scalars['String']>;
  approvalRG_GRBS?: InputMaybe<Scalars['String']>;
  auctionResultsDate?: InputMaybe<Scalars['String']>;
  basisDocument?: InputMaybe<Scalars['String']>;
  basisForSigning?: InputMaybe<Scalars['String']>;
  contractDate?: InputMaybe<Scalars['String']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractPrice?: InputMaybe<Scalars['String']>;
  contractor?: InputMaybe<Scalars['String']>;
  executionPeriod?: InputMaybe<Scalars['String']>;
  executor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  initiator?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  purchaseStatus?: InputMaybe<Scalars['String']>;
  receiptDate?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  validity?: InputMaybe<Scalars['String']>;
};

export type CreateDictionaryValueInput = {
  dictionaryType: DictionaryTypesEnum;
  name: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type CreateEquipmentRequestInput = {
  analogEquipmentLink?: InputMaybe<Scalars['String']>;
  count: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  equipmentLink?: InputMaybe<Scalars['String']>;
  equipmentTypeId?: InputMaybe<Scalars['String']>;
  mandatorySpecifications?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  price?: InputMaybe<Scalars['Float']>;
  requestStatus: EquipmentRequestStatusEnum;
  serviceNoteScanId?: InputMaybe<Scalars['String']>;
  sportKindId?: InputMaybe<Scalars['String']>;
  sportObjectId: Scalars['String'];
  sportSubZoneId?: InputMaybe<Scalars['String']>;
  sportZoneId?: InputMaybe<Scalars['String']>;
  unitOfMeasurementId?: InputMaybe<Scalars['String']>;
  urgentRequirementComment?: InputMaybe<Scalars['String']>;
};

export type CreateEquipmentServicePeriodInput = {
  name: Scalars['String'];
  nextDate: Scalars['Date'];
  periodType: Scalars['String'];
  sportEquipmentId: Scalars['String'];
};

export type CreateEquipmentSpecificationDictionaryInput = {
  equipmentTypeId: Scalars['String'];
  name: Scalars['String'];
};

export type CreateEquipmentTypeDictionaryInput = {
  name: Scalars['String'];
  sportKindId: Scalars['String'];
};

export type CreateExternalOrderInput = {
  comments?: InputMaybe<Scalars['String']>;
  equipmentRecords?: InputMaybe<Array<OrderRecordInput>>;
  notExistingEquipmentRecords?: InputMaybe<Array<OrderNotExistingRecordInput>>;
  receivingName: Scalars['String'];
  receivingPhone: Scalars['String'];
  receivingPosition: Scalars['String'];
  targetPointAddress: Scalars['String'];
  /** Реквизиты создателя заказа для перевода */
  tenantDetails?: InputMaybe<Scalars['String']>;
  /** ID файла с реквизитами создателя заказа */
  tenantDetailsFileId?: InputMaybe<Scalars['String']>;
};

export type CreateSportCategoryDictionaryInput = {
  name: Scalars['String'];
  sportKindIds: Array<Scalars['String']>;
};

export type CreateSportEquipmentInput = {
  accountingName?: InputMaybe<Scalars['String']>;
  availableForTransfer?: Scalars['Boolean'];
  /** Идентификатор фотографии штрих-кода */
  barcodePhotoId?: InputMaybe<Scalars['String']>;
  certificateIds?: InputMaybe<Array<Scalars['String']>>;
  commissioningCertificateIds?: InputMaybe<Array<Scalars['String']>>;
  commissioningDate: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  equipmentSpecificationId?: InputMaybe<Scalars['String']>;
  equipmentTypeId?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  guaranteeIds?: InputMaybe<Array<Scalars['String']>>;
  /** Высота оборудования в сантиметрах */
  height?: InputMaybe<Scalars['Float']>;
  inUse?: InputMaybe<Scalars['Boolean']>;
  inventoryNumber?: InputMaybe<Scalars['String']>;
  isInformationComplete?: InputMaybe<Scalars['Boolean']>;
  /** Длина оборудования в сантиметрах */
  length?: InputMaybe<Scalars['Float']>;
  mainPhotoId?: InputMaybe<Scalars['String']>;
  manualIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  otherDocumentsIds?: InputMaybe<Array<Scalars['String']>>;
  passportIds?: InputMaybe<Array<Scalars['String']>>;
  photosIds?: InputMaybe<Array<Scalars['String']>>;
  specificationValues?: InputMaybe<Array<Array<Scalars['String']>>>;
  sportCategoryId?: InputMaybe<Scalars['String']>;
  sportKindId?: InputMaybe<Scalars['String']>;
  sportObjectId: Scalars['String'];
  sportSubZoneId?: InputMaybe<Scalars['String']>;
  sportZoneId?: InputMaybe<Scalars['String']>;
  technicalCondition?: InputMaybe<TechnicalCondition>;
  /** Вес оборудования в килограммах */
  weight?: InputMaybe<Scalars['Float']>;
  /** Ширина оборудования в сантиметрах */
  width?: InputMaybe<Scalars['Float']>;
};

export type CreateSportKindDictionaryInput = {
  name: Scalars['String'];
  sportCategoryId: Scalars['String'];
};

export type CreateSportObjectInput = {
  activeDirectoryGroup?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type CreateSportSubZoneInput = {
  area?: InputMaybe<Scalars['Float']>;
  eps?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  number?: InputMaybe<Scalars['Float']>;
  sportObjectId: Scalars['String'];
  sportZoneId: Scalars['String'];
};

export type CreateSportZoneInput = {
  address?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  sportObjectId?: InputMaybe<Scalars['String']>;
};

export type CreateUserInput = {
  departments: Array<DepartmentEnum>;
  email?: InputMaybe<Scalars['String']>;
  isExternal?: Scalars['Boolean'];
  isSportObject: Scalars['Boolean'];
  login: Scalars['String'];
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  sportObjectIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Департаменты / отделы сотрудников */
export enum DepartmentEnum {
  AccountingSportEquipment = 'AccountingSportEquipment',
  Admins = 'Admins',
  EquipmentAcceptanceAndDiagnostics = 'EquipmentAcceptanceAndDiagnostics',
  External = 'External',
  PlanningAndOrganizationPaidServices = 'PlanningAndOrganizationPaidServices',
  SportObject = 'SportObject'
}

export type DictionaryEntity = {
  __typename?: 'DictionaryEntity';
  createdAt: Scalars['String'];
  dictionaryType: DictionaryTypesEnum;
  id: Scalars['ID'];
  name: Scalars['String'];
  tags?: Maybe<Array<DictionaryTagEntity>>;
};

export type DictionaryTagEntity = {
  __typename?: 'DictionaryTagEntity';
  createdAt: Scalars['String'];
  dictionary: DictionaryEntity;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** DictionaryEntity types */
export enum DictionaryTypesEnum {
  MeasurementUnit = 'MeasurementUnit'
}

export type EquipmentRelocationRequestEntity = {
  __typename?: 'EquipmentRelocationRequestEntity';
  acceptByAcceptanceDepartmentComments?: Maybe<Scalars['String']>;
  acceptBySportObjectComments?: Maybe<Scalars['String']>;
  acceptComments?: Maybe<Scalars['String']>;
  acceptedByAcceptanceDepartmentDate?: Maybe<Scalars['String']>;
  acceptedByAcceptanceDepartmentUser?: Maybe<UserEntity>;
  acceptedDate?: Maybe<Scalars['String']>;
  acceptedUser?: Maybe<UserEntity>;
  createdAt: Scalars['String'];
  equipment: SportEquipmentEntity;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  notifiableUsers?: Maybe<Array<UserEntity>>;
  receivedEquipmentComments?: Maybe<Scalars['String']>;
  receivedEquipmentUser?: Maybe<UserEntity>;
  rejectByAcceptanceDepartmentReason?: Maybe<Scalars['String']>;
  rejectReason?: Maybe<Scalars['String']>;
  rejectedByAcceptanceDepartmentDate: Scalars['String'];
  rejectedByAcceptanceDepartmentUser?: Maybe<UserEntity>;
  rejectedDate: Scalars['String'];
  rejectedUser?: Maybe<UserEntity>;
  relocatedDate?: Maybe<Scalars['String']>;
  relocationResponsibleUser?: Maybe<UserEntity>;
  relocationStartedComments?: Maybe<Scalars['String']>;
  relocationStartedDate?: Maybe<Scalars['String']>;
  sourceSportObject: SportObjectEntity;
  sportObjectResponseDate?: Maybe<Scalars['String']>;
  sportObjectResponseUser?: Maybe<UserEntity>;
  status: Scalars['String'];
  targetSportObject?: Maybe<SportObjectEntity>;
  targetSportSubZone?: Maybe<SportSubZoneEntity>;
  targetSportZone?: Maybe<SportZoneEntity>;
  transportRequest?: Maybe<TransportDepartmentRequestEntity>;
};

export type EquipmentRepairRequestEntity = {
  __typename?: 'EquipmentRepairRequestEntity';
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  /** The hero of the occasion */
  sportEquipment: SportEquipmentEntity;
  /** ID of the hero of the occasion */
  sportEquipmentId: Scalars['UUID'];
  /** State history */
  stateHistory: Array<EquipmentRepairRequestStateObject>;
  updatedAt: Scalars['Date'];
};

export type EquipmentRepairRequestFilterInput = {
  equipmentRepairRequestIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Сортировка */
  order?: InputMaybe<Scalars['SortOrder']>;
  skip?: InputMaybe<Scalars['NonNegativeInt']>;
  sportEquipmentIds?: InputMaybe<Array<Scalars['UUID']>>;
  sportObjectIds?: InputMaybe<Array<Scalars['UUID']>>;
  sportSubZoneIds?: InputMaybe<Array<Scalars['UUID']>>;
  sportZoneIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Filter by latest state status */
  statuses?: InputMaybe<Array<EquipmentRepairRequestStatusEnum>>;
  take?: InputMaybe<Scalars['PositiveInt']>;
};

export type EquipmentRepairRequestStateInput = {
  comment: Scalars['String'];
  status: EquipmentRepairRequestStatusEnum;
};

export type EquipmentRepairRequestStateObject = {
  __typename?: 'EquipmentRepairRequestStateObject';
  comment: Scalars['String'];
  /** Date ISO string */
  createdAt: Scalars['String'];
  status: EquipmentRepairRequestStatusEnum;
};

/** Equipment repair request status enum */
export enum EquipmentRepairRequestStatusEnum {
  FixedByOwnEfforts = 'FixedByOwnEfforts',
  Pending = 'Pending',
  PendingAndIncludedInContract = 'PendingAndIncludedInContract',
  RepairRecognisedImpractical = 'RepairRecognisedImpractical',
  Repaired = 'Repaired'
}

export type EquipmentRepairRequestsResponse = {
  __typename?: 'EquipmentRepairRequestsResponse';
  /** Equipment repair requests */
  equipmentRepairRequests: Array<EquipmentRepairRequestEntity>;
  /** Count of requests without pagination */
  total: Scalars['NonNegativeInt'];
};

export type EquipmentRequestCreateHistoryRecordInput = {
  combinedEquipmentRequestId?: InputMaybe<Scalars['String']>;
  equipmentRequestId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  /** Статус заявки (Submitted - ... - Rejected). Если не задано, то используется статус из заявки. */
  requestStatus?: InputMaybe<EquipmentRequestStatusEnum>;
};

export type EquipmentRequestEntity = {
  __typename?: 'EquipmentRequestEntity';
  /** Акт приема оборудования */
  acceptanceCertificate?: Maybe<FileStoreEntity>;
  acceptanceCertificateId?: Maybe<Scalars['String']>;
  analogEquipmentLink?: Maybe<Scalars['String']>;
  count: Scalars['Float'];
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  equipmentLink?: Maybe<Scalars['String']>;
  equipmentType?: Maybe<Scalars['String']>;
  equipmentTypeObject?: Maybe<EquipmentTypeDictionaryEntity>;
  id: Scalars['ID'];
  isChildRequest: Scalars['Boolean'];
  mandatorySpecifications?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Waybill (Накладная) */
  parentCombinedRequest?: Maybe<CombinedEquipmentRequestEntity>;
  parentCombinedRequestId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  rejectReason?: Maybe<Scalars['String']>;
  requestStatus: EquipmentRequestStatusEnum;
  serviceNoteScan?: Maybe<FileStoreEntity>;
  sportKind?: Maybe<Scalars['String']>;
  sportKindObject?: Maybe<SportKindDictionaryEntity>;
  sportObject: SportObjectEntity;
  sportSubZone?: Maybe<SportSubZoneEntity>;
  sportZone: SportZoneEntity;
  unitOfMeasurement?: Maybe<DictionaryEntity>;
  urgentRequirementComment?: Maybe<Scalars['String']>;
  /** Visual inspection report (Акт визуального осмотра) */
  visualInspectionReport?: Maybe<FileStoreEntity>;
  /** ID of visual inspection report (ID Акта визуального осмотра) */
  visualInspectionReportId?: Maybe<Scalars['UUID']>;
  /** Waybill (Накладная) */
  waybill?: Maybe<FileStoreEntity>;
  /** ID of waybill (ID Накладной) */
  waybillId?: Maybe<Scalars['UUID']>;
};

export type EquipmentRequestHistoryRecordEntity = {
  __typename?: 'EquipmentRequestHistoryRecordEntity';
  combinedEquipmentRequest?: Maybe<CombinedEquipmentRequestEntity>;
  createdAt: Scalars['String'];
  equipmentRequest?: Maybe<EquipmentRequestEntity>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  requestStatus: EquipmentRequestStatusEnum;
  user: UserEntity;
};

/** Equipment request status */
export enum EquipmentRequestStatusEnum {
  Acceptance = 'Acceptance',
  Auction = 'Auction',
  ContractingServiceAndPlanningAndEconomicDepartmentApproval = 'ContractingServiceAndPlanningAndEconomicDepartmentApproval',
  DocumentPackageFormation = 'DocumentPackageFormation',
  EquipmentAccepted = 'EquipmentAccepted',
  LotFormation = 'LotFormation',
  PassedToAno = 'PassedToANO',
  PassedToContractualService = 'PassedToContractualService',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Submitted = 'Submitted',
  Success = 'Success',
  Supplied = 'Supplied'
}

export type EquipmentRequestsAcceptForProcessingInput = {
  /** Equipment request id */
  equipmentRequestIds: Array<Scalars['UUID']>;
  /** Comment to all requests */
  message: Scalars['String'];
};

export type EquipmentServiceJobEntity = {
  __typename?: 'EquipmentServiceJobEntity';
  archived: Scalars['Boolean'];
  createdAt: Scalars['String'];
  deadline: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  done: Scalars['Boolean'];
  doneDate?: Maybe<Scalars['String']>;
  equipment?: Maybe<SportEquipmentEntity>;
  equipmentServicePeriod?: Maybe<EquipmentServicePeriodEntity>;
  id: Scalars['ID'];
  jobStatus: Scalars['String'];
  name: Scalars['String'];
  photos?: Maybe<Array<ImageStoreEntity>>;
  sportObject: SportObjectEntity;
  sportSubZone?: Maybe<SportSubZoneEntity>;
  sportZone?: Maybe<SportZoneEntity>;
};

export type EquipmentServicePeriodEntity = {
  __typename?: 'EquipmentServicePeriodEntity';
  createdAt: Scalars['String'];
  equipmentServiceJobs: Array<EquipmentServiceJobEntity>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nextDate: Scalars['String'];
  periodType: Scalars['String'];
  sportEquipment?: Maybe<SportEquipmentEntity>;
};

export type EquipmentSpecificationDictionaryEntity = {
  __typename?: 'EquipmentSpecificationDictionaryEntity';
  createdAt: Scalars['String'];
  equipmentType: EquipmentTypeDictionaryEntity;
  equipmentTypeId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EquipmentTypeDictionaryEntity = {
  __typename?: 'EquipmentTypeDictionaryEntity';
  createdAt: Scalars['String'];
  equipmentSpecifications?: Maybe<Array<EquipmentSpecificationDictionaryEntity>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sportKind: SportKindDictionaryEntity;
  sportKindId: Scalars['String'];
};

/** Input type for export the rented equipment excel report */
export type ExportRentedEquipmentsExcelInput = {
  /** End date for the rents */
  endDate: Scalars['Date'];
  /** Start date for the rents */
  startDate: Scalars['Date'];
};

/** Response for export the rented equipment excel report */
export type ExportRentedEquipmentsExcelResponse = {
  __typename?: 'ExportRentedEquipmentsExcelResponse';
  /** Report file with rents count */
  file?: Maybe<FileStoreEntity>;
  /** Indicates if the rented equipments were found */
  isEquipmentsFound: Scalars['Boolean'];
};

export type ExternalOrderEntity = {
  __typename?: 'ExternalOrderEntity';
  comments?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  externalOrderOwner: UserEntity;
  giverName?: Maybe<Scalars['String']>;
  giverPhone?: Maybe<Scalars['String']>;
  history?: Maybe<Array<ExternalOrderHistoryEntity>>;
  id: Scalars['ID'];
  messages?: Maybe<Array<ExternalOrderMessageEntity>>;
  notExistingEquipmentRecords: Array<ExternalOrderNotExistingRecordEntity>;
  orderNumber: Scalars['String'];
  receivingName: Scalars['String'];
  receivingPhone: Scalars['String'];
  receivingPosition?: Maybe<Scalars['String']>;
  records: Array<ExternalOrderRecordEntity>;
  status: Scalars['String'];
  targetPointAddress: Scalars['String'];
  /** Реквизиты создателя заказа для перевода */
  tenantDetails?: Maybe<Scalars['String']>;
  /** Файл с реквизитами создателя заказа */
  tenantDetailsFile?: Maybe<FileStoreEntity>;
  vehicleType?: Maybe<Scalars['String']>;
};

export type ExternalOrderHistoryEntity = {
  __typename?: 'ExternalOrderHistoryEntity';
  createdAt: Scalars['Date'];
  externalOrder: ExternalOrderEntity;
  id: Scalars['ID'];
  isExisting: Scalars['Boolean'];
  replacementEquipment?: Maybe<SportEquipmentEntity>;
  status: Scalars['String'];
  updatedEquipment?: Maybe<SportEquipmentEntity>;
  updatedNotExistingEquipmentName?: Maybe<Scalars['String']>;
};

export type ExternalOrderMessageEntity = {
  __typename?: 'ExternalOrderMessageEntity';
  createdAt: Scalars['String'];
  externalOrder: ExternalOrderEntity;
  externalOrderStatus: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  user: UserEntity;
};

export type ExternalOrderNotExistingRecordEntity = {
  __typename?: 'ExternalOrderNotExistingRecordEntity';
  createdAt: Scalars['String'];
  dateFrom: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  equipmentCount: Scalars['Float'];
  id: Scalars['ID'];
  images?: Maybe<Array<ImageStoreEntity>>;
  name: Scalars['String'];
  order: ExternalOrderEntity;
};

export type ExternalOrderRecordEntity = {
  __typename?: 'ExternalOrderRecordEntity';
  comment?: Maybe<Scalars['String']>;
  equipment: SportEquipmentEntity;
  equipmentCount?: Maybe<Scalars['Float']>;
  externalOrder: ExternalOrderEntity;
  id: Scalars['ID'];
  isReturned: Scalars['Boolean'];
  technicalCondition?: Maybe<Scalars['String']>;
};

export type FileStoreEntity = {
  __typename?: 'FileStoreEntity';
  createdAt: Scalars['Date'];
  /** File description if needed */
  description?: Maybe<Scalars['String']>;
  /** File extension with dot: ".jpg", ".png", ".pdf", etc */
  ext: Scalars['String'];
  id: Scalars['ID'];
  /** Original file name with extension: "image.jpg", "document.pdf", etc */
  name: Scalars['String'];
  updatedAt: Scalars['String'];
  /** URL to download this file: "/files/<uuid>.<ext>" */
  url: Scalars['String'];
};

export type GetAllSportKindsResponse = {
  __typename?: 'GetAllSportKindsResponse';
  equipmentSpecifications: Array<EquipmentSpecificationDictionaryEntity>;
  equipmentTypes: Array<EquipmentTypeDictionaryEntity>;
  sportCategories: Array<SportCategoryDictionaryEntity>;
  sportKinds: Array<SportKindDictionaryEntity>;
};

export type GetCoordsByAddressResponse = {
  __typename?: 'GetCoordsByAddressResponse';
  address: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type GetEquipmentRequestHistoryInput = {
  combinedEquipmentRequestId?: InputMaybe<Scalars['String']>;
  equipmentRequestId?: InputMaybe<Scalars['String']>;
};

export type GetEquipmentRequestsInput = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  equipmentTypeIds?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['SortOrder']>;
  rejectReason?: InputMaybe<Scalars['String']>;
  requestStatus?: InputMaybe<Array<EquipmentRequestStatusEnum>>;
  skip?: InputMaybe<Scalars['Float']>;
  sportKindIds?: InputMaybe<Array<Scalars['String']>>;
  sportObjectIds?: InputMaybe<Array<Scalars['String']>>;
  sportSubZoneIds?: InputMaybe<Array<Scalars['String']>>;
  sportZoneIds?: InputMaybe<Array<Scalars['String']>>;
  take?: InputMaybe<Scalars['Float']>;
};

export type GetEquipmentRequestsResponse = {
  __typename?: 'GetEquipmentRequestsResponse';
  allCount: Scalars['Float'];
  combinedEquipmentRequests?: Maybe<Array<CombinedEquipmentRequestEntity>>;
  count: Scalars['Float'];
  equipmentRequests?: Maybe<Array<EquipmentRequestEntity>>;
};

export type GetEquipmentServiceJobsInput = {
  deadlineFrom?: InputMaybe<Scalars['String']>;
  deadlineTo?: InputMaybe<Scalars['String']>;
  doneFrom?: InputMaybe<Scalars['String']>;
  doneTo?: InputMaybe<Scalars['String']>;
  equipmentInventoryNumber?: InputMaybe<Scalars['String']>;
  equipmentName?: InputMaybe<Scalars['String']>;
  jobName?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['SortOrder']>;
  skip?: InputMaybe<Scalars['Float']>;
  sportObjectIds?: InputMaybe<Array<Scalars['String']>>;
  sportSubZoneIds?: InputMaybe<Array<Scalars['String']>>;
  sportZoneIds?: InputMaybe<Array<Scalars['String']>>;
  take?: InputMaybe<Scalars['Float']>;
};

export type GetEquipmentServiceJobsResponse = {
  __typename?: 'GetEquipmentServiceJobsResponse';
  count?: Maybe<Scalars['Float']>;
  equipmentServiceJobs?: Maybe<Array<EquipmentServiceJobEntity>>;
};

export type GetExternalOrdersInput = {
  statuses?: InputMaybe<Array<Scalars['String']>>;
};

export type GetRelocationRequestResponse = {
  __typename?: 'GetRelocationRequestResponse';
  allCount: Scalars['Float'];
  count: Scalars['Float'];
  relocationRequests: Array<EquipmentRelocationRequestEntity>;
};

export type GetRelocationRequestsInput = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  equipmentTypeIds?: InputMaybe<Array<Scalars['String']>>;
  inventoryNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['SortOrder']>;
  /** Поиск по name/inventoryNumber (логика ИЛИ) */
  searchText?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  sourceSportObjectIds?: InputMaybe<Array<Scalars['String']>>;
  sportKindIds?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  take?: InputMaybe<Scalars['Float']>;
  targetSportObjectIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GetSportEquipmentInput = {
  accountingName?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  availableForTransfer?: InputMaybe<Scalars['Boolean']>;
  commissioningDateFrom?: InputMaybe<Scalars['String']>;
  commissioningDateTo?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['String']>;
  equipmentId?: InputMaybe<Scalars['String']>;
  equipmentSpecificationIds?: InputMaybe<Array<Scalars['String']>>;
  equipmentTypeIds?: InputMaybe<Array<Scalars['String']>>;
  fromDateAvailable?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<Scalars['UUID']>>;
  inStock?: InputMaybe<Scalars['Boolean']>;
  inUse?: InputMaybe<Scalars['Boolean']>;
  inventoryNumber?: InputMaybe<Scalars['String']>;
  isInformationComplete?: InputMaybe<Scalars['Boolean']>;
  isWroteOff?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['SortOrder']>;
  /** Поиск по name/accountingName/inventoryNumber (логика ИЛИ) */
  searchText?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  sportCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  sportKindIds?: InputMaybe<Array<Scalars['String']>>;
  sportObjectIds?: InputMaybe<Array<Scalars['String']>>;
  sportSubZoneIds?: InputMaybe<Array<Scalars['String']>>;
  sportZoneIds?: InputMaybe<Array<Scalars['String']>>;
  take?: InputMaybe<Scalars['Float']>;
  technicalCondition?: InputMaybe<TechnicalCondition>;
  transferStatus?: InputMaybe<SportEquipmentTransferStatus>;
  untilDateAvailable?: InputMaybe<Scalars['String']>;
};

export type GetSportEquipmentResponse = {
  __typename?: 'GetSportEquipmentResponse';
  allCount: Scalars['Float'];
  count: Scalars['Float'];
  inStockCount: Scalars['Float'];
  sportEquipments: Array<SportEquipmentEntity>;
  withoutStockCount: Scalars['Float'];
};

export type ImageStoreEntity = {
  __typename?: 'ImageStoreEntity';
  /** URL of AVATAR of this image to view in browser: "/images/avatar/<uuid>.<ext>" */
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  /** File description if needed */
  description?: Maybe<Scalars['String']>;
  /** URL to download this image: "/images/<uuid>.<ext>" */
  downloadUrl?: Maybe<Scalars['String']>;
  /** File extension with dot: ".jpg", ".png", ".pdf", etc */
  ext: Scalars['String'];
  /** Image height in pixels after resizing */
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Original file name with extension: "image.jpg", "document.pdf", etc */
  name: Scalars['String'];
  updatedAt: Scalars['String'];
  /** URL to view this image: "/images/image/<uuid>.<ext>" */
  url?: Maybe<Scalars['String']>;
  /** Image width in pixels after resizing */
  width?: Maybe<Scalars['Int']>;
};

export type ImportSportEquipmentsInput = {
  createEquipmentInputs: Array<CreateSportEquipmentInput>;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  token: Scalars['String'];
  user: UserEntity;
};

export type LoginUserInput = {
  login?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  sourceType: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptByMaintenanceDepartment: EquipmentRelocationRequestEntity;
  acceptExternalOrder: ExternalOrderEntity;
  acceptRequestByCommercialDepartment: EquipmentRelocationRequestEntity;
  acceptRequestBySportObject: EquipmentRelocationRequestEntity;
  addContract: Scalars['String'];
  addEquipmentSpecificationDictionary: EquipmentSpecificationDictionaryEntity;
  addEquipmentTypeDictionary: EquipmentTypeDictionaryEntity;
  addNotExistingEquipmentRecordToCart: CartEntity;
  addRequestsToCombinedRequest: CombinedEquipmentRequestEntity;
  addSportCategoryDictionary: SportCategoryDictionaryEntity;
  addSportKindDictionary: SportKindDictionaryEntity;
  addToCart: CartEntity;
  /** Изменить статус внешней заявки на "На согласовании" */
  approveExternalOrder: ExternalOrderEntity;
  cancelRelocation: SportEquipmentEntity;
  cancelRequest: EquipmentRelocationRequestEntity;
  changeCategories: Scalars['Boolean'];
  changeSportObject: Scalars['Boolean'];
  clearCart: CartEntity;
  createCombinedEquipmentRequest: CombinedEquipmentRequestEntity;
  createDictionaryValue: DictionaryEntity;
  createEquipmentRequest: EquipmentRequestEntity;
  createEquipmentServicePeriod: EquipmentServicePeriodEntity;
  createOrder: ExternalOrderEntity;
  createSportEquipment: SportEquipmentEntity;
  createSportObject: SportObjectEntity;
  createSportSubZone: SportSubZoneEntity;
  createSportZone: SportZoneEntity;
  createUser: UserEntity;
  deleteCombinedEquipmentRequest: Scalars['Boolean'];
  deleteContract: Scalars['String'];
  deleteDictionaryValue: Scalars['Boolean'];
  deleteEquipmentRequest: Scalars['Boolean'];
  deleteEquipmentServiceJob: Scalars['Boolean'];
  deleteEquipmentServicePeriod: Scalars['Boolean'];
  deleteEquipmentSpecificationDictionary: Scalars['Boolean'];
  deleteEquipmentTypeDictionary: Scalars['Boolean'];
  deleteSportCategoryDictionary: Scalars['Boolean'];
  deleteSportEquipment: Scalars['Boolean'];
  deleteSportKindDictionary: Scalars['Boolean'];
  deleteSportObject: Scalars['Boolean'];
  deleteSportSubZone: Scalars['Boolean'];
  deleteSportZone: Scalars['Boolean'];
  /** Add status to EquipmentRepairRequest */
  equipmentRepairRequestAddStatus: EquipmentRepairRequestEntity;
  /** Create new EquipmentRepairRequest */
  equipmentRepairRequestCreate: EquipmentRepairRequestEntity;
  /** Delete EquipmentRepairRequest */
  equipmentRepairRequestsDelete: EquipmentRepairRequestEntity;
  equipmentRequestCreateHistoryRecord: EquipmentRequestHistoryRecordEntity;
  /** Массовое изменение статуса заявок на оборудование */
  equipmentRequest_updateEquipmentRequestsStatuses: Array<EquipmentRequestEntity>;
  /** Accept equipments from requests for processing (Начало обработки заявки) */
  equipmentRequestsAcceptForProcessing: Array<EquipmentRequestEntity>;
  exportEquipmentRequests: FileStoreEntity;
  exportEquipmentRequestsFiltered: FileStoreEntity;
  /** Export the transferred equipment excel report */
  exportRentedEquipmentExcel: ExportRentedEquipmentsExcelResponse;
  generatePassword: Scalars['String'];
  importSportEquipment: Scalars['Boolean'];
  /** Отклонить внешнюю заявку */
  rejectExternalOrder: ExternalOrderEntity;
  rejectRequestByAcceptanceDepartment: EquipmentRelocationRequestEntity;
  rejectRequestByCommercialDepartment: EquipmentRelocationRequestEntity;
  relocateEquipment: EquipmentRelocationRequestEntity;
  removeExternalOrderEquipment: ExternalOrderEntity;
  removeExternalOrderNotExistingEquipment: ExternalOrderEntity;
  removeFromCart: CartEntity;
  removeNotExistingEquipmentRecordFromCart: CartEntity;
  removeRequestsFromCombinedRequest: CombinedEquipmentRequestEntity;
  replaceExternalOrderEquipment: ExternalOrderEntity;
  replaceExternalOrderNotExistingEquipment: ExternalOrderEntity;
  sendMessage: ExternalOrderMessageEntity;
  setEditable: Scalars['Boolean'];
  setMainPhoto: Scalars['Boolean'];
  /** Create sport equipment group */
  sportEquipmentGroupCreate: SportEquipmentGroupEntity;
  /** Update sport equipment group */
  sportEquipmentGroupUpdate: SportEquipmentGroupEntity;
  /** Force delete sport equipment groups */
  sportEquipmentGroupsDelete: Array<SportEquipmentGroupEntity>;
  /** Списать оборудование */
  sportEquipmentWriteOff: SportEquipmentEntity;
  /** Вернуть списанное оборудование в эксплуатацию */
  sportEquipmentWriteOffCancel: SportEquipmentEntity;
  startEquipmentRelocation: EquipmentRelocationRequestEntity;
  updateCombinedEquipmentRequest: CombinedEquipmentRequestEntity;
  updateContract: Scalars['String'];
  updateDictionaryValue: DictionaryEntity;
  /** Редактирование заявки на оборудование. Если не передан любой fileId, то файл удаляется. */
  updateEquipmentRequest: EquipmentRequestEntity;
  updateEquipmentServiceJob: EquipmentServiceJobEntity;
  updateEquipmentServicePeriod: EquipmentServicePeriodEntity;
  updateEquipmentSpecificationDictionary: EquipmentSpecificationDictionaryEntity;
  updateEquipmentTypeDictionary: EquipmentTypeDictionaryEntity;
  updateField: Scalars['String'];
  updateSettings: SettingsEntity;
  updateSportCategoryDictionary: SportCategoryDictionaryEntity;
  updateSportEquipment: SportEquipmentEntity;
  updateSportKindDictionary: SportKindDictionaryEntity;
  updateSportObject: SportObjectEntity;
  updateSportObjectsCoords: Scalars['Boolean'];
  updateSportSubZone: SportSubZoneEntity;
  updateSportZone: SportZoneEntity;
  updateUserSettings: UserSettingsEntity;
};


export type MutationAcceptByMaintenanceDepartmentArgs = {
  input: AcceptByMaintananceDepartmentInput;
};


export type MutationAcceptExternalOrderArgs = {
  input: AcceptExternalOrdersInput;
};


export type MutationAcceptRequestByCommercialDepartmentArgs = {
  input: AcceptRequestInput;
};


export type MutationAcceptRequestBySportObjectArgs = {
  input: AcceptRequestBySportObjectInput;
};


export type MutationAddContractArgs = {
  contract: ContractInput;
};


export type MutationAddEquipmentSpecificationDictionaryArgs = {
  input: CreateEquipmentSpecificationDictionaryInput;
};


export type MutationAddEquipmentTypeDictionaryArgs = {
  input: CreateEquipmentTypeDictionaryInput;
};


export type MutationAddNotExistingEquipmentRecordToCartArgs = {
  input: AddNotExistingEquipmentToCartInput;
};


export type MutationAddRequestsToCombinedRequestArgs = {
  input: AddRequestsToCombinedRequestInput;
};


export type MutationAddSportCategoryDictionaryArgs = {
  input: CreateSportCategoryDictionaryInput;
};


export type MutationAddSportKindDictionaryArgs = {
  input: CreateSportKindDictionaryInput;
};


export type MutationAddToCartArgs = {
  input: AddToCartInput;
};


export type MutationApproveExternalOrderArgs = {
  externalOrderId: Scalars['Float'];
};


export type MutationCancelRelocationArgs = {
  equipmentId: Scalars['String'];
};


export type MutationCancelRequestArgs = {
  input: CancelRequestInput;
};


export type MutationChangeCategoriesArgs = {
  input: ChangeCategoriesInput;
};


export type MutationChangeSportObjectArgs = {
  input: ChangeSportObjectInput;
};


export type MutationCreateCombinedEquipmentRequestArgs = {
  input: CombineRequestsInput;
};


export type MutationCreateDictionaryValueArgs = {
  input: CreateDictionaryValueInput;
};


export type MutationCreateEquipmentRequestArgs = {
  input: CreateEquipmentRequestInput;
};


export type MutationCreateEquipmentServicePeriodArgs = {
  input: CreateEquipmentServicePeriodInput;
};


export type MutationCreateOrderArgs = {
  input: CreateExternalOrderInput;
};


export type MutationCreateSportEquipmentArgs = {
  createSportEquipmentInput: CreateSportEquipmentInput;
};


export type MutationCreateSportObjectArgs = {
  createSportObjectInput: CreateSportObjectInput;
};


export type MutationCreateSportSubZoneArgs = {
  createSportSubZoneInput: CreateSportSubZoneInput;
};


export type MutationCreateSportZoneArgs = {
  createSportZoneInput: CreateSportZoneInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteCombinedEquipmentRequestArgs = {
  id: Scalars['String'];
};


export type MutationDeleteContractArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDictionaryValueArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEquipmentRequestArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEquipmentServiceJobArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEquipmentServicePeriodArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEquipmentSpecificationDictionaryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEquipmentTypeDictionaryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSportCategoryDictionaryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSportEquipmentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSportKindDictionaryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSportObjectArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSportSubZoneArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSportZoneArgs = {
  id: Scalars['String'];
};


export type MutationEquipmentRepairRequestAddStatusArgs = {
  equipmentRepairRequestId: Scalars['UUID'];
  state: EquipmentRepairRequestStateInput;
};


export type MutationEquipmentRepairRequestCreateArgs = {
  sportEquipmentId: Scalars['UUID'];
  state: EquipmentRepairRequestStateInput;
};


export type MutationEquipmentRepairRequestsDeleteArgs = {
  equipmentRepairRequestId: Scalars['UUID'];
};


export type MutationEquipmentRequestCreateHistoryRecordArgs = {
  input: EquipmentRequestCreateHistoryRecordInput;
};


export type MutationEquipmentRequest_UpdateEquipmentRequestsStatusesArgs = {
  input: UpdateEquipmentRequestsStatusesInput;
};


export type MutationEquipmentRequestsAcceptForProcessingArgs = {
  input: EquipmentRequestsAcceptForProcessingInput;
};


export type MutationExportEquipmentRequestsArgs = {
  equipmentRequestIds?: InputMaybe<Array<Scalars['String']>>;
  order?: InputMaybe<Scalars['SortOrder']>;
};


export type MutationExportEquipmentRequestsFilteredArgs = {
  input: GetEquipmentRequestsInput;
};


export type MutationExportRentedEquipmentExcelArgs = {
  input: ExportRentedEquipmentsExcelInput;
};


export type MutationGeneratePasswordArgs = {
  password: Scalars['String'];
};


export type MutationImportSportEquipmentArgs = {
  input: ImportSportEquipmentsInput;
};


export type MutationRejectExternalOrderArgs = {
  externalOrderId: Scalars['Float'];
};


export type MutationRejectRequestByAcceptanceDepartmentArgs = {
  input: RejectRequestByAcceptanceDepartmentInput;
};


export type MutationRejectRequestByCommercialDepartmentArgs = {
  input: RejectRequestInput;
};


export type MutationRelocateEquipmentArgs = {
  input: RelocateEquipmentInput;
};


export type MutationRemoveExternalOrderEquipmentArgs = {
  externalOrderRecordId: Scalars['String'];
};


export type MutationRemoveExternalOrderNotExistingEquipmentArgs = {
  notExistingRecordId: Scalars['String'];
};


export type MutationRemoveFromCartArgs = {
  input: RemoveFromCartInput;
};


export type MutationRemoveNotExistingEquipmentRecordFromCartArgs = {
  input: RemoveFromCartInput;
};


export type MutationRemoveRequestsFromCombinedRequestArgs = {
  input: RemoveRequestsFromCombinedRequestInput;
};


export type MutationReplaceExternalOrderEquipmentArgs = {
  input: ReplaceExternalOrderEquipmentInput;
};


export type MutationReplaceExternalOrderNotExistingEquipmentArgs = {
  input: ReplaceExternalOrderNotExistingEquipmentInput;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSetEditableArgs = {
  input: SetEditableInput;
};


export type MutationSetMainPhotoArgs = {
  input: SetMainPhotoInput;
};


export type MutationSportEquipmentGroupCreateArgs = {
  input: SportEquipmentGroupCreateInput;
};


export type MutationSportEquipmentGroupUpdateArgs = {
  input: SportEquipmentGroupUpdateInput;
};


export type MutationSportEquipmentGroupsDeleteArgs = {
  ids: Array<Scalars['UUID']>;
};


export type MutationSportEquipmentWriteOffArgs = {
  sportEquipmentId: Scalars['UUID'];
  wroteOffCertificateId: Scalars['UUID'];
};


export type MutationSportEquipmentWriteOffCancelArgs = {
  sportEquipmentId: Scalars['UUID'];
};


export type MutationStartEquipmentRelocationArgs = {
  input: StartEquipmentRelocationInput;
};


export type MutationUpdateCombinedEquipmentRequestArgs = {
  input: UpdateCombinedEquipmentRequestInput;
};


export type MutationUpdateContractArgs = {
  contract: ContractInput;
};


export type MutationUpdateDictionaryValueArgs = {
  input: UpdateDictionaryValueInput;
};


export type MutationUpdateEquipmentRequestArgs = {
  input: UpdateEquipmentRequestInput;
};


export type MutationUpdateEquipmentServiceJobArgs = {
  input: UpdateEquipmentServiceJobInput;
};


export type MutationUpdateEquipmentServicePeriodArgs = {
  input: UpdateEquipmentServicePeriodInput;
};


export type MutationUpdateEquipmentSpecificationDictionaryArgs = {
  input: UpdateEquipmentSpecificationDictionaryInput;
};


export type MutationUpdateEquipmentTypeDictionaryArgs = {
  input: UpdateEquipmentTypeDictionaryInput;
};


export type MutationUpdateFieldArgs = {
  fieldName: Scalars['String'];
  id: Scalars['String'];
  value: Scalars['String'];
};


export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


export type MutationUpdateSportCategoryDictionaryArgs = {
  input: UpdateSportCategoryDictionaryInput;
};


export type MutationUpdateSportEquipmentArgs = {
  updateSportEquipmentInput: UpdateSportEquipmentInput;
};


export type MutationUpdateSportKindDictionaryArgs = {
  input: UpdateSportKindDictionaryInput;
};


export type MutationUpdateSportObjectArgs = {
  updateSportObjectInput: UpdateSportObjectInput;
};


export type MutationUpdateSportSubZoneArgs = {
  updateSportSubZoneInput: UpdateSportSubZoneInput;
};


export type MutationUpdateSportZoneArgs = {
  updateSportZoneInput: UpdateSportZoneInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};

export type NotExistingCartRecordEntity = {
  __typename?: 'NotExistingCartRecordEntity';
  cart: CartEntity;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  equipmentCount: Scalars['Float'];
  id: Scalars['ID'];
  images?: Maybe<Array<ImageStoreEntity>>;
  name: Scalars['String'];
};

export type OrderNotExistingRecordInput = {
  description?: InputMaybe<Scalars['String']>;
  equipmentCount: Scalars['Float'];
  imageIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type OrderRecordInput = {
  equipmentCount: Scalars['Float'];
  equipmentId: Scalars['String'];
};

export type Permission = {
  __typename?: 'Permission';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /** Get EquipmentRepairRequest by ID */
  equipmentRepairRequest: EquipmentRepairRequestEntity;
  /** Get filtered EquipmentRepairRequests */
  equipmentRepairRequests: EquipmentRepairRequestsResponse;
  exportEquipmentReapairRequestsInExcel: FileStoreEntity;
  exportExternalOrder: FileStoreEntity;
  exportExternalOrderHistory: FileStoreEntity;
  exportSportEquipmentsInExcel: FileStoreEntity;
  getAllContracts: Array<Contract>;
  getAllEquipmentRequests: Array<EquipmentRequestEntity>;
  getAllEquipmentRequestsByStatuses: Array<EquipmentRequestEntity>;
  getAllEquipmentSpecificationDictionary: Array<EquipmentSpecificationDictionaryEntity>;
  getAllEquipmentTypeDictionary: Array<EquipmentTypeDictionaryEntity>;
  getAllSportCategoryDictionary: Array<SportCategoryDictionaryEntity>;
  getAllSportKindDictionary: GetAllSportKindsResponse;
  getAllSportObjects: Array<SportObjectEntity>;
  getArchivedEquipmentServiceJobsBySportObject: Array<EquipmentServiceJobEntity>;
  getArchivedEquipmentServiceJobsBySportObjects: Array<EquipmentServiceJobEntity>;
  getCart: CartEntity;
  getCombinedEquipmentRequestById?: Maybe<CombinedEquipmentRequestEntity>;
  getCoordsByAddress: GetCoordsByAddressResponse;
  getEquipmentRelocationRequestByIds: Array<EquipmentRelocationRequestEntity>;
  getEquipmentRequestById?: Maybe<EquipmentRequestEntity>;
  getEquipmentRequestHistory: Array<EquipmentRequestHistoryRecordEntity>;
  getEquipmentRequests: GetEquipmentRequestsResponse;
  getEquipmentRequestsBySportObjectId: Array<EquipmentRequestEntity>;
  getEquipmentServiceJobById: EquipmentServiceJobEntity;
  getEquipmentServiceJobs: GetEquipmentServiceJobsResponse;
  getEquipmentServiceJobsBySportObject: Array<EquipmentServiceJobEntity>;
  getEquipmentServiceJobsBySportObjects: Array<EquipmentServiceJobEntity>;
  getEquipmentServicePeriods: Array<EquipmentServicePeriodEntity>;
  getEquipmentSpecificationDictionaryByEquipmentTypeId: Array<EquipmentSpecificationDictionaryEntity>;
  getEquipmentTypeDictionaryBySportKindId: Array<EquipmentTypeDictionaryEntity>;
  /** Получение словаря по его типу */
  getFullDictionary: Array<DictionaryEntity>;
  getNotReturnedEquipment: Array<ExternalOrderRecordEntity>;
  getOrderById: ExternalOrderEntity;
  getOrders: Array<ExternalOrderEntity>;
  getRelocationRequests: GetRelocationRequestResponse;
  getSettings: Array<SettingsEntity>;
  getSpecifications: Array<SpecificationEntity>;
  getSportEquipmentById: SportEquipmentEntity;
  getSportEquipmentHistoryByEquipmentId: Array<SportEquipmentHistoryEntity>;
  getSportEquipmentHistoryByHistoryId: SportEquipmentHistoryEntity;
  getSportEquipments: GetSportEquipmentResponse;
  getSportObject: SportObjectEntity;
  getSportObjects: Array<SportObjectEntity>;
  getSportSubZone: SportSubZoneEntity;
  getSportSubZonesByObjectId: Array<SportSubZoneEntity>;
  getSportSubZonesByZoneId: Array<SportSubZoneEntity>;
  getSportZone: SportZoneEntity;
  getSportZonesByObjectId: Array<SportZoneEntity>;
  login: LoginResult;
  loginShop: LoginResult;
  refreshToken: Scalars['String'];
  searchTags: Array<DictionaryTagEntity>;
  selectedSportObjectIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Get sport equipment group by id */
  sportEquipmentGroup: SportEquipmentGroupEntity;
  /** Get all sport equipment groups */
  sportEquipmentGroups: Array<SportEquipmentGroupEntity>;
  sportEquipmentListFilters: SportEquipmentListFilters;
  sportEquipmentListPagination: SportEquipmentListPagination;
  sportEquipmentListSortOrder: Scalars['SportEquipmentListSortOrder'];
  sportEquipmentTabActive: SportEquipmentTab;
  /** Sport equipments and groups with equipments */
  sportEquipmentsInGroups: SportEquipmentsInGroupsResponse;
  user: UserEntity;
  users: Array<UserEntity>;
  /** Get users emails of sport object */
  usersOfSportObject: Array<UserOfSportObjectResponse>;
};


export type QueryEquipmentRepairRequestArgs = {
  id: Scalars['UUID'];
};


export type QueryEquipmentRepairRequestsArgs = {
  filter?: InputMaybe<EquipmentRepairRequestFilterInput>;
};


export type QueryExportEquipmentReapairRequestsInExcelArgs = {
  filter?: InputMaybe<EquipmentRepairRequestFilterInput>;
};


export type QueryExportExternalOrderArgs = {
  externalOrderId: Scalars['Float'];
};


export type QueryExportExternalOrderHistoryArgs = {
  externalOrderId: Scalars['Float'];
};


export type QueryExportSportEquipmentsInExcelArgs = {
  input: GetSportEquipmentInput;
};


export type QueryGetAllEquipmentRequestsByStatusesArgs = {
  statuses: Array<EquipmentRequestStatusEnum>;
};


export type QueryGetArchivedEquipmentServiceJobsBySportObjectArgs = {
  sportObjectId: Scalars['String'];
};


export type QueryGetArchivedEquipmentServiceJobsBySportObjectsArgs = {
  sportObjectIds: Array<Scalars['String']>;
};


export type QueryGetCombinedEquipmentRequestByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetCoordsByAddressArgs = {
  address: Scalars['String'];
};


export type QueryGetEquipmentRelocationRequestByIdsArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryGetEquipmentRequestByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetEquipmentRequestHistoryArgs = {
  input: GetEquipmentRequestHistoryInput;
};


export type QueryGetEquipmentRequestsArgs = {
  input: GetEquipmentRequestsInput;
};


export type QueryGetEquipmentRequestsBySportObjectIdArgs = {
  sportObjectId: Scalars['String'];
};


export type QueryGetEquipmentServiceJobByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetEquipmentServiceJobsArgs = {
  input: GetEquipmentServiceJobsInput;
};


export type QueryGetEquipmentServiceJobsBySportObjectArgs = {
  sportObjectId: Scalars['String'];
};


export type QueryGetEquipmentServiceJobsBySportObjectsArgs = {
  sportObjectIds: Array<Scalars['String']>;
};


export type QueryGetEquipmentServicePeriodsArgs = {
  equipmentId: Scalars['String'];
};


export type QueryGetEquipmentSpecificationDictionaryByEquipmentTypeIdArgs = {
  equipmentTypeId: Scalars['String'];
};


export type QueryGetEquipmentTypeDictionaryBySportKindIdArgs = {
  sportKindId: Scalars['String'];
};


export type QueryGetFullDictionaryArgs = {
  dictionaryType: DictionaryTypesEnum;
};


export type QueryGetOrderByIdArgs = {
  orderId: Scalars['Float'];
};


export type QueryGetOrdersArgs = {
  input: GetExternalOrdersInput;
};


export type QueryGetRelocationRequestsArgs = {
  input: GetRelocationRequestsInput;
};


export type QueryGetSportEquipmentByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSportEquipmentHistoryByEquipmentIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSportEquipmentHistoryByHistoryIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSportEquipmentsArgs = {
  input: GetSportEquipmentInput;
};


export type QueryGetSportObjectArgs = {
  id: Scalars['String'];
};


export type QueryGetSportObjectsArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryGetSportSubZoneArgs = {
  id: Scalars['String'];
};


export type QueryGetSportSubZonesByObjectIdArgs = {
  sportObjectId: Scalars['String'];
};


export type QueryGetSportSubZonesByZoneIdArgs = {
  sportZoneId: Scalars['String'];
};


export type QueryGetSportZoneArgs = {
  id: Scalars['String'];
};


export type QueryGetSportZonesByObjectIdArgs = {
  sportObjectId: Scalars['String'];
};


export type QueryLoginArgs = {
  input: LoginUserInput;
};


export type QueryLoginShopArgs = {
  input: LoginUserInput;
};


export type QuerySearchTagsArgs = {
  tagName: Scalars['String'];
};


export type QuerySportEquipmentGroupArgs = {
  id: Scalars['UUID'];
};


export type QuerySportEquipmentsInGroupsArgs = {
  input: GetSportEquipmentInput;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};


export type QueryUsersOfSportObjectArgs = {
  sportObjectId: Scalars['UUID'];
};

export type RejectRequestByAcceptanceDepartmentInput = {
  equipmentRelocationRequestId: Scalars['String'];
  reason: Scalars['String'];
};

export type RejectRequestInput = {
  equipmentRelocationRequestId: Scalars['String'];
  reason: Scalars['String'];
};

export type RelocateEquipmentInput = {
  relocateRequestId: Scalars['String'];
  targetSportObjectId: Scalars['String'];
  targetSportSubZoneId?: InputMaybe<Scalars['String']>;
  targetSportZoneId?: InputMaybe<Scalars['String']>;
};

export type RemoveFromCartInput = {
  cartRecordId: Scalars['String'];
  equipmentCount: Scalars['Float'];
};

/** Input для удаления заявок из объединенной заявки */
export type RemoveRequestsFromCombinedRequestInput = {
  /** ID объединенной заявки */
  combinedRequestId: Scalars['ID'];
  /** Список ID заявок, которые нужно удалить из объединенной заявки */
  equipmentRequestIds: Array<Scalars['ID']>;
};

export type ReplaceExternalOrderEquipmentInput = {
  externalOrderId: Scalars['Float'];
  newEquipmentId: Scalars['String'];
  oldEquipmentId: Scalars['String'];
};

export type ReplaceExternalOrderNotExistingEquipmentInput = {
  equipmentId: Scalars['String'];
  notExistingEquipmentId: Scalars['String'];
};

export type SendMessageInput = {
  externalOrderId: Scalars['ID'];
  message: Scalars['String'];
};

export type SendRequestToTransportDepartmentInput = {
  collectionPointAddress: Scalars['String'];
  comments?: InputMaybe<Scalars['String']>;
  endEventDate?: InputMaybe<Scalars['String']>;
  equipmentIds: Array<Scalars['String']>;
  giverName: Scalars['String'];
  giverPhone: Scalars['String'];
  needForHandling: Scalars['Boolean'];
  needForMountingDismounting: Scalars['Boolean'];
  receivingName: Scalars['String'];
  receivingPhone: Scalars['String'];
  relocationRequestId: Scalars['String'];
  relocationType: Scalars['String'];
  returnDate?: InputMaybe<Scalars['String']>;
  startEventDate?: InputMaybe<Scalars['String']>;
  startVehicleDeliveryDate: Scalars['String'];
  targetPointAddress: Scalars['String'];
  vehicleType: Scalars['String'];
};

export type SetEditableInput = {
  isEditable: Scalars['Boolean'];
  sportEquipmentId: Scalars['String'];
};

export type SetMainPhotoInput = {
  mainPhotoId: Scalars['String'];
  sportEquipmentId: Scalars['String'];
};

export type SettingsEntity = {
  __typename?: 'SettingsEntity';
  acceptanceAndDiagnosticsEquipmentMover?: Maybe<UserEntity>;
  accountantEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  leaseNegotiator?: Maybe<UserEntity>;
  planningAndServiceEquipmentMover?: Maybe<UserEntity>;
  transportServiceEmail?: Maybe<Scalars['String']>;
};

export type SpecificationEntity = {
  __typename?: 'SpecificationEntity';
  id: Scalars['ID'];
  name: Scalars['String'];
  specificationListValues?: Maybe<Array<SpecificationListValuesEntity>>;
  specificationType: Scalars['String'];
  unit?: Maybe<SpecificationUnitEntity>;
};

export type SpecificationListValuesEntity = {
  __typename?: 'SpecificationListValuesEntity';
  id: Scalars['ID'];
  name: Scalars['String'];
  specification?: Maybe<SpecificationEntity>;
  value: Scalars['String'];
};

export type SpecificationUnitEntity = {
  __typename?: 'SpecificationUnitEntity';
  id: Scalars['ID'];
  name: Scalars['String'];
  shortName: Scalars['String'];
};

export type SpecificationValueEntity = {
  __typename?: 'SpecificationValueEntity';
  id: Scalars['ID'];
  specification: SpecificationEntity;
  sportEquipment?: Maybe<SportEquipmentEntity>;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueList?: Maybe<SpecificationListValuesEntity>;
  valueNumber?: Maybe<Scalars['Float']>;
  valueString?: Maybe<Scalars['String']>;
};

export type SportCategoryDictionaryEntity = {
  __typename?: 'SportCategoryDictionaryEntity';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sportKinds: Array<SportKindDictionaryEntity>;
};

export type SportEquipmentEntity = {
  __typename?: 'SportEquipmentEntity';
  accountingName?: Maybe<Scalars['String']>;
  availableForTransfer: Scalars['Boolean'];
  /** Фотография штрих-кода */
  barcodePhoto?: Maybe<ImageStoreEntity>;
  certificate?: Maybe<Array<FileStoreEntity>>;
  commissioningCertificates?: Maybe<Array<FileStoreEntity>>;
  commissioningDate: Scalars['String'];
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  equipmentServicePeriods?: Maybe<Array<EquipmentServicePeriodEntity>>;
  equipmentSpecificationObject?: Maybe<EquipmentSpecificationDictionaryEntity>;
  equipmentType?: Maybe<Scalars['String']>;
  equipmentTypeObject?: Maybe<EquipmentTypeDictionaryEntity>;
  failureReason?: Maybe<Scalars['String']>;
  group?: Maybe<SportEquipmentGroupEntity>;
  groupId?: Maybe<Scalars['UUID']>;
  guarantee?: Maybe<Array<FileStoreEntity>>;
  /** Высота оборудования в сантиметрах */
  height?: Maybe<Scalars['Float']>;
  history?: Maybe<Array<SportEquipmentHistoryEntity>>;
  id: Scalars['ID'];
  inUse: Scalars['Boolean'];
  inventoryNumber?: Maybe<Scalars['String']>;
  isEditable: Scalars['Boolean'];
  /** Заполнена ли информация об оборудовании? */
  isInformationComplete: Scalars['Boolean'];
  /** Списано ли оборудование? */
  isWroteOff: Scalars['Boolean'];
  /** Длина оборудования в сантиметрах */
  length?: Maybe<Scalars['Float']>;
  mainPhoto?: Maybe<ImageStoreEntity>;
  manual?: Maybe<Array<FileStoreEntity>>;
  name?: Maybe<Scalars['String']>;
  otherDocuments?: Maybe<Array<FileStoreEntity>>;
  passport?: Maybe<Array<FileStoreEntity>>;
  photos?: Maybe<Array<ImageStoreEntity>>;
  specifications?: Maybe<Array<SpecificationValueEntity>>;
  sportCategoryObject?: Maybe<SportCategoryDictionaryEntity>;
  sportEquipmentNotAvailableRecords?: Maybe<Array<SportEquipmentNotAvailableRecordEntity>>;
  sportKind?: Maybe<Scalars['String']>;
  sportKindObject?: Maybe<SportKindDictionaryEntity>;
  sportObject: SportObjectEntity;
  sportSubZone?: Maybe<SportSubZoneEntity>;
  sportZone?: Maybe<SportZoneEntity>;
  technicalCondition: TechnicalCondition;
  transferStatus?: Maybe<SportEquipmentTransferStatus>;
  /** Вес оборудования в килограммах */
  weight?: Maybe<Scalars['Float']>;
  /** Ширина оборудования в сантиметрах */
  width?: Maybe<Scalars['Float']>;
  /** Акт о списании */
  wroteOffCertificate?: Maybe<FileStoreEntity>;
};

/** Input type to create sport equipment group */
export type SportEquipmentGroupCreateInput = {
  /** Name of the group */
  name: Scalars['String'];
  /** Sport equipments ids to connect (sub zone must match) */
  sportEquipmentsConnectIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Sport equipments sub zone must match to this. Can't be changed. */
  sportSubZoneId: Scalars['UUID'];
};

export type SportEquipmentGroupEntity = {
  __typename?: 'SportEquipmentGroupEntity';
  createdAt: Scalars['Date'];
  id: Scalars['UUID'];
  /** Name of the group */
  name: Scalars['String'];
  /** Sport equipments list connected to this group */
  sportEquipments: Array<SportEquipmentEntity>;
  /** Sport equipments sub zone must match to this. Can't be changed. */
  sportSubZone: SportSubZoneEntity;
  /** Sport equipments sub zone must match to this. Can't be changed. */
  sportSubZoneId: Scalars['UUID'];
  updatedAt: Scalars['Date'];
};

/** Input type to update sport equipment group */
export type SportEquipmentGroupUpdateInput = {
  /** Id of group to update */
  id?: InputMaybe<Scalars['UUID']>;
  /** Name of the group */
  name?: InputMaybe<Scalars['String']>;
  /** Sport equipments ids to connect (sub zone must match) */
  sportEquipmentsConnectIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Sport equipments ids to disconnect */
  sportEquipmentsDisconnectIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type SportEquipmentHistoryEntity = {
  __typename?: 'SportEquipmentHistoryEntity';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  sportEquipment: SportEquipmentEntity;
  sportEquipmentHistoryJson: SportEquipmentEntity;
  user: UserEntity;
};

export type SportEquipmentListFilters = {
  __typename?: 'SportEquipmentListFilters';
  archived?: Maybe<Scalars['Boolean']>;
  commissioningDate?: Maybe<Array<Maybe<Scalars['String']>>>;
  commissioningDateFrom?: Maybe<Scalars['String']>;
  commissioningDateTo?: Maybe<Scalars['String']>;
  createdAtFrom?: Maybe<Scalars['String']>;
  createdAtTo?: Maybe<Scalars['String']>;
  equipmentTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  inUse?: Maybe<Scalars['Boolean']>;
  inventoryNumber?: Maybe<Scalars['String']>;
  isWroteOff?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  sportCategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  sportKindIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  sportObjectIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  sportSubZoneIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  sportZoneIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  technicalCondition?: Maybe<Scalars['String']>;
  transferStatus?: Maybe<Scalars['String']>;
};

export type SportEquipmentListPagination = {
  __typename?: 'SportEquipmentListPagination';
  page: Scalars['Float'];
  pageSize: Scalars['Float'];
};

export type SportEquipmentNotAvailableRecordEntity = {
  __typename?: 'SportEquipmentNotAvailableRecordEntity';
  createdAt: Scalars['String'];
  dateFrom: Scalars['String'];
  dateTo?: Maybe<Scalars['String']>;
  externalOrder: ExternalOrderEntity;
  id: Scalars['ID'];
  sportEquipment: SportEquipmentEntity;
};

export type SportEquipmentTab = {
  __typename?: 'SportEquipmentTab';
  displayName: Scalars['String'];
  id: Scalars['String'];
};

/** Sport equipment transfer status */
export enum SportEquipmentTransferStatus {
  TransferredToSubordinate = 'TransferredToSubordinate'
}

/** Sport equipments in groups and without */
export type SportEquipmentsInGroupsResponse = {
  __typename?: 'SportEquipmentsInGroupsResponse';
  /** Groups with sport equipments */
  groups: Array<SportEquipmentGroupEntity>;
  /** Sport Equipments */
  sportEquipments: Array<SportEquipmentEntity>;
};

export type SportKindDictionaryEntity = {
  __typename?: 'SportKindDictionaryEntity';
  createdAt: Scalars['String'];
  equipmentTypes: Array<EquipmentTypeDictionaryEntity>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sportCategory: SportCategoryDictionaryEntity;
  sportCategoryId: Scalars['String'];
};

export type SportObjectEntity = {
  __typename?: 'SportObjectEntity';
  activeDirectoryGroup: Scalars['String'];
  address: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  sportEquipments: Array<SportEquipmentEntity>;
  sportSubZones?: Maybe<Array<SportSubZoneEntity>>;
  sportZones?: Maybe<Array<SportZoneEntity>>;
};

export type SportSubZoneEntity = {
  __typename?: 'SportSubZoneEntity';
  area?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  eps?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  number?: Maybe<Scalars['Int']>;
  sportEquipments: Array<SportEquipmentEntity>;
  sportObject: SportObjectEntity;
  sportZone: SportZoneEntity;
};

export type SportZoneEntity = {
  __typename?: 'SportZoneEntity';
  address: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  scheduleTimeStep: Scalars['String'];
  sportEquipments: Array<SportEquipmentEntity>;
  sportObject: SportObjectEntity;
  sportSubZones: Array<SportSubZoneEntity>;
};

export type StartEquipmentRelocationInput = {
  comments: Scalars['String'];
  relocateRequestId: Scalars['String'];
};

/** Technical condition */
export enum TechnicalCondition {
  AwaitingRegistration = 'AWAITING_REGISTRATION',
  NotWorking = 'NOT_WORKING',
  Working = 'WORKING'
}

export type TransportDepartmentRequestEntity = {
  __typename?: 'TransportDepartmentRequestEntity';
  collectionPointAddress: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  endEventDate?: Maybe<Scalars['String']>;
  equipmentList: Array<SportEquipmentEntity>;
  giverName: Scalars['String'];
  giverPhone: Scalars['String'];
  id: Scalars['ID'];
  needForHandling: Scalars['Boolean'];
  needForMountingDismounting: Scalars['Boolean'];
  receivingName: Scalars['String'];
  receivingPhone: Scalars['String'];
  relocationRequest: EquipmentRelocationRequestEntity;
  relocationType: Scalars['String'];
  returnDate?: Maybe<Scalars['String']>;
  startEventDate?: Maybe<Scalars['String']>;
  startVehicleDeliveryDate: Scalars['String'];
  targetPointAddress: Scalars['String'];
  vehicleType: Scalars['String'];
};

/** Поля для обновления объединенной заявки на оборудование */
export type UpdateCombinedEquipmentRequestInput = {
  /** Акт приема оборудования (id файла) */
  acceptanceCertificateId?: InputMaybe<Scalars['String']>;
  /** Массив заявок на оборудование с указанием количества и наименования для принятия оборудования */
  acceptedEquipmentRequests?: InputMaybe<Array<AcceptedEquipmentRequestsInput>>;
  /** Id родительских заявок */
  childRequestId?: InputMaybe<Array<Scalars['ID']>>;
  /** Дополнительная информация по заявке */
  description?: InputMaybe<Scalars['String']>;
  /** ID объединенной заявки */
  id: Scalars['ID'];
  /** Наименование объединенной заявки */
  name?: InputMaybe<Scalars['String']>;
  /** Стоимость оборудования в заявке */
  price?: InputMaybe<Scalars['Float']>;
  /** Статус заявки (Submitted - ... - Rejected) */
  requestStatus?: InputMaybe<EquipmentRequestStatusEnum>;
  /** Скан служебной записки (id файла) */
  serviceNoteScanFileId?: InputMaybe<Scalars['String']>;
  /** Комментарий в случае, если оборудование необходимо срочно */
  urgentRequirementComment?: InputMaybe<Scalars['String']>;
};

export type UpdateDictionaryValueInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type UpdateEquipmentRequestInput = {
  analogEquipmentLink?: InputMaybe<Scalars['String']>;
  count: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  equipmentLink?: InputMaybe<Scalars['String']>;
  equipmentTypeId: Scalars['String'];
  id: Scalars['String'];
  mandatorySpecifications?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  price?: InputMaybe<Scalars['Float']>;
  rejectReason?: InputMaybe<Scalars['String']>;
  requestStatus: EquipmentRequestStatusEnum;
  serviceNoteScanId?: InputMaybe<Scalars['String']>;
  sportKindId?: InputMaybe<Scalars['String']>;
  sportObjectId: Scalars['String'];
  sportSubZoneId?: InputMaybe<Scalars['String']>;
  sportZoneId?: InputMaybe<Scalars['String']>;
  unitOfMeasurementId?: InputMaybe<Scalars['String']>;
  urgentRequirementComment?: InputMaybe<Scalars['String']>;
  /** ID of visual inspection report (ID Акта визуального осмотра) */
  visualInspectionReportId?: InputMaybe<Scalars['UUID']>;
  /** ID of waybill (ID Накладной) */
  waybillId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateEquipmentRequestsStatusesInput = {
  /** Акт приема оборудования (id файла) */
  acceptanceCertificateId?: InputMaybe<Scalars['String']>;
  /** Массив заявок на оборудование с указанием количества и наименования для принятия оборудования */
  acceptedEquipmentRequests?: InputMaybe<Array<AcceptedEquipmentRequestsInput>>;
  /** Новый статус для заявок */
  newStatus: EquipmentRequestStatusEnum;
  /** Причина отклонения (опционально, для статуса Rejected) */
  rejectReason?: InputMaybe<Scalars['String']>;
  /** Массив ID заявок для изменения статуса */
  requestIds: Array<Scalars['String']>;
};

export type UpdateEquipmentServiceJobInput = {
  deadline: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  done: Scalars['Boolean'];
  doneDate?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  photosIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateEquipmentServicePeriodInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  periodType: Scalars['String'];
  sportEquipmentId: Scalars['String'];
};

export type UpdateEquipmentSpecificationDictionaryInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateEquipmentTypeDictionaryInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateSettingsInput = {
  acceptanceAndDiagnosticsEquipmentMoverId?: InputMaybe<Scalars['String']>;
  accountantEmail?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  leaseNegotiatorId?: InputMaybe<Scalars['String']>;
  planningAndServiceEquipmentMoverId?: InputMaybe<Scalars['String']>;
  transportServiceEmail?: InputMaybe<Scalars['String']>;
};

export type UpdateSportCategoryDictionaryInput = {
  attachSportKindIds: Array<Scalars['String']>;
  detachSportKindIds: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateSportEquipmentInput = {
  accountingName?: InputMaybe<Scalars['String']>;
  availableForTransfer?: Scalars['Boolean'];
  /** Идентификатор фотографии штрих-кода */
  barcodePhotoId?: InputMaybe<Scalars['String']>;
  certificateIds?: InputMaybe<Array<Scalars['String']>>;
  commissioningCertificateIds?: InputMaybe<Array<Scalars['String']>>;
  commissioningDate: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  equipmentSpecificationId?: InputMaybe<Scalars['String']>;
  equipmentTypeId?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  guaranteeIds?: InputMaybe<Array<Scalars['String']>>;
  /** Высота оборудования в сантиметрах */
  height?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  inUse?: InputMaybe<Scalars['Boolean']>;
  inventoryNumber?: InputMaybe<Scalars['String']>;
  isInformationComplete?: Scalars['Boolean'];
  /** Длина оборудования в сантиметрах */
  length?: InputMaybe<Scalars['Float']>;
  mainPhotoId?: InputMaybe<Scalars['String']>;
  manualIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  otherDocumentsIds?: InputMaybe<Array<Scalars['String']>>;
  passportIds?: InputMaybe<Array<Scalars['String']>>;
  photosIds?: InputMaybe<Array<Scalars['String']>>;
  specificationValues?: InputMaybe<Array<Array<Scalars['String']>>>;
  sportCategoryId?: InputMaybe<Scalars['String']>;
  sportKindId?: InputMaybe<Scalars['String']>;
  sportObjectId: Scalars['String'];
  sportSubZoneId?: InputMaybe<Scalars['String']>;
  sportZoneId?: InputMaybe<Scalars['String']>;
  technicalCondition?: InputMaybe<TechnicalCondition>;
  /** Вес оборудования в килограммах */
  weight?: InputMaybe<Scalars['Float']>;
  /** Ширина оборудования в сантиметрах */
  width?: InputMaybe<Scalars['Float']>;
};

export type UpdateSportKindDictionaryInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateSportObjectInput = {
  activeDirectoryGroup?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type UpdateSportSubZoneInput = {
  area?: InputMaybe<Scalars['Float']>;
  eps?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  sportObjectId?: InputMaybe<Scalars['String']>;
  sportZoneId?: InputMaybe<Scalars['String']>;
};

export type UpdateSportZoneInput = {
  address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  sportObjectId?: InputMaybe<Scalars['String']>;
};

export type UpdateUserSettingsInput = {
  email?: InputMaybe<Scalars['String']>;
  equipmentNotWorkingNotifications?: Scalars['Boolean'];
  equipmentRelocationRequestNotifications?: Scalars['Boolean'];
  equipmentRequestNotifications?: Scalars['Boolean'];
  id?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UserEntity = {
  __typename?: 'UserEntity';
  createdAt: Scalars['String'];
  departments?: Maybe<Array<DepartmentEnum>>;
  enabled: Scalars['Boolean'];
  fio?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isExternal: Scalars['Boolean'];
  /** @deprecated Больше не используется, нужно удалить */
  isForSportObject: Scalars['Boolean'];
  isLoggedIn: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['Date']>;
  lastSeenAt: Scalars['String'];
  login: Scalars['String'];
  password: Scalars['String'];
  permissions?: Maybe<Array<Permission>>;
  sportObjects?: Maybe<Array<SportObjectEntity>>;
  userSettings?: Maybe<UserSettingsEntity>;
  userType: Scalars['String'];
};

export type UserOfSportObjectResponse = {
  __typename?: 'UserOfSportObjectResponse';
  email?: Maybe<Scalars['EmailAddress']>;
  login: Scalars['String'];
  userId: Scalars['UUID'];
};

export type UserSettingsEntity = {
  __typename?: 'UserSettingsEntity';
  createdAt: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  equipmentNotWorkingNotifications: Scalars['String'];
  equipmentRelocationRequestNotifications: Scalars['String'];
  equipmentRequestNotifications: Scalars['String'];
  id: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
};

export type DictionaryValueFragmentFragment = { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string };

export type GetFullDictionaryQueryVariables = Exact<{
  dictionaryType: DictionaryTypesEnum;
}>;


export type GetFullDictionaryQuery = { __typename?: 'Query', dictionaries: Array<{ __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string }> };

export type CreateDictionaryValueMutationVariables = Exact<{
  input: CreateDictionaryValueInput;
}>;


export type CreateDictionaryValueMutation = { __typename?: 'Mutation', createdDictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } };

export type UpdateDictionaryValueMutationVariables = Exact<{
  input: UpdateDictionaryValueInput;
}>;


export type UpdateDictionaryValueMutation = { __typename?: 'Mutation', updatedDictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } };

export type DeleteDictionaryValueMutationVariables = Exact<{
  deleteDictionaryValueId: Scalars['String'];
}>;


export type DeleteDictionaryValueMutation = { __typename?: 'Mutation', isDeleted: boolean };

export type EquipmentRepairRequestAddStatusMutationVariables = Exact<{
  equipmentRepairRequestId: Scalars['UUID'];
  state: EquipmentRepairRequestStateInput;
}>;


export type EquipmentRepairRequestAddStatusMutation = { __typename?: 'Mutation', equipmentRepairRequestAddStatus: { __typename?: 'EquipmentRepairRequestEntity', id: string, updatedAt: any, createdAt: any, sportEquipmentId: string, sportEquipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }, stateHistory: Array<{ __typename?: 'EquipmentRepairRequestStateObject', createdAt: string, status: EquipmentRepairRequestStatusEnum, comment: string }> } };

export type EquipmentRepairRequestCreateMutationVariables = Exact<{
  sportEquipmentId: Scalars['UUID'];
  state: EquipmentRepairRequestStateInput;
}>;


export type EquipmentRepairRequestCreateMutation = { __typename?: 'Mutation', equipmentRepairRequestCreate: { __typename?: 'EquipmentRepairRequestEntity', id: string, updatedAt: any, createdAt: any, sportEquipmentId: string, sportEquipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }, stateHistory: Array<{ __typename?: 'EquipmentRepairRequestStateObject', createdAt: string, status: EquipmentRepairRequestStatusEnum, comment: string }> } };

export type EquipmentRepairRequestsDeleteMutationVariables = Exact<{
  equipmentRepairRequestId: Scalars['UUID'];
}>;


export type EquipmentRepairRequestsDeleteMutation = { __typename?: 'Mutation', equipmentRepairRequestsDelete: { __typename?: 'EquipmentRepairRequestEntity', id: string, updatedAt: any, createdAt: any, sportEquipmentId: string, sportEquipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }, stateHistory: Array<{ __typename?: 'EquipmentRepairRequestStateObject', createdAt: string, status: EquipmentRepairRequestStatusEnum, comment: string }> } };

export type ExportEquipmentRepairRequestsInExcelQueryVariables = Exact<{
  filter: EquipmentRepairRequestFilterInput;
}>;


export type ExportEquipmentRepairRequestsInExcelQuery = { __typename?: 'Query', exportEquipmentReapairRequestsInExcel: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } };

export type EquipmentRepairRequestsQueryVariables = Exact<{
  filter?: InputMaybe<EquipmentRepairRequestFilterInput>;
}>;


export type EquipmentRepairRequestsQuery = { __typename?: 'Query', equipmentRepairRequests: { __typename?: 'EquipmentRepairRequestsResponse', total: number, equipmentRepairRequests: Array<{ __typename?: 'EquipmentRepairRequestEntity', id: string, updatedAt: any, createdAt: any, sportEquipmentId: string, sportEquipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }, stateHistory: Array<{ __typename?: 'EquipmentRepairRequestStateObject', createdAt: string, status: EquipmentRepairRequestStatusEnum, comment: string }> }> } };

export type EquipmentRepairRequestFragment = { __typename?: 'EquipmentRepairRequestEntity', id: string, updatedAt: any, createdAt: any, sportEquipmentId: string, sportEquipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }, stateHistory: Array<{ __typename?: 'EquipmentRepairRequestStateObject', createdAt: string, status: EquipmentRepairRequestStatusEnum, comment: string }> };

export type ExportExternalOrderHistoryQueryVariables = Exact<{
  externalOrderId: Scalars['Float'];
}>;


export type ExportExternalOrderHistoryQuery = { __typename?: 'Query', exportExternalOrderHistory: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } };

export type ExportRentedEquipmentExcelMutationVariables = Exact<{
  input: ExportRentedEquipmentsExcelInput;
}>;


export type ExportRentedEquipmentExcelMutation = { __typename?: 'Mutation', exportRentedEquipmentExcel: { __typename?: 'ExportRentedEquipmentsExcelResponse', isEquipmentsFound: boolean, file?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null } };

export type ExternalOrderRecordFullFragment = { __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } };

export type ExternalOrderMessageFullFragment = { __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } };

export type ExternalOrderFullFragment = { __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, tenantDetails?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null, records: Array<{ __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }>, tenantDetailsFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, notExistingEquipmentRecords: Array<{ __typename?: 'ExternalOrderNotExistingRecordEntity', createdAt: string, dateFrom: string, description?: string | null, equipmentCount: number, id: string, name: string, images?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> };

export type ReplaceExternalOrderEquipmentMutationVariables = Exact<{
  input: ReplaceExternalOrderEquipmentInput;
}>;


export type ReplaceExternalOrderEquipmentMutation = { __typename?: 'Mutation', replaceExternalOrderEquipment: { __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, tenantDetails?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null, records: Array<{ __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }>, tenantDetailsFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, notExistingEquipmentRecords: Array<{ __typename?: 'ExternalOrderNotExistingRecordEntity', createdAt: string, dateFrom: string, description?: string | null, equipmentCount: number, id: string, name: string, images?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> } };

export type AcceptExternalOrderMutationVariables = Exact<{
  input: AcceptExternalOrdersInput;
}>;


export type AcceptExternalOrderMutation = { __typename?: 'Mutation', acceptExternalOrder: { __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, tenantDetails?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null, records: Array<{ __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }>, tenantDetailsFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, notExistingEquipmentRecords: Array<{ __typename?: 'ExternalOrderNotExistingRecordEntity', createdAt: string, dateFrom: string, description?: string | null, equipmentCount: number, id: string, name: string, images?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> } };

export type RemoveExternalOrderEquipmentMutationVariables = Exact<{
  externalOrderRecordId: Scalars['String'];
}>;


export type RemoveExternalOrderEquipmentMutation = { __typename?: 'Mutation', removeExternalOrderEquipment: { __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, tenantDetails?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null, records: Array<{ __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }>, tenantDetailsFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, notExistingEquipmentRecords: Array<{ __typename?: 'ExternalOrderNotExistingRecordEntity', createdAt: string, dateFrom: string, description?: string | null, equipmentCount: number, id: string, name: string, images?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> } };

export type SendMessageMutationVariables = Exact<{
  input: SendMessageInput;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } } };

export type ReplaceExternalOrderNotExistingEquipmentMutationVariables = Exact<{
  input: ReplaceExternalOrderNotExistingEquipmentInput;
}>;


export type ReplaceExternalOrderNotExistingEquipmentMutation = { __typename?: 'Mutation', replaceExternalOrderNotExistingEquipment: { __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, tenantDetails?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null, records: Array<{ __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }>, tenantDetailsFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, notExistingEquipmentRecords: Array<{ __typename?: 'ExternalOrderNotExistingRecordEntity', createdAt: string, dateFrom: string, description?: string | null, equipmentCount: number, id: string, name: string, images?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> } };

export type RemoveExternalOrderNotExistingEquipmentMutationVariables = Exact<{
  notExistingRecordId: Scalars['String'];
}>;


export type RemoveExternalOrderNotExistingEquipmentMutation = { __typename?: 'Mutation', removeExternalOrderNotExistingEquipment: { __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, tenantDetails?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null, records: Array<{ __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }>, tenantDetailsFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, notExistingEquipmentRecords: Array<{ __typename?: 'ExternalOrderNotExistingRecordEntity', createdAt: string, dateFrom: string, description?: string | null, equipmentCount: number, id: string, name: string, images?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> } };

export type ApproveExternalOrderMutationVariables = Exact<{
  externalOrderId: Scalars['Float'];
}>;


export type ApproveExternalOrderMutation = { __typename?: 'Mutation', approveExternalOrder: { __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, tenantDetails?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null, records: Array<{ __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }>, tenantDetailsFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, notExistingEquipmentRecords: Array<{ __typename?: 'ExternalOrderNotExistingRecordEntity', createdAt: string, dateFrom: string, description?: string | null, equipmentCount: number, id: string, name: string, images?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> } };

export type RejectExternalOrderMutationVariables = Exact<{
  externalOrderId: Scalars['Float'];
}>;


export type RejectExternalOrderMutation = { __typename?: 'Mutation', rejectExternalOrder: { __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, tenantDetails?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null, records: Array<{ __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }>, tenantDetailsFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, notExistingEquipmentRecords: Array<{ __typename?: 'ExternalOrderNotExistingRecordEntity', createdAt: string, dateFrom: string, description?: string | null, equipmentCount: number, id: string, name: string, images?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> } };

export type GetOrdersQueryVariables = Exact<{
  input: GetExternalOrdersInput;
}>;


export type GetOrdersQuery = { __typename?: 'Query', getOrders: Array<{ __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, tenantDetails?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null, records: Array<{ __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }>, tenantDetailsFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, notExistingEquipmentRecords: Array<{ __typename?: 'ExternalOrderNotExistingRecordEntity', createdAt: string, dateFrom: string, description?: string | null, equipmentCount: number, id: string, name: string, images?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> }> };

export type GetNotReturnedEquipmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotReturnedEquipmentQuery = { __typename?: 'Query', getNotReturnedEquipment: Array<{ __typename?: 'ExternalOrderRecordEntity', comment?: string | null, id: string, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null }, externalOrder: { __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null } }> };

export type GetOrderByIdQueryVariables = Exact<{
  orderId: Scalars['Float'];
}>;


export type GetOrderByIdQuery = { __typename?: 'Query', getOrderById: { __typename?: 'ExternalOrderEntity', comments?: string | null, createdAt: any, giverName?: string | null, giverPhone?: string | null, id: string, orderNumber: string, receivingName: string, receivingPhone: string, receivingPosition?: string | null, status: string, targetPointAddress: string, vehicleType?: string | null, tenantDetails?: string | null, externalOrderOwner: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null, records: Array<{ __typename?: 'ExternalOrderRecordEntity', id: string, comment?: string | null, equipmentCount?: number | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }>, tenantDetailsFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, notExistingEquipmentRecords: Array<{ __typename?: 'ExternalOrderNotExistingRecordEntity', createdAt: string, dateFrom: string, description?: string | null, equipmentCount: number, id: string, name: string, images?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> } };

export type GetMessagesByOrderIdQueryVariables = Exact<{
  orederId: Scalars['Float'];
}>;


export type GetMessagesByOrderIdQuery = { __typename?: 'Query', getOrderById: { __typename?: 'ExternalOrderEntity', id: string, orderNumber: string, messages?: Array<{ __typename?: 'ExternalOrderMessageEntity', createdAt: string, externalOrderStatus: string, id: string, message: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> | null } };

export type ExportExternalOrderQueryVariables = Exact<{
  externalOrderId: Scalars['Float'];
}>;


export type ExportExternalOrderQuery = { __typename?: 'Query', exportExternalOrder: { __typename?: 'FileStoreEntity', id: string, createdAt: any, name: string, ext: string, description?: string | null, url: string } };

export type SportObjectBasisFragment = { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string };

export type SportZoneBasisFragment = { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string };

export type SportSubZoneBasisFragment = { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string };

export type ImageBasisFragment = { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string };

export type ImageBasisWithoutDatesFragment = { __typename?: 'ImageStoreEntity', id: string, description?: string | null, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null };

export type FileBasisFragment = { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null };

export type SportEquipmentBasisFragment = { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null };

export type EquipmentTypeObjectBasisFragment = { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null };

export type SportKindObjectBasisFragment = { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string };

export type SportEquipmentFullFragment = { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null };

export type SportEquipmentFullForCreateFragment = { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, description?: string | null, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null };

export type SportEquipmentFullForHistoryFragment = { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, weight?: number | null, width?: number | null, height?: number | null, length?: number | null, availableForTransfer: boolean, isInformationComplete: boolean, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, description?: string | null, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, description?: string | null, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null };

export type SportEquipmentsFragment = { __typename?: 'GetSportEquipmentResponse', count: number, allCount: number, inStockCount: number, sportEquipments: Array<{ __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null }> };

export type EquipmentRequestFragment = { __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null };

export type EquipmentRequestBasisFragment = { __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null };

export type GetSportEquipmentHistoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSportEquipmentHistoryQuery = { __typename?: 'Query', getSportEquipmentHistoryByEquipmentId: Array<{ __typename?: 'SportEquipmentHistoryEntity', id: string, createdAt: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, sportEquipmentHistoryJson: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, weight?: number | null, width?: number | null, height?: number | null, length?: number | null, availableForTransfer: boolean, isInformationComplete: boolean, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, description?: string | null, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, description?: string | null, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } }> };

export type GetSportEquipmentHistoryByHistoryIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSportEquipmentHistoryByHistoryIdQuery = { __typename?: 'Query', getSportEquipmentHistoryByHistoryId: { __typename?: 'SportEquipmentHistoryEntity', id: string, createdAt: string, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }, sportEquipmentHistoryJson: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, weight?: number | null, width?: number | null, height?: number | null, length?: number | null, availableForTransfer: boolean, isInformationComplete: boolean, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, description?: string | null, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, description?: string | null, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } } };

export type ExportSportEquipmentsInExcelQueryVariables = Exact<{
  input: GetSportEquipmentInput;
}>;


export type ExportSportEquipmentsInExcelQuery = { __typename?: 'Query', exportSportEquipmentsInExcel: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } };

export type CreateSportObjectMutationVariables = Exact<{
  input: CreateSportObjectInput;
}>;


export type CreateSportObjectMutation = { __typename?: 'Mutation', createSportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string } };

export type UpdateSportObjectMutationVariables = Exact<{
  input: UpdateSportObjectInput;
}>;


export type UpdateSportObjectMutation = { __typename?: 'Mutation', updateSportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string } };

export type UpdateEquipmentRequestsStatusesMutationVariables = Exact<{
  input: UpdateEquipmentRequestsStatusesInput;
}>;


export type UpdateEquipmentRequestsStatusesMutation = { __typename?: 'Mutation', equipmentRequest_updateEquipmentRequestsStatuses: Array<{ __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null }> };

export type DeleteSportObjectMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSportObjectMutation = { __typename?: 'Mutation', deleteSportObject: boolean };

export type GetAllSportObjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSportObjectsQuery = { __typename?: 'Query', getAllSportObjects: Array<{ __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string, createdAt: string, sportZones?: Array<{ __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string }, sportSubZones: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, area?: number | null, eps?: number | null }> }> | null, sportSubZones?: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string } }> | null }> };

export type FullSportObjectFragmentFragment = { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string, createdAt: string, sportZones?: Array<{ __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string }, sportSubZones: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, area?: number | null, eps?: number | null }> }> | null, sportSubZones?: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string } }> | null };

export type GetSportObjectQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSportObjectQuery = { __typename?: 'Query', getSportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string, createdAt: string, sportZones?: Array<{ __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string }, sportSubZones: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, area?: number | null, eps?: number | null }> }> | null, sportSubZones?: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string } }> | null } };

export type CreateSportZoneMutationVariables = Exact<{
  input: CreateSportZoneInput;
}>;


export type CreateSportZoneMutation = { __typename?: 'Mutation', createSportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } };

export type UpdateSportZoneMutationVariables = Exact<{
  input: UpdateSportZoneInput;
}>;


export type UpdateSportZoneMutation = { __typename?: 'Mutation', updateSportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } };

export type DeleteSportZoneMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSportZoneMutation = { __typename?: 'Mutation', deleteSportZone: boolean };

export type SportZoneFullFragment = { __typename?: 'SportZoneEntity', id: string, name: string, address: string, sportSubZones: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string }>, sportEquipments: Array<{ __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> };

export type GetSportZonesByObjectIdQueryVariables = Exact<{
  sportObjectId: Scalars['String'];
}>;


export type GetSportZonesByObjectIdQuery = { __typename?: 'Query', getSportZonesByObjectId: Array<{ __typename?: 'SportZoneEntity', id: string, name: string, address: string, sportSubZones: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string }>, sportEquipments: Array<{ __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> }> };

export type GetSportZoneQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSportZoneQuery = { __typename?: 'Query', getSportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, sportSubZones: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string }>, sportEquipments: Array<{ __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> } };

export type CreateSportSubZoneMutationVariables = Exact<{
  input: CreateSportSubZoneInput;
}>;


export type CreateSportSubZoneMutation = { __typename?: 'Mutation', createSportSubZone: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } };

export type UpdateSportSubZoneMutationVariables = Exact<{
  input: UpdateSportSubZoneInput;
}>;


export type UpdateSportSubZoneMutation = { __typename?: 'Mutation', updateSportSubZone: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } };

export type GetSportZonesByZoneIdQueryVariables = Exact<{
  sportZoneId: Scalars['String'];
}>;


export type GetSportZonesByZoneIdQuery = { __typename?: 'Query', getSportSubZonesByZoneId: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string }> };

export type SportSubZoneFullFragment = { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string }, sportEquipments: Array<{ __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> };

export type GetSportSubZoneQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSportSubZoneQuery = { __typename?: 'Query', getSportSubZone: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string }, sportEquipments: Array<{ __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }> } };

export type DeleteSportSubZoneMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSportSubZoneMutation = { __typename?: 'Mutation', deleteSportSubZone: boolean };

export type CreateSportEquipmentMutationVariables = Exact<{
  input: CreateSportEquipmentInput;
}>;


export type CreateSportEquipmentMutation = { __typename?: 'Mutation', createSportEquipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, description?: string | null, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } };

export type ImportSportEquipmentMutationVariables = Exact<{
  input: ImportSportEquipmentsInput;
}>;


export type ImportSportEquipmentMutation = { __typename?: 'Mutation', importSportEquipment: boolean };

export type SetEditableMutationVariables = Exact<{
  input: SetEditableInput;
}>;


export type SetEditableMutation = { __typename?: 'Mutation', setEditable: boolean };

export type UpdateSportEquipmentMutationVariables = Exact<{
  input: UpdateSportEquipmentInput;
}>;


export type UpdateSportEquipmentMutation = { __typename?: 'Mutation', updateSportEquipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } };

export type DeleteSportEquipmentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSportEquipmentMutation = { __typename?: 'Mutation', deleteSportEquipment: boolean };

export type EquipmentServicePeriodBasisFragment = { __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string };

export type EquipmentServicePeriodFullFragment = { __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string };

export type CreateEquipmentServicePeriodMutationVariables = Exact<{
  input: CreateEquipmentServicePeriodInput;
}>;


export type CreateEquipmentServicePeriodMutation = { __typename?: 'Mutation', createEquipmentServicePeriod: { __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string } };

export type UpdateEquipmentServicePeriodMutationVariables = Exact<{
  input: UpdateEquipmentServicePeriodInput;
}>;


export type UpdateEquipmentServicePeriodMutation = { __typename?: 'Mutation', updateEquipmentServicePeriod: { __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string } };

export type GetEquipmentServicePeriodsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEquipmentServicePeriodsQuery = { __typename?: 'Query', getEquipmentServicePeriods: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> };

export type DeleteEquipmentServicePeriodMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEquipmentServicePeriodMutation = { __typename?: 'Mutation', deleteEquipmentServicePeriod: boolean };

export type EquipmentServiceJobBasisFragment = { __typename?: 'EquipmentServiceJobEntity', id: string, name: string, deadline: string, jobStatus: string, done: boolean, doneDate?: string | null, description?: string | null, createdAt: string, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, equipmentServicePeriod?: { __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string } | null, equipment?: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null };

export type GetEquipmentServiceJobsQueryVariables = Exact<{
  input: GetEquipmentServiceJobsInput;
}>;


export type GetEquipmentServiceJobsQuery = { __typename?: 'Query', getEquipmentServiceJobs: { __typename?: 'GetEquipmentServiceJobsResponse', count?: number | null, equipmentServiceJobs?: Array<{ __typename?: 'EquipmentServiceJobEntity', id: string, name: string, deadline: string, jobStatus: string, done: boolean, doneDate?: string | null, description?: string | null, createdAt: string, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, equipmentServicePeriod?: { __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string } | null, equipment?: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null }> | null } };

export type GetEquipmentServiceJobsBySportObjectQueryVariables = Exact<{
  sportObjectId: Scalars['String'];
}>;


export type GetEquipmentServiceJobsBySportObjectQuery = { __typename?: 'Query', getEquipmentServiceJobsBySportObject: Array<{ __typename?: 'EquipmentServiceJobEntity', id: string, name: string, deadline: string, jobStatus: string, done: boolean, doneDate?: string | null, description?: string | null, createdAt: string, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, equipmentServicePeriod?: { __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string } | null, equipment?: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null }> };

export type GetEquipmentServiceJobsBySportObjectsQueryVariables = Exact<{
  sportObjectIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetEquipmentServiceJobsBySportObjectsQuery = { __typename?: 'Query', getEquipmentServiceJobsBySportObjects: Array<{ __typename?: 'EquipmentServiceJobEntity', id: string, name: string, deadline: string, jobStatus: string, done: boolean, doneDate?: string | null, description?: string | null, createdAt: string, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, equipmentServicePeriod?: { __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string } | null, equipment?: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null }> };

export type GetArchivedEquipmentServiceJobsBySportObjectQueryVariables = Exact<{
  sportObjectId: Scalars['String'];
}>;


export type GetArchivedEquipmentServiceJobsBySportObjectQuery = { __typename?: 'Query', getArchivedEquipmentServiceJobsBySportObject: Array<{ __typename?: 'EquipmentServiceJobEntity', id: string, name: string, deadline: string, jobStatus: string, done: boolean, doneDate?: string | null, description?: string | null, createdAt: string, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, equipmentServicePeriod?: { __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string } | null, equipment?: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null }> };

export type GetArchivedEquipmentServiceJobsBySportObjectsQueryVariables = Exact<{
  sportObjectIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetArchivedEquipmentServiceJobsBySportObjectsQuery = { __typename?: 'Query', getArchivedEquipmentServiceJobsBySportObjects: Array<{ __typename?: 'EquipmentServiceJobEntity', id: string, name: string, deadline: string, jobStatus: string, done: boolean, doneDate?: string | null, description?: string | null, createdAt: string, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, equipmentServicePeriod?: { __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string } | null, equipment?: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null }> };

export type UpdateEquipmentServiceJobMutationVariables = Exact<{
  input: UpdateEquipmentServiceJobInput;
}>;


export type UpdateEquipmentServiceJobMutation = { __typename?: 'Mutation', updateEquipmentServiceJob: { __typename?: 'EquipmentServiceJobEntity', id: string } };

export type DeleteEquipmentServiceJobMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEquipmentServiceJobMutation = { __typename?: 'Mutation', deleteEquipmentServiceJob: boolean };

export type GetAllEquipmentRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEquipmentRequestsQuery = { __typename?: 'Query', getAllEquipmentRequests: Array<{ __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null }> };

export type GetEquipmentRequestsBySportObjectIdQueryVariables = Exact<{
  sportObjectId: Scalars['String'];
}>;


export type GetEquipmentRequestsBySportObjectIdQuery = { __typename?: 'Query', getEquipmentRequestsBySportObjectId: Array<{ __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null }> };

export type GetAllEquipmentRequestsByStatusesQueryVariables = Exact<{
  statuses: Array<EquipmentRequestStatusEnum> | EquipmentRequestStatusEnum;
}>;


export type GetAllEquipmentRequestsByStatusesQuery = { __typename?: 'Query', getAllEquipmentRequestsByStatuses: Array<{ __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null }> };

export type CreateEquipmentRequestMutationVariables = Exact<{
  input: CreateEquipmentRequestInput;
}>;


export type CreateEquipmentRequestMutation = { __typename?: 'Mutation', createEquipmentRequest: { __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null } };

export type UpdateEquipmentRequestMutationVariables = Exact<{
  input: UpdateEquipmentRequestInput;
}>;


export type UpdateEquipmentRequestMutation = { __typename?: 'Mutation', updateEquipmentRequest: { __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null } };

export type DeleteEquipmentRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEquipmentRequestMutation = { __typename?: 'Mutation', deleteEquipmentRequest: boolean };

export type UserFullFragment = { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null };

export type UserBasicFragment = { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null };

export type LoginQueryVariables = Exact<{
  input: LoginUserInput;
}>;


export type LoginQuery = { __typename?: 'Query', login: { __typename?: 'LoginResult', token: string, user: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } } };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }> };

export type GetRelocationRequestsFragment = { __typename?: 'GetRelocationRequestResponse', count: number, allCount: number, relocationRequests: Array<{ __typename?: 'EquipmentRelocationRequestEntity', id: string, name?: string | null, status: string, sportObjectResponseDate?: string | null, acceptByAcceptanceDepartmentComments?: string | null, rejectByAcceptanceDepartmentReason?: string | null, acceptBySportObjectComments?: string | null, acceptedDate?: string | null, acceptedByAcceptanceDepartmentDate?: string | null, rejectedByAcceptanceDepartmentDate: string, acceptComments?: string | null, rejectedDate: string, rejectReason?: string | null, relocationStartedDate?: string | null, relocationStartedComments?: string | null, relocatedDate?: string | null, receivedEquipmentComments?: string | null, createdAt: string, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }, sourceSportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, targetSportObject?: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string } | null, targetSportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null, targetSportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportObjectResponseUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, acceptedUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, acceptedByAcceptanceDepartmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, rejectedByAcceptanceDepartmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, rejectedUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, relocationResponsibleUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, receivedEquipmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, notifiableUsers?: Array<{ __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }> | null }> };

export type EquipmentRelocationRequestBasisFragment = { __typename?: 'EquipmentRelocationRequestEntity', id: string, name?: string | null, status: string, sportObjectResponseDate?: string | null, acceptByAcceptanceDepartmentComments?: string | null, rejectByAcceptanceDepartmentReason?: string | null, acceptBySportObjectComments?: string | null, acceptedDate?: string | null, acceptedByAcceptanceDepartmentDate?: string | null, rejectedByAcceptanceDepartmentDate: string, acceptComments?: string | null, rejectedDate: string, rejectReason?: string | null, relocationStartedDate?: string | null, relocationStartedComments?: string | null, relocatedDate?: string | null, receivedEquipmentComments?: string | null, createdAt: string, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }, sourceSportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, targetSportObject?: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string } | null, targetSportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null, targetSportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportObjectResponseUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, acceptedUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, acceptedByAcceptanceDepartmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, rejectedByAcceptanceDepartmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, rejectedUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, relocationResponsibleUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, receivedEquipmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, notifiableUsers?: Array<{ __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }> | null };

export type GetRelocationRequestsQueryVariables = Exact<{
  input: GetRelocationRequestsInput;
}>;


export type GetRelocationRequestsQuery = { __typename?: 'Query', getRelocationRequests: { __typename?: 'GetRelocationRequestResponse', count: number, allCount: number, relocationRequests: Array<{ __typename?: 'EquipmentRelocationRequestEntity', id: string, name?: string | null, status: string, sportObjectResponseDate?: string | null, acceptByAcceptanceDepartmentComments?: string | null, rejectByAcceptanceDepartmentReason?: string | null, acceptBySportObjectComments?: string | null, acceptedDate?: string | null, acceptedByAcceptanceDepartmentDate?: string | null, rejectedByAcceptanceDepartmentDate: string, acceptComments?: string | null, rejectedDate: string, rejectReason?: string | null, relocationStartedDate?: string | null, relocationStartedComments?: string | null, relocatedDate?: string | null, receivedEquipmentComments?: string | null, createdAt: string, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }, sourceSportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, targetSportObject?: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string } | null, targetSportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null, targetSportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportObjectResponseUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, acceptedUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, acceptedByAcceptanceDepartmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, rejectedByAcceptanceDepartmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, rejectedUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, relocationResponsibleUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, receivedEquipmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, notifiableUsers?: Array<{ __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }> | null }> } };

export type GetEquipmentRelocationRequestByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetEquipmentRelocationRequestByIdsQuery = { __typename?: 'Query', getEquipmentRelocationRequestByIds: Array<{ __typename?: 'EquipmentRelocationRequestEntity', id: string, name?: string | null, status: string, sportObjectResponseDate?: string | null, acceptByAcceptanceDepartmentComments?: string | null, rejectByAcceptanceDepartmentReason?: string | null, acceptBySportObjectComments?: string | null, acceptedDate?: string | null, acceptedByAcceptanceDepartmentDate?: string | null, rejectedByAcceptanceDepartmentDate: string, acceptComments?: string | null, rejectedDate: string, rejectReason?: string | null, relocationStartedDate?: string | null, relocationStartedComments?: string | null, relocatedDate?: string | null, receivedEquipmentComments?: string | null, createdAt: string, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }, sourceSportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, targetSportObject?: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string } | null, targetSportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null, targetSportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportObjectResponseUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, acceptedUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, acceptedByAcceptanceDepartmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, rejectedByAcceptanceDepartmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, rejectedUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, relocationResponsibleUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, receivedEquipmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, notifiableUsers?: Array<{ __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }> | null }> };

export type AcceptRequestMutationVariables = Exact<{
  input: AcceptRequestInput;
}>;


export type AcceptRequestMutation = { __typename?: 'Mutation', acceptRequestByCommercialDepartment: { __typename?: 'EquipmentRelocationRequestEntity', id: string } };

export type AcceptRequestBySportObjectMutationVariables = Exact<{
  input: AcceptRequestBySportObjectInput;
}>;


export type AcceptRequestBySportObjectMutation = { __typename?: 'Mutation', acceptRequestBySportObject: { __typename?: 'EquipmentRelocationRequestEntity', id: string, name?: string | null, status: string, sportObjectResponseDate?: string | null, acceptByAcceptanceDepartmentComments?: string | null, rejectByAcceptanceDepartmentReason?: string | null, acceptBySportObjectComments?: string | null, acceptedDate?: string | null, acceptedByAcceptanceDepartmentDate?: string | null, rejectedByAcceptanceDepartmentDate: string, acceptComments?: string | null, rejectedDate: string, rejectReason?: string | null, relocationStartedDate?: string | null, relocationStartedComments?: string | null, relocatedDate?: string | null, receivedEquipmentComments?: string | null, createdAt: string, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null }, sourceSportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, targetSportObject?: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string } | null, targetSportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null, targetSportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportObjectResponseUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, acceptedUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, acceptedByAcceptanceDepartmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, rejectedByAcceptanceDepartmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, rejectedUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, relocationResponsibleUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, receivedEquipmentUser?: { __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } | null, notifiableUsers?: Array<{ __typename?: 'UserEntity', id: string, login: string, password: string, isLoggedIn: boolean, enabled: boolean, lastLogin?: any | null, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, permissions?: Array<{ __typename?: 'Permission', name: string, value: string }> | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null }> | null } };

export type RejectRequestMutationVariables = Exact<{
  input: RejectRequestInput;
}>;


export type RejectRequestMutation = { __typename?: 'Mutation', rejectRequestByCommercialDepartment: { __typename?: 'EquipmentRelocationRequestEntity', id: string } };

export type AcceptByMaintenanceDepartmentMutationVariables = Exact<{
  input: AcceptByMaintananceDepartmentInput;
}>;


export type AcceptByMaintenanceDepartmentMutation = { __typename?: 'Mutation', acceptByMaintenanceDepartment: { __typename?: 'EquipmentRelocationRequestEntity', id: string } };

export type RejectRequestByAcceptanceDepartmentMutationVariables = Exact<{
  input: RejectRequestByAcceptanceDepartmentInput;
}>;


export type RejectRequestByAcceptanceDepartmentMutation = { __typename?: 'Mutation', rejectRequestByAcceptanceDepartment: { __typename?: 'EquipmentRelocationRequestEntity', id: string } };

export type RelocateEquipmentMutationVariables = Exact<{
  input: RelocateEquipmentInput;
}>;


export type RelocateEquipmentMutation = { __typename?: 'Mutation', relocateEquipment: { __typename?: 'EquipmentRelocationRequestEntity', id: string } };

export type StartEquipmentRelocationMutationVariables = Exact<{
  input: StartEquipmentRelocationInput;
}>;


export type StartEquipmentRelocationMutation = { __typename?: 'Mutation', startEquipmentRelocation: { __typename?: 'EquipmentRelocationRequestEntity', id: string } };

export type GetAllSportKindDictionaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSportKindDictionaryQuery = { __typename?: 'Query', getAllSportKindDictionary: { __typename?: 'GetAllSportKindsResponse', sportCategories: Array<{ __typename?: 'SportCategoryDictionaryEntity', id: string, name: string, createdAt: string }>, sportKinds: Array<{ __typename?: 'SportKindDictionaryEntity', id: string, name: string, createdAt: string, sportCategoryId: string, sportCategory: { __typename?: 'SportCategoryDictionaryEntity', name: string } }>, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, createdAt: string, sportKind: { __typename?: 'SportKindDictionaryEntity', name: string } }>, equipmentSpecifications: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', equipmentTypeId: string }> } };

export type SportCategoryFragment = { __typename?: 'SportCategoryDictionaryEntity', createdAt: string, name: string, id: string, sportKinds: Array<{ __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, createdAt: string }> };

export type GetAllSportCategoryDictionaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSportCategoryDictionaryQuery = { __typename?: 'Query', getAllSportCategoryDictionary: Array<{ __typename?: 'SportCategoryDictionaryEntity', createdAt: string, name: string, id: string, sportKinds: Array<{ __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, createdAt: string }> }> };

export type GetAllDictionariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDictionariesQuery = { __typename?: 'Query', getAllSportKindDictionary: { __typename?: 'GetAllSportKindsResponse', sportCategories: Array<{ __typename?: 'SportCategoryDictionaryEntity', id: string, name: string, createdAt: string, sportKinds: Array<{ __typename?: 'SportKindDictionaryEntity', id: string }> }>, sportKinds: Array<{ __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, createdAt: string, sportCategory: { __typename?: 'SportCategoryDictionaryEntity', name: string } }>, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, createdAt: string, sportKind: { __typename?: 'SportKindDictionaryEntity', name: string } }> } };

export type AddSportCategoryDictionaryMutationVariables = Exact<{
  input: CreateSportCategoryDictionaryInput;
}>;


export type AddSportCategoryDictionaryMutation = { __typename?: 'Mutation', addSportCategoryDictionary: { __typename?: 'SportCategoryDictionaryEntity', createdAt: string, name: string, id: string, sportKinds: Array<{ __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, createdAt: string }> } };

export type UpdateSportCategoryDictionaryMutationVariables = Exact<{
  input: UpdateSportCategoryDictionaryInput;
}>;


export type UpdateSportCategoryDictionaryMutation = { __typename?: 'Mutation', updateSportCategoryDictionary: { __typename?: 'SportCategoryDictionaryEntity', createdAt: string, name: string, id: string, sportKinds: Array<{ __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, createdAt: string }> } };

export type DeleteSportCategoryDictionaryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSportCategoryDictionaryMutation = { __typename?: 'Mutation', deleteSportCategoryDictionary: boolean };

export type AddSportKindDictionaryMutationVariables = Exact<{
  input: CreateSportKindDictionaryInput;
}>;


export type AddSportKindDictionaryMutation = { __typename?: 'Mutation', addSportKindDictionary: { __typename?: 'SportKindDictionaryEntity', id: string } };

export type UpdateSportKindDictionaryMutationVariables = Exact<{
  input: UpdateSportKindDictionaryInput;
}>;


export type UpdateSportKindDictionaryMutation = { __typename?: 'Mutation', updateSportKindDictionary: { __typename?: 'SportKindDictionaryEntity', id: string } };

export type DeleteSportKindDictionaryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSportKindDictionaryMutation = { __typename?: 'Mutation', deleteSportKindDictionary: boolean };

export type GetAllEquipmentTypeDictionaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEquipmentTypeDictionaryQuery = { __typename?: 'Query', getAllEquipmentTypeDictionary: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, createdAt: string, sportKind: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } }> };

export type GetEquipmentTypeDictionaryBySportKindIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEquipmentTypeDictionaryBySportKindIdQuery = { __typename?: 'Query', getEquipmentTypeDictionaryBySportKindId: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, createdAt: string, sportKind: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } }> };

export type AddEquipmentTypeDictionaryMutationVariables = Exact<{
  input: CreateEquipmentTypeDictionaryInput;
}>;


export type AddEquipmentTypeDictionaryMutation = { __typename?: 'Mutation', addEquipmentTypeDictionary: { __typename?: 'EquipmentTypeDictionaryEntity', id: string } };

export type UpdateEquipmentTypeDictionaryMutationVariables = Exact<{
  input: UpdateEquipmentTypeDictionaryInput;
}>;


export type UpdateEquipmentTypeDictionaryMutation = { __typename?: 'Mutation', updateEquipmentTypeDictionary: { __typename?: 'EquipmentTypeDictionaryEntity', id: string } };

export type DeleteEquipmentTypeDictionaryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEquipmentTypeDictionaryMutation = { __typename?: 'Mutation', deleteEquipmentTypeDictionary: boolean };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings: { __typename?: 'UserSettingsEntity', id: string } };

export type GetAllEquipmentSpecificationDictionaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEquipmentSpecificationDictionaryQuery = { __typename?: 'Query', getAllEquipmentSpecificationDictionary: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string, createdAt: string, equipmentType: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string } }> };

export type GetEquipmentSpecificationDictionaryByEquipmentTypeIdQueryVariables = Exact<{
  equipmentTypeId: Scalars['String'];
}>;


export type GetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery = { __typename?: 'Query', getEquipmentSpecificationDictionaryByEquipmentTypeId: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string, createdAt: string, equipmentType: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string } }> };

export type AddEquipmentSpecificationDictionaryMutationVariables = Exact<{
  input: CreateEquipmentSpecificationDictionaryInput;
}>;


export type AddEquipmentSpecificationDictionaryMutation = { __typename?: 'Mutation', addEquipmentSpecificationDictionary: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string } };

export type UpdateEquipmentSpecificationDictionaryMutationVariables = Exact<{
  input: UpdateEquipmentSpecificationDictionaryInput;
}>;


export type UpdateEquipmentSpecificationDictionaryMutation = { __typename?: 'Mutation', updateEquipmentSpecificationDictionary: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string } };

export type DeleteEquipmentSpecificationDictionaryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEquipmentSpecificationDictionaryMutation = { __typename?: 'Mutation', deleteEquipmentSpecificationDictionary: boolean };

export type GetSpecificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpecificationsQuery = { __typename?: 'Query', getSpecifications: Array<{ __typename?: 'SpecificationEntity', id: string, name: string, specificationType: string, specificationListValues?: Array<{ __typename?: 'SpecificationListValuesEntity', id: string, name: string, value: string }> | null, unit?: { __typename?: 'SpecificationUnitEntity', id: string, name: string, shortName: string } | null }> };

export type SetMainPhotoMutationVariables = Exact<{
  input: SetMainPhotoInput;
}>;


export type SetMainPhotoMutation = { __typename?: 'Mutation', setMainPhoto: boolean };

export type ChangeCategoriesMutationVariables = Exact<{
  input: ChangeCategoriesInput;
}>;


export type ChangeCategoriesMutation = { __typename?: 'Mutation', changeCategories: boolean };

export type ChangeSportObjectMutationVariables = Exact<{
  input: ChangeSportObjectInput;
}>;


export type ChangeSportObjectMutation = { __typename?: 'Mutation', changeSportObject: boolean };

export type RecordFragmentFragment = { __typename?: 'ExternalOrderRecordEntity', id: string, equipmentCount?: number | null, comment?: string | null, isReturned: boolean, technicalCondition?: string | null, equipment: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } };

export type GetCoordsByAddressQueryVariables = Exact<{
  address: Scalars['String'];
}>;


export type GetCoordsByAddressQuery = { __typename?: 'Query', getCoordsByAddress: { __typename?: 'GetCoordsByAddressResponse', address: string, longitude: number, latitude: number } };

export type ExportEquipmentRequestsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  order?: InputMaybe<Scalars['SortOrder']>;
}>;


export type ExportEquipmentRequestsMutation = { __typename?: 'Mutation', exportedFile: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } };

export type EquipmentRequestsAcceptForProcessingMutationVariables = Exact<{
  input: EquipmentRequestsAcceptForProcessingInput;
}>;


export type EquipmentRequestsAcceptForProcessingMutation = { __typename?: 'Mutation', equipmentRequestsAcceptForProcessing: Array<{ __typename?: 'EquipmentRequestEntity', id: string }> };

export type DeleteCombinedEquipmentRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCombinedEquipmentRequestMutation = { __typename?: 'Mutation', deleteCombinedEquipmentRequest: boolean };

export type UpdateCombinedEquipmentRequestMutationVariables = Exact<{
  input: UpdateCombinedEquipmentRequestInput;
}>;


export type UpdateCombinedEquipmentRequestMutation = { __typename?: 'Mutation', updateCombinedEquipmentRequest: { __typename?: 'CombinedEquipmentRequestEntity', id: string } };

export type CreateCombinedEquipmentRequestMutationVariables = Exact<{
  input: CombineRequestsInput;
}>;


export type CreateCombinedEquipmentRequestMutation = { __typename?: 'Mutation', createCombinedEquipmentRequest: { __typename?: 'CombinedEquipmentRequestEntity', id: string } };

export type GetEquipmentRequestsQueryVariables = Exact<{
  input: GetEquipmentRequestsInput;
}>;


export type GetEquipmentRequestsQuery = { __typename?: 'Query', getEquipmentRequests: { __typename?: 'GetEquipmentRequestsResponse', count: number, allCount: number, combinedEquipmentRequests?: Array<{ __typename?: 'CombinedEquipmentRequestEntity', createdAt: string, description?: string | null, id: string, name: string, price?: number | null, requestStatus: EquipmentRequestStatusEnum, serviceNoteScanFileId?: string | null, acceptanceCertificateId?: string | null, urgentRequirementComment?: string | null, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null }> | null, serviceNoteScanFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null }> | null, equipmentRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null }> | null } };

export type GetCombinedEquipmentRequestByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCombinedEquipmentRequestByIdQuery = { __typename?: 'Query', getCombinedEquipmentRequestById?: { __typename?: 'CombinedEquipmentRequestEntity', createdAt: string, description?: string | null, id: string, name: string, price?: number | null, requestStatus: EquipmentRequestStatusEnum, serviceNoteScanFileId?: string | null, acceptanceCertificateId?: string | null, urgentRequirementComment?: string | null, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null }> | null, serviceNoteScanFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null } | null };

export type EquipmentRequestCreateHistoryRecordMutationVariables = Exact<{
  input: EquipmentRequestCreateHistoryRecordInput;
}>;


export type EquipmentRequestCreateHistoryRecordMutation = { __typename?: 'Mutation', equipmentRequestCreateHistoryRecord: { __typename?: 'EquipmentRequestHistoryRecordEntity', createdAt: string, id: string } };

export type GetEquipmentRequestHistoryQueryVariables = Exact<{
  input: GetEquipmentRequestHistoryInput;
}>;


export type GetEquipmentRequestHistoryQuery = { __typename?: 'Query', getEquipmentRequestHistory: Array<{ __typename?: 'EquipmentRequestHistoryRecordEntity', createdAt: string, id: string, message?: string | null, requestStatus: EquipmentRequestStatusEnum, combinedEquipmentRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string } | null, equipmentRequest?: { __typename?: 'EquipmentRequestEntity', id: string } | null, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } }> };

export type EquipmentRequestHistoryRecordFragmentBasisFragment = { __typename?: 'EquipmentRequestHistoryRecordEntity', createdAt: string, id: string };

export type EquipmentRequestHistoryRecordFragmentFragment = { __typename?: 'EquipmentRequestHistoryRecordEntity', createdAt: string, id: string, message?: string | null, requestStatus: EquipmentRequestStatusEnum, combinedEquipmentRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string } | null, equipmentRequest?: { __typename?: 'EquipmentRequestEntity', id: string } | null, user: { __typename?: 'UserEntity', id: string, login: string, createdAt: string, lastSeenAt: string, departments?: Array<DepartmentEnum> | null, isForSportObject: boolean, fio?: string | null, sportObjects?: Array<{ __typename?: 'SportObjectEntity', id: string, name: string }> | null, userSettings?: { __typename?: 'UserSettingsEntity', id: string, email?: string | null, phone?: string | null, equipmentRequestNotifications: string, equipmentRelocationRequestNotifications: string, equipmentNotWorkingNotifications: string, createdAt: string } | null } };

export type GetEquipmentRequestsFragment = { __typename?: 'GetEquipmentRequestsResponse', count: number, allCount: number, combinedEquipmentRequests?: Array<{ __typename?: 'CombinedEquipmentRequestEntity', createdAt: string, description?: string | null, id: string, name: string, price?: number | null, requestStatus: EquipmentRequestStatusEnum, serviceNoteScanFileId?: string | null, acceptanceCertificateId?: string | null, urgentRequirementComment?: string | null, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null }> | null, serviceNoteScanFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null }> | null, equipmentRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null }> | null };

export type CombinedEquipmentRequestFragment = { __typename?: 'CombinedEquipmentRequestEntity', createdAt: string, description?: string | null, id: string, name: string, price?: number | null, requestStatus: EquipmentRequestStatusEnum, serviceNoteScanFileId?: string | null, acceptanceCertificateId?: string | null, urgentRequirementComment?: string | null, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, name: string, count: number, requestStatus: EquipmentRequestStatusEnum, equipmentType?: string | null, sportKind?: string | null, acceptanceCertificateId?: string | null, rejectReason?: string | null, description?: string | null, createdAt: string, urgentRequirementComment?: string | null, equipmentLink?: string | null, mandatorySpecifications?: string | null, price?: number | null, analogEquipmentLink?: string | null, visualInspectionReportId?: string | null, waybillId?: string | null, parentCombinedRequestId?: string | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, sportKindId: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string, equipmentTypes: Array<{ __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null }> } | null, serviceNoteScan?: { __typename?: 'FileStoreEntity', id: string, ext: string, name: string, url: string, description?: string | null, createdAt: any } | null, unitOfMeasurement?: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string, tags?: Array<{ __typename?: 'DictionaryTagEntity', id: string, name: string, createdAt: string, dictionary: { __typename?: 'DictionaryEntity', id: string, dictionaryType: DictionaryTypesEnum, name: string, createdAt: string } }> | null } | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string }, sportZone: { __typename?: 'SportZoneEntity', id: string, name: string, address: string }, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string } | null, waybill?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, visualInspectionReport?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, parentCombinedRequest?: { __typename?: 'CombinedEquipmentRequestEntity', id: string, name: string, requestStatus: EquipmentRequestStatusEnum, childRequests?: Array<{ __typename?: 'EquipmentRequestEntity', id: string, requestStatus: EquipmentRequestStatusEnum }> | null } | null }> | null, serviceNoteScanFile?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, acceptanceCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null };

export type SportEquipmentWriteOffCancelMutationVariables = Exact<{
  sportEquipmentId: Scalars['UUID'];
}>;


export type SportEquipmentWriteOffCancelMutation = { __typename?: 'Mutation', sportEquipmentWriteOffCancel: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null } };

export type SportEquipmentWriteOffMutationVariables = Exact<{
  sportEquipmentId: Scalars['UUID'];
  wroteOffCertificateId: Scalars['UUID'];
}>;


export type SportEquipmentWriteOffMutation = { __typename?: 'Mutation', sportEquipmentWriteOff: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, inUse: boolean, transferStatus?: SportEquipmentTransferStatus | null, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, commissioningDate: string, createdAt: string, isEditable: boolean, availableForTransfer: boolean, isInformationComplete: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null } };

export type GetSelectedSportObjectIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelectedSportObjectIdsQuery = { __typename?: 'Query', selectedSportObjectIds?: Array<string | null> | null };

export type SportObjectFullFragment = { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string, createdAt: string, sportZones?: Array<{ __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string }> | null, sportSubZones?: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, eps?: number | null, area?: number | null, createdAt: string }> | null };

export type GetSportObjectsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetSportObjectsByIdsQuery = { __typename?: 'Query', getSportObjects: Array<{ __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string, createdAt: string, sportZones?: Array<{ __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string }> | null, sportSubZones?: Array<{ __typename?: 'SportSubZoneEntity', id: string, name: string, eps?: number | null, area?: number | null, createdAt: string }> | null }> };

export type GetSportEquipmentsQueryVariables = Exact<{
  input: GetSportEquipmentInput;
}>;


export type GetSportEquipmentsQuery = { __typename?: 'Query', getSportEquipments: { __typename?: 'GetSportEquipmentResponse', count: number, allCount: number, inStockCount: number, sportEquipments: Array<{ __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null }> } };

export type GetSportEquipmentByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSportEquipmentByIdQuery = { __typename?: 'Query', getSportEquipmentById: { __typename?: 'SportEquipmentEntity', id: string, name?: string | null, transferStatus?: SportEquipmentTransferStatus | null, accountingName?: string | null, inUse: boolean, isWroteOff: boolean, inventoryNumber?: string | null, technicalCondition: TechnicalCondition, failureReason?: string | null, availableForTransfer: boolean, isInformationComplete: boolean, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, description?: string | null, commissioningDate: string, createdAt: string, isEditable: boolean, wroteOffCertificate?: { __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null } | null, mainPhoto?: { __typename?: 'ImageStoreEntity', id: string, url?: string | null, avatarUrl?: string | null } | null, barcodePhoto?: { __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string } | null, specifications?: Array<{ __typename?: 'SpecificationValueEntity', id: string, valueString?: string | null, sportEquipment?: { __typename?: 'SportEquipmentEntity', id: string } | null }> | null, equipmentServicePeriods?: Array<{ __typename?: 'EquipmentServicePeriodEntity', id: string, name: string, periodType: string, nextDate: string, createdAt: string }> | null, sportCategoryObject?: { __typename?: 'SportCategoryDictionaryEntity', id: string, name: string } | null, equipmentTypeObject?: { __typename?: 'EquipmentTypeDictionaryEntity', id: string, name: string, equipmentSpecifications?: Array<{ __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string }> | null } | null, sportKindObject?: { __typename?: 'SportKindDictionaryEntity', id: string, name: string, sportCategoryId: string } | null, equipmentSpecificationObject?: { __typename?: 'EquipmentSpecificationDictionaryEntity', id: string, name: string } | null, photos?: Array<{ __typename?: 'ImageStoreEntity', id: string, name: string, description?: string | null, ext: string, url?: string | null, downloadUrl?: string | null, avatarUrl?: string | null, width?: number | null, height?: number | null, createdAt: any, updatedAt: string }> | null, commissioningCertificates?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, passport?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, certificate?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, manual?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, guarantee?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, otherDocuments?: Array<{ __typename?: 'FileStoreEntity', id: string, url: string, name: string, ext: string, description?: string | null }> | null, sportObject: { __typename?: 'SportObjectEntity', id: string, name: string, address: string, longitude?: number | null, latitude?: number | null, activeDirectoryGroup: string }, sportZone?: { __typename?: 'SportZoneEntity', id: string, name: string, address: string, createdAt: string } | null, sportSubZone?: { __typename?: 'SportSubZoneEntity', id: string, name: string, number?: number | null, area?: number | null, eps?: number | null, createdAt: string } | null } };

export type GetUsersOfSportObjectQueryVariables = Exact<{
  sportObjectId: Scalars['UUID'];
}>;


export type GetUsersOfSportObjectQuery = { __typename?: 'Query', usersOfSportObject: Array<{ __typename?: 'UserOfSportObjectResponse', email?: string | null, login: string, userId: string }> };

export const DictionaryValueFragmentFragmentDoc = gql`
    fragment DictionaryValueFragment on DictionaryEntity {
  id
  dictionaryType
  name
  createdAt
}
    `;
export const FileBasisFragmentDoc = gql`
    fragment FileBasis on FileStoreEntity {
  id
  url
  name
  ext
  description
}
    `;
export const SportKindObjectBasisFragmentDoc = gql`
    fragment SportKindObjectBasis on SportKindDictionaryEntity {
  id
  name
  sportCategoryId
}
    `;
export const EquipmentTypeObjectBasisFragmentDoc = gql`
    fragment EquipmentTypeObjectBasis on EquipmentTypeDictionaryEntity {
  id
  name
  equipmentSpecifications {
    id
    name
  }
}
    `;
export const ImageBasisFragmentDoc = gql`
    fragment ImageBasis on ImageStoreEntity {
  id
  name
  description
  ext
  url
  downloadUrl
  avatarUrl
  width
  height
  createdAt
  updatedAt
}
    `;
export const SportEquipmentBasisFragmentDoc = gql`
    fragment SportEquipmentBasis on SportEquipmentEntity {
  id
  name
  inUse
  transferStatus
  isWroteOff
  wroteOffCertificate {
    ...FileBasis
  }
  inventoryNumber
  technicalCondition
  sportKindObject {
    ...SportKindObjectBasis
  }
  equipmentTypeObject {
    ...EquipmentTypeObjectBasis
  }
  equipmentSpecificationObject {
    id
    name
  }
  commissioningDate
  photos {
    ...ImageBasis
  }
  createdAt
  isEditable
  availableForTransfer
  isInformationComplete
}
    ${FileBasisFragmentDoc}
${SportKindObjectBasisFragmentDoc}
${EquipmentTypeObjectBasisFragmentDoc}
${ImageBasisFragmentDoc}`;
export const SportObjectBasisFragmentDoc = gql`
    fragment SportObjectBasis on SportObjectEntity {
  id
  name
  address
  longitude
  latitude
  activeDirectoryGroup
}
    `;
export const EquipmentRepairRequestFragmentDoc = gql`
    fragment EquipmentRepairRequest on EquipmentRepairRequestEntity {
  id
  updatedAt
  createdAt
  sportEquipmentId
  sportEquipment {
    ...SportEquipmentBasis
    sportObject {
      ...SportObjectBasis
    }
  }
  stateHistory {
    createdAt
    status
    comment
  }
}
    ${SportEquipmentBasisFragmentDoc}
${SportObjectBasisFragmentDoc}`;
export const UserBasicFragmentDoc = gql`
    fragment UserBasic on UserEntity {
  id
  login
  createdAt
  lastSeenAt
  departments
  sportObjects {
    id
    name
  }
  userSettings {
    id
    email
    phone
    equipmentRequestNotifications
    equipmentRelocationRequestNotifications
    equipmentNotWorkingNotifications
    createdAt
  }
  isForSportObject
  fio
}
    `;
export const ExternalOrderMessageFullFragmentDoc = gql`
    fragment ExternalOrderMessageFull on ExternalOrderMessageEntity {
  createdAt
  externalOrderStatus
  id
  message
  user {
    ...UserBasic
  }
}
    ${UserBasicFragmentDoc}`;
export const EquipmentServicePeriodFullFragmentDoc = gql`
    fragment EquipmentServicePeriodFull on EquipmentServicePeriodEntity {
  id
  name
  periodType
  nextDate
  createdAt
}
    `;
export const SportZoneBasisFragmentDoc = gql`
    fragment SportZoneBasis on SportZoneEntity {
  id
  name
  address
  createdAt
}
    `;
export const SportSubZoneBasisFragmentDoc = gql`
    fragment SportSubZoneBasis on SportSubZoneEntity {
  id
  name
  number
  area
  eps
  createdAt
}
    `;
export const SportEquipmentFullFragmentDoc = gql`
    fragment SportEquipmentFull on SportEquipmentEntity {
  id
  name
  transferStatus
  accountingName
  inUse
  isWroteOff
  wroteOffCertificate {
    ...FileBasis
  }
  inventoryNumber
  technicalCondition
  failureReason
  availableForTransfer
  isInformationComplete
  length
  width
  height
  weight
  description
  mainPhoto {
    id
    url
    avatarUrl
  }
  barcodePhoto {
    ...ImageBasis
  }
  specifications {
    id
    sportEquipment {
      id
    }
    valueString
  }
  equipmentServicePeriods {
    ...EquipmentServicePeriodFull
  }
  sportCategoryObject {
    id
    name
  }
  equipmentTypeObject {
    ...EquipmentTypeObjectBasis
  }
  sportKindObject {
    ...SportKindObjectBasis
  }
  equipmentSpecificationObject {
    id
    name
  }
  photos {
    ...ImageBasis
  }
  commissioningCertificates {
    ...FileBasis
  }
  commissioningDate
  passport {
    ...FileBasis
  }
  certificate {
    ...FileBasis
  }
  manual {
    ...FileBasis
  }
  guarantee {
    ...FileBasis
  }
  otherDocuments {
    ...FileBasis
  }
  sportObject {
    ...SportObjectBasis
  }
  sportZone {
    ...SportZoneBasis
  }
  sportSubZone {
    ...SportSubZoneBasis
  }
  createdAt
  isEditable
}
    ${FileBasisFragmentDoc}
${ImageBasisFragmentDoc}
${EquipmentServicePeriodFullFragmentDoc}
${EquipmentTypeObjectBasisFragmentDoc}
${SportKindObjectBasisFragmentDoc}
${SportObjectBasisFragmentDoc}
${SportZoneBasisFragmentDoc}
${SportSubZoneBasisFragmentDoc}`;
export const ExternalOrderRecordFullFragmentDoc = gql`
    fragment ExternalOrderRecordFull on ExternalOrderRecordEntity {
  id
  comment
  equipment {
    ...SportEquipmentFull
  }
  equipmentCount
  isReturned
  technicalCondition
}
    ${SportEquipmentFullFragmentDoc}`;
export const ExternalOrderFullFragmentDoc = gql`
    fragment ExternalOrderFull on ExternalOrderEntity {
  comments
  createdAt
  externalOrderOwner {
    ...UserBasic
  }
  giverName
  giverPhone
  id
  messages {
    ...ExternalOrderMessageFull
  }
  orderNumber
  receivingName
  receivingPhone
  receivingPosition
  records {
    ...ExternalOrderRecordFull
  }
  status
  targetPointAddress
  vehicleType
  tenantDetails
  tenantDetailsFile {
    ...FileBasis
  }
  notExistingEquipmentRecords {
    createdAt
    dateFrom
    description
    equipmentCount
    id
    images {
      ...ImageBasis
    }
    name
  }
}
    ${UserBasicFragmentDoc}
${ExternalOrderMessageFullFragmentDoc}
${ExternalOrderRecordFullFragmentDoc}
${FileBasisFragmentDoc}
${ImageBasisFragmentDoc}`;
export const ImageBasisWithoutDatesFragmentDoc = gql`
    fragment ImageBasisWithoutDates on ImageStoreEntity {
  id
  description
  url
  downloadUrl
  avatarUrl
  width
  height
}
    `;
export const SportEquipmentFullForCreateFragmentDoc = gql`
    fragment SportEquipmentFullForCreate on SportEquipmentEntity {
  id
  name
  transferStatus
  accountingName
  inUse
  isWroteOff
  wroteOffCertificate {
    ...FileBasis
  }
  inventoryNumber
  technicalCondition
  failureReason
  availableForTransfer
  isInformationComplete
  length
  width
  height
  weight
  description
  mainPhoto {
    id
    url
    avatarUrl
  }
  barcodePhoto {
    ...ImageBasisWithoutDates
  }
  specifications {
    id
    sportEquipment {
      id
    }
    valueString
  }
  equipmentServicePeriods {
    ...EquipmentServicePeriodFull
  }
  sportCategoryObject {
    id
    name
  }
  equipmentTypeObject {
    ...EquipmentTypeObjectBasis
  }
  sportKindObject {
    ...SportKindObjectBasis
  }
  equipmentSpecificationObject {
    id
    name
  }
  photos {
    ...ImageBasis
  }
  commissioningCertificates {
    ...FileBasis
  }
  commissioningDate
  passport {
    ...FileBasis
  }
  certificate {
    ...FileBasis
  }
  manual {
    ...FileBasis
  }
  guarantee {
    ...FileBasis
  }
  otherDocuments {
    ...FileBasis
  }
  sportObject {
    ...SportObjectBasis
  }
  sportZone {
    ...SportZoneBasis
  }
  sportSubZone {
    ...SportSubZoneBasis
  }
  createdAt
  isEditable
}
    ${FileBasisFragmentDoc}
${ImageBasisWithoutDatesFragmentDoc}
${EquipmentServicePeriodFullFragmentDoc}
${EquipmentTypeObjectBasisFragmentDoc}
${SportKindObjectBasisFragmentDoc}
${ImageBasisFragmentDoc}
${SportObjectBasisFragmentDoc}
${SportZoneBasisFragmentDoc}
${SportSubZoneBasisFragmentDoc}`;
export const SportEquipmentFullForHistoryFragmentDoc = gql`
    fragment SportEquipmentFullForHistory on SportEquipmentEntity {
  id
  name
  transferStatus
  accountingName
  inUse
  isWroteOff
  wroteOffCertificate {
    ...FileBasis
  }
  inventoryNumber
  technicalCondition
  failureReason
  weight
  width
  height
  length
  availableForTransfer
  isInformationComplete
  description
  mainPhoto {
    id
    url
    avatarUrl
  }
  barcodePhoto {
    ...ImageBasisWithoutDates
  }
  specifications {
    id
    sportEquipment {
      id
    }
    valueString
  }
  equipmentServicePeriods {
    ...EquipmentServicePeriodFull
  }
  sportCategoryObject {
    id
    name
  }
  equipmentTypeObject {
    ...EquipmentTypeObjectBasis
  }
  sportKindObject {
    ...SportKindObjectBasis
  }
  equipmentSpecificationObject {
    id
    name
  }
  photos {
    ...ImageBasisWithoutDates
  }
  commissioningCertificates {
    ...FileBasis
  }
  commissioningDate
  passport {
    ...FileBasis
  }
  certificate {
    ...FileBasis
  }
  manual {
    ...FileBasis
  }
  guarantee {
    ...FileBasis
  }
  otherDocuments {
    ...FileBasis
  }
  sportObject {
    ...SportObjectBasis
  }
  sportZone {
    ...SportZoneBasis
  }
  sportSubZone {
    ...SportSubZoneBasis
  }
  createdAt
  isEditable
}
    ${FileBasisFragmentDoc}
${ImageBasisWithoutDatesFragmentDoc}
${EquipmentServicePeriodFullFragmentDoc}
${EquipmentTypeObjectBasisFragmentDoc}
${SportKindObjectBasisFragmentDoc}
${SportObjectBasisFragmentDoc}
${SportZoneBasisFragmentDoc}
${SportSubZoneBasisFragmentDoc}`;
export const SportEquipmentsFragmentDoc = gql`
    fragment SportEquipments on GetSportEquipmentResponse {
  count
  allCount
  inStockCount
  sportEquipments {
    ...SportEquipmentFull
  }
}
    ${SportEquipmentFullFragmentDoc}`;
export const EquipmentRequestFragmentDoc = gql`
    fragment EquipmentRequest on EquipmentRequestEntity {
  id
  name
  count
  requestStatus
  equipmentType
  sportKind
  equipmentTypeObject {
    id
    name
    sportKindId
    equipmentSpecifications {
      id
      name
    }
  }
  sportKindObject {
    id
    name
    equipmentTypes {
      id
      name
      equipmentSpecifications {
        id
        name
      }
    }
    sportCategoryId
  }
  rejectReason
  description
  createdAt
  urgentRequirementComment
  serviceNoteScan {
    id
    ext
    name
    url
    description
    createdAt
  }
  equipmentLink
  mandatorySpecifications
  price
  unitOfMeasurement {
    id
    dictionaryType
    name
    tags {
      id
      name
      dictionary {
        id
        dictionaryType
        name
        createdAt
      }
      createdAt
    }
    createdAt
  }
  analogEquipmentLink
  sportObject {
    id
    name
    address
  }
  sportZone {
    id
    name
    address
  }
  sportSubZone {
    id
    name
  }
  visualInspectionReportId
  waybill {
    ...FileBasis
  }
  waybillId
  visualInspectionReport {
    ...FileBasis
  }
}
    ${FileBasisFragmentDoc}`;
export const FullSportObjectFragmentFragmentDoc = gql`
    fragment fullSportObjectFragment on SportObjectEntity {
  id
  name
  address
  longitude
  latitude
  activeDirectoryGroup
  sportZones {
    id
    name
    address
    sportObject {
      id
      name
    }
    sportSubZones {
      id
      name
      area
      eps
    }
    createdAt
  }
  sportSubZones {
    id
    name
    number
    area
    eps
    sportZone {
      id
      name
    }
    createdAt
  }
  createdAt
}
    `;
export const SportZoneFullFragmentDoc = gql`
    fragment SportZoneFull on SportZoneEntity {
  id
  name
  address
  sportSubZones {
    ...SportSubZoneBasis
  }
  sportEquipments {
    ...SportEquipmentBasis
  }
}
    ${SportSubZoneBasisFragmentDoc}
${SportEquipmentBasisFragmentDoc}`;
export const SportSubZoneFullFragmentDoc = gql`
    fragment SportSubZoneFull on SportSubZoneEntity {
  id
  name
  number
  sportObject {
    ...SportObjectBasis
  }
  sportZone {
    ...SportZoneBasis
  }
  sportEquipments {
    ...SportEquipmentBasis
  }
}
    ${SportObjectBasisFragmentDoc}
${SportZoneBasisFragmentDoc}
${SportEquipmentBasisFragmentDoc}`;
export const EquipmentServicePeriodBasisFragmentDoc = gql`
    fragment EquipmentServicePeriodBasis on EquipmentServicePeriodEntity {
  id
  name
  periodType
  nextDate
  createdAt
}
    `;
export const EquipmentServiceJobBasisFragmentDoc = gql`
    fragment EquipmentServiceJobBasis on EquipmentServiceJobEntity {
  id
  name
  deadline
  jobStatus
  done
  doneDate
  description
  photos {
    ...ImageBasis
  }
  equipmentServicePeriod {
    ...EquipmentServicePeriodBasis
  }
  equipment {
    ...SportEquipmentBasis
  }
  sportObject {
    ...SportObjectBasis
  }
  sportZone {
    ...SportZoneBasis
  }
  sportSubZone {
    ...SportSubZoneBasis
  }
  createdAt
}
    ${ImageBasisFragmentDoc}
${EquipmentServicePeriodBasisFragmentDoc}
${SportEquipmentBasisFragmentDoc}
${SportObjectBasisFragmentDoc}
${SportZoneBasisFragmentDoc}
${SportSubZoneBasisFragmentDoc}`;
export const UserFullFragmentDoc = gql`
    fragment UserFull on UserEntity {
  id
  login
  password
  isLoggedIn
  enabled
  lastLogin
  createdAt
  lastSeenAt
  permissions {
    name
    value
  }
  departments
  isForSportObject
  sportObjects {
    id
  }
  userSettings {
    id
    email
    phone
    equipmentRequestNotifications
    equipmentRelocationRequestNotifications
    equipmentNotWorkingNotifications
    createdAt
  }
  fio
}
    `;
export const EquipmentRelocationRequestBasisFragmentDoc = gql`
    fragment EquipmentRelocationRequestBasis on EquipmentRelocationRequestEntity {
  id
  name
  equipment {
    ...SportEquipmentBasis
  }
  status
  sourceSportObject {
    ...SportObjectBasis
  }
  targetSportObject {
    ...SportObjectBasis
  }
  targetSportSubZone {
    ...SportSubZoneBasis
  }
  targetSportZone {
    ...SportZoneBasis
  }
  sportObjectResponseDate
  sportObjectResponseUser {
    ...UserFull
  }
  acceptByAcceptanceDepartmentComments
  rejectByAcceptanceDepartmentReason
  acceptBySportObjectComments
  acceptedDate
  acceptedUser {
    ...UserFull
  }
  acceptedByAcceptanceDepartmentUser {
    ...UserFull
  }
  acceptedByAcceptanceDepartmentDate
  rejectedByAcceptanceDepartmentDate
  rejectedByAcceptanceDepartmentUser {
    ...UserFull
  }
  acceptComments
  rejectedDate
  rejectedUser {
    ...UserFull
  }
  rejectReason
  relocationStartedDate
  relocationResponsibleUser {
    ...UserFull
  }
  relocationStartedComments
  relocatedDate
  receivedEquipmentUser {
    ...UserFull
  }
  receivedEquipmentComments
  notifiableUsers {
    ...UserFull
  }
  createdAt
}
    ${SportEquipmentBasisFragmentDoc}
${SportObjectBasisFragmentDoc}
${SportSubZoneBasisFragmentDoc}
${SportZoneBasisFragmentDoc}
${UserFullFragmentDoc}`;
export const GetRelocationRequestsFragmentDoc = gql`
    fragment GetRelocationRequests on GetRelocationRequestResponse {
  count
  allCount
  relocationRequests {
    ...EquipmentRelocationRequestBasis
  }
}
    ${EquipmentRelocationRequestBasisFragmentDoc}`;
export const SportCategoryFragmentDoc = gql`
    fragment SportCategory on SportCategoryDictionaryEntity {
  createdAt
  name
  id
  sportKinds {
    id
    name
    sportCategoryId
    createdAt
  }
}
    `;
export const RecordFragmentFragmentDoc = gql`
    fragment RecordFragment on ExternalOrderRecordEntity {
  id
  equipmentCount
  comment
  equipmentCount
  isReturned
  technicalCondition
  equipment {
    ...SportEquipmentFull
  }
}
    ${SportEquipmentFullFragmentDoc}`;
export const EquipmentRequestHistoryRecordFragmentBasisFragmentDoc = gql`
    fragment EquipmentRequestHistoryRecordFragmentBasis on EquipmentRequestHistoryRecordEntity {
  createdAt
  id
}
    `;
export const EquipmentRequestHistoryRecordFragmentFragmentDoc = gql`
    fragment EquipmentRequestHistoryRecordFragment on EquipmentRequestHistoryRecordEntity {
  combinedEquipmentRequest {
    id
  }
  createdAt
  equipmentRequest {
    id
  }
  id
  message
  requestStatus
  user {
    ...UserBasic
  }
}
    ${UserBasicFragmentDoc}`;
export const EquipmentRequestBasisFragmentDoc = gql`
    fragment EquipmentRequestBasis on EquipmentRequestEntity {
  id
  name
  count
  requestStatus
  equipmentType
  sportKind
  acceptanceCertificate {
    ...FileBasis
  }
  acceptanceCertificateId
  equipmentTypeObject {
    id
    name
    sportKindId
    equipmentSpecifications {
      id
      name
    }
  }
  sportKindObject {
    id
    name
    equipmentTypes {
      id
      name
      equipmentSpecifications {
        id
        name
      }
    }
    sportCategoryId
  }
  rejectReason
  description
  createdAt
  urgentRequirementComment
  serviceNoteScan {
    id
    ext
    name
    url
    description
    createdAt
  }
  equipmentLink
  mandatorySpecifications
  price
  unitOfMeasurement {
    id
    dictionaryType
    name
    tags {
      id
      name
      dictionary {
        id
        dictionaryType
        name
        createdAt
      }
      createdAt
    }
    createdAt
  }
  analogEquipmentLink
  sportObject {
    id
    name
    address
  }
  sportZone {
    id
    name
    address
  }
  sportSubZone {
    id
    name
  }
  visualInspectionReportId
  waybill {
    ...FileBasis
  }
  waybillId
  visualInspectionReport {
    ...FileBasis
  }
  parentCombinedRequestId
  parentCombinedRequest {
    id
    name
    requestStatus
    childRequests {
      id
      requestStatus
    }
  }
}
    ${FileBasisFragmentDoc}`;
export const CombinedEquipmentRequestFragmentDoc = gql`
    fragment CombinedEquipmentRequest on CombinedEquipmentRequestEntity {
  childRequests {
    ...EquipmentRequestBasis
  }
  createdAt
  description
  id
  name
  price
  requestStatus
  serviceNoteScanFile {
    ...FileBasis
  }
  serviceNoteScanFileId
  acceptanceCertificate {
    ...FileBasis
  }
  acceptanceCertificateId
  urgentRequirementComment
}
    ${EquipmentRequestBasisFragmentDoc}
${FileBasisFragmentDoc}`;
export const GetEquipmentRequestsFragmentDoc = gql`
    fragment GetEquipmentRequests on GetEquipmentRequestsResponse {
  count
  allCount
  combinedEquipmentRequests {
    ...CombinedEquipmentRequest
  }
  equipmentRequests {
    ...EquipmentRequestBasis
  }
}
    ${CombinedEquipmentRequestFragmentDoc}
${EquipmentRequestBasisFragmentDoc}`;
export const SportObjectFullFragmentDoc = gql`
    fragment SportObjectFull on SportObjectEntity {
  id
  name
  address
  longitude
  latitude
  activeDirectoryGroup
  sportZones {
    id
    name
    address
    createdAt
  }
  sportSubZones {
    id
    name
    eps
    area
    createdAt
  }
  createdAt
}
    `;
export const GetFullDictionaryDocument = gql`
    query GetFullDictionary($dictionaryType: DictionaryTypesEnum!) {
  dictionaries: getFullDictionary(dictionaryType: $dictionaryType) {
    ...DictionaryValueFragment
  }
}
    ${DictionaryValueFragmentFragmentDoc}`;

/**
 * __useGetFullDictionaryQuery__
 *
 * To run a query within a React component, call `useGetFullDictionaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullDictionaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullDictionaryQuery({
 *   variables: {
 *      dictionaryType: // value for 'dictionaryType'
 *   },
 * });
 */
export function useGetFullDictionaryQuery(baseOptions: Apollo.QueryHookOptions<GetFullDictionaryQuery, GetFullDictionaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullDictionaryQuery, GetFullDictionaryQueryVariables>(GetFullDictionaryDocument, options);
      }
export function useGetFullDictionaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullDictionaryQuery, GetFullDictionaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullDictionaryQuery, GetFullDictionaryQueryVariables>(GetFullDictionaryDocument, options);
        }
export type GetFullDictionaryQueryHookResult = ReturnType<typeof useGetFullDictionaryQuery>;
export type GetFullDictionaryLazyQueryHookResult = ReturnType<typeof useGetFullDictionaryLazyQuery>;
export type GetFullDictionaryQueryResult = Apollo.QueryResult<GetFullDictionaryQuery, GetFullDictionaryQueryVariables>;
export function refetchGetFullDictionaryQuery(variables: GetFullDictionaryQueryVariables) {
      return { query: GetFullDictionaryDocument, variables: variables }
    }
export const CreateDictionaryValueDocument = gql`
    mutation CreateDictionaryValue($input: CreateDictionaryValueInput!) {
  createdDictionary: createDictionaryValue(input: $input) {
    ...DictionaryValueFragment
  }
}
    ${DictionaryValueFragmentFragmentDoc}`;
export type CreateDictionaryValueMutationFn = Apollo.MutationFunction<CreateDictionaryValueMutation, CreateDictionaryValueMutationVariables>;

/**
 * __useCreateDictionaryValueMutation__
 *
 * To run a mutation, you first call `useCreateDictionaryValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDictionaryValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDictionaryValueMutation, { data, loading, error }] = useCreateDictionaryValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDictionaryValueMutation(baseOptions?: Apollo.MutationHookOptions<CreateDictionaryValueMutation, CreateDictionaryValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDictionaryValueMutation, CreateDictionaryValueMutationVariables>(CreateDictionaryValueDocument, options);
      }
export type CreateDictionaryValueMutationHookResult = ReturnType<typeof useCreateDictionaryValueMutation>;
export type CreateDictionaryValueMutationResult = Apollo.MutationResult<CreateDictionaryValueMutation>;
export type CreateDictionaryValueMutationOptions = Apollo.BaseMutationOptions<CreateDictionaryValueMutation, CreateDictionaryValueMutationVariables>;
export const UpdateDictionaryValueDocument = gql`
    mutation UpdateDictionaryValue($input: UpdateDictionaryValueInput!) {
  updatedDictionary: updateDictionaryValue(input: $input) {
    ...DictionaryValueFragment
  }
}
    ${DictionaryValueFragmentFragmentDoc}`;
export type UpdateDictionaryValueMutationFn = Apollo.MutationFunction<UpdateDictionaryValueMutation, UpdateDictionaryValueMutationVariables>;

/**
 * __useUpdateDictionaryValueMutation__
 *
 * To run a mutation, you first call `useUpdateDictionaryValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDictionaryValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDictionaryValueMutation, { data, loading, error }] = useUpdateDictionaryValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDictionaryValueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDictionaryValueMutation, UpdateDictionaryValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDictionaryValueMutation, UpdateDictionaryValueMutationVariables>(UpdateDictionaryValueDocument, options);
      }
export type UpdateDictionaryValueMutationHookResult = ReturnType<typeof useUpdateDictionaryValueMutation>;
export type UpdateDictionaryValueMutationResult = Apollo.MutationResult<UpdateDictionaryValueMutation>;
export type UpdateDictionaryValueMutationOptions = Apollo.BaseMutationOptions<UpdateDictionaryValueMutation, UpdateDictionaryValueMutationVariables>;
export const DeleteDictionaryValueDocument = gql`
    mutation DeleteDictionaryValue($deleteDictionaryValueId: String!) {
  isDeleted: deleteDictionaryValue(id: $deleteDictionaryValueId)
}
    `;
export type DeleteDictionaryValueMutationFn = Apollo.MutationFunction<DeleteDictionaryValueMutation, DeleteDictionaryValueMutationVariables>;

/**
 * __useDeleteDictionaryValueMutation__
 *
 * To run a mutation, you first call `useDeleteDictionaryValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDictionaryValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDictionaryValueMutation, { data, loading, error }] = useDeleteDictionaryValueMutation({
 *   variables: {
 *      deleteDictionaryValueId: // value for 'deleteDictionaryValueId'
 *   },
 * });
 */
export function useDeleteDictionaryValueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDictionaryValueMutation, DeleteDictionaryValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDictionaryValueMutation, DeleteDictionaryValueMutationVariables>(DeleteDictionaryValueDocument, options);
      }
export type DeleteDictionaryValueMutationHookResult = ReturnType<typeof useDeleteDictionaryValueMutation>;
export type DeleteDictionaryValueMutationResult = Apollo.MutationResult<DeleteDictionaryValueMutation>;
export type DeleteDictionaryValueMutationOptions = Apollo.BaseMutationOptions<DeleteDictionaryValueMutation, DeleteDictionaryValueMutationVariables>;
export const EquipmentRepairRequestAddStatusDocument = gql`
    mutation equipmentRepairRequestAddStatus($equipmentRepairRequestId: UUID!, $state: EquipmentRepairRequestStateInput!) {
  equipmentRepairRequestAddStatus(
    equipmentRepairRequestId: $equipmentRepairRequestId
    state: $state
  ) {
    ...EquipmentRepairRequest
  }
}
    ${EquipmentRepairRequestFragmentDoc}`;
export type EquipmentRepairRequestAddStatusMutationFn = Apollo.MutationFunction<EquipmentRepairRequestAddStatusMutation, EquipmentRepairRequestAddStatusMutationVariables>;

/**
 * __useEquipmentRepairRequestAddStatusMutation__
 *
 * To run a mutation, you first call `useEquipmentRepairRequestAddStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipmentRepairRequestAddStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipmentRepairRequestAddStatusMutation, { data, loading, error }] = useEquipmentRepairRequestAddStatusMutation({
 *   variables: {
 *      equipmentRepairRequestId: // value for 'equipmentRepairRequestId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useEquipmentRepairRequestAddStatusMutation(baseOptions?: Apollo.MutationHookOptions<EquipmentRepairRequestAddStatusMutation, EquipmentRepairRequestAddStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EquipmentRepairRequestAddStatusMutation, EquipmentRepairRequestAddStatusMutationVariables>(EquipmentRepairRequestAddStatusDocument, options);
      }
export type EquipmentRepairRequestAddStatusMutationHookResult = ReturnType<typeof useEquipmentRepairRequestAddStatusMutation>;
export type EquipmentRepairRequestAddStatusMutationResult = Apollo.MutationResult<EquipmentRepairRequestAddStatusMutation>;
export type EquipmentRepairRequestAddStatusMutationOptions = Apollo.BaseMutationOptions<EquipmentRepairRequestAddStatusMutation, EquipmentRepairRequestAddStatusMutationVariables>;
export const EquipmentRepairRequestCreateDocument = gql`
    mutation equipmentRepairRequestCreate($sportEquipmentId: UUID!, $state: EquipmentRepairRequestStateInput!) {
  equipmentRepairRequestCreate(sportEquipmentId: $sportEquipmentId, state: $state) {
    ...EquipmentRepairRequest
  }
}
    ${EquipmentRepairRequestFragmentDoc}`;
export type EquipmentRepairRequestCreateMutationFn = Apollo.MutationFunction<EquipmentRepairRequestCreateMutation, EquipmentRepairRequestCreateMutationVariables>;

/**
 * __useEquipmentRepairRequestCreateMutation__
 *
 * To run a mutation, you first call `useEquipmentRepairRequestCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipmentRepairRequestCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipmentRepairRequestCreateMutation, { data, loading, error }] = useEquipmentRepairRequestCreateMutation({
 *   variables: {
 *      sportEquipmentId: // value for 'sportEquipmentId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useEquipmentRepairRequestCreateMutation(baseOptions?: Apollo.MutationHookOptions<EquipmentRepairRequestCreateMutation, EquipmentRepairRequestCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EquipmentRepairRequestCreateMutation, EquipmentRepairRequestCreateMutationVariables>(EquipmentRepairRequestCreateDocument, options);
      }
export type EquipmentRepairRequestCreateMutationHookResult = ReturnType<typeof useEquipmentRepairRequestCreateMutation>;
export type EquipmentRepairRequestCreateMutationResult = Apollo.MutationResult<EquipmentRepairRequestCreateMutation>;
export type EquipmentRepairRequestCreateMutationOptions = Apollo.BaseMutationOptions<EquipmentRepairRequestCreateMutation, EquipmentRepairRequestCreateMutationVariables>;
export const EquipmentRepairRequestsDeleteDocument = gql`
    mutation equipmentRepairRequestsDelete($equipmentRepairRequestId: UUID!) {
  equipmentRepairRequestsDelete(
    equipmentRepairRequestId: $equipmentRepairRequestId
  ) {
    ...EquipmentRepairRequest
  }
}
    ${EquipmentRepairRequestFragmentDoc}`;
export type EquipmentRepairRequestsDeleteMutationFn = Apollo.MutationFunction<EquipmentRepairRequestsDeleteMutation, EquipmentRepairRequestsDeleteMutationVariables>;

/**
 * __useEquipmentRepairRequestsDeleteMutation__
 *
 * To run a mutation, you first call `useEquipmentRepairRequestsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipmentRepairRequestsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipmentRepairRequestsDeleteMutation, { data, loading, error }] = useEquipmentRepairRequestsDeleteMutation({
 *   variables: {
 *      equipmentRepairRequestId: // value for 'equipmentRepairRequestId'
 *   },
 * });
 */
export function useEquipmentRepairRequestsDeleteMutation(baseOptions?: Apollo.MutationHookOptions<EquipmentRepairRequestsDeleteMutation, EquipmentRepairRequestsDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EquipmentRepairRequestsDeleteMutation, EquipmentRepairRequestsDeleteMutationVariables>(EquipmentRepairRequestsDeleteDocument, options);
      }
export type EquipmentRepairRequestsDeleteMutationHookResult = ReturnType<typeof useEquipmentRepairRequestsDeleteMutation>;
export type EquipmentRepairRequestsDeleteMutationResult = Apollo.MutationResult<EquipmentRepairRequestsDeleteMutation>;
export type EquipmentRepairRequestsDeleteMutationOptions = Apollo.BaseMutationOptions<EquipmentRepairRequestsDeleteMutation, EquipmentRepairRequestsDeleteMutationVariables>;
export const ExportEquipmentRepairRequestsInExcelDocument = gql`
    query exportEquipmentRepairRequestsInExcel($filter: EquipmentRepairRequestFilterInput!) {
  exportEquipmentReapairRequestsInExcel(filter: $filter) {
    ...FileBasis
  }
}
    ${FileBasisFragmentDoc}`;

/**
 * __useExportEquipmentRepairRequestsInExcelQuery__
 *
 * To run a query within a React component, call `useExportEquipmentRepairRequestsInExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportEquipmentRepairRequestsInExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportEquipmentRepairRequestsInExcelQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportEquipmentRepairRequestsInExcelQuery(baseOptions: Apollo.QueryHookOptions<ExportEquipmentRepairRequestsInExcelQuery, ExportEquipmentRepairRequestsInExcelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportEquipmentRepairRequestsInExcelQuery, ExportEquipmentRepairRequestsInExcelQueryVariables>(ExportEquipmentRepairRequestsInExcelDocument, options);
      }
export function useExportEquipmentRepairRequestsInExcelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportEquipmentRepairRequestsInExcelQuery, ExportEquipmentRepairRequestsInExcelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportEquipmentRepairRequestsInExcelQuery, ExportEquipmentRepairRequestsInExcelQueryVariables>(ExportEquipmentRepairRequestsInExcelDocument, options);
        }
export type ExportEquipmentRepairRequestsInExcelQueryHookResult = ReturnType<typeof useExportEquipmentRepairRequestsInExcelQuery>;
export type ExportEquipmentRepairRequestsInExcelLazyQueryHookResult = ReturnType<typeof useExportEquipmentRepairRequestsInExcelLazyQuery>;
export type ExportEquipmentRepairRequestsInExcelQueryResult = Apollo.QueryResult<ExportEquipmentRepairRequestsInExcelQuery, ExportEquipmentRepairRequestsInExcelQueryVariables>;
export function refetchExportEquipmentRepairRequestsInExcelQuery(variables: ExportEquipmentRepairRequestsInExcelQueryVariables) {
      return { query: ExportEquipmentRepairRequestsInExcelDocument, variables: variables }
    }
export const EquipmentRepairRequestsDocument = gql`
    query equipmentRepairRequests($filter: EquipmentRepairRequestFilterInput) {
  equipmentRepairRequests(filter: $filter) {
    equipmentRepairRequests {
      ...EquipmentRepairRequest
    }
    total
  }
}
    ${EquipmentRepairRequestFragmentDoc}`;

/**
 * __useEquipmentRepairRequestsQuery__
 *
 * To run a query within a React component, call `useEquipmentRepairRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipmentRepairRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipmentRepairRequestsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEquipmentRepairRequestsQuery(baseOptions?: Apollo.QueryHookOptions<EquipmentRepairRequestsQuery, EquipmentRepairRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EquipmentRepairRequestsQuery, EquipmentRepairRequestsQueryVariables>(EquipmentRepairRequestsDocument, options);
      }
export function useEquipmentRepairRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EquipmentRepairRequestsQuery, EquipmentRepairRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EquipmentRepairRequestsQuery, EquipmentRepairRequestsQueryVariables>(EquipmentRepairRequestsDocument, options);
        }
export type EquipmentRepairRequestsQueryHookResult = ReturnType<typeof useEquipmentRepairRequestsQuery>;
export type EquipmentRepairRequestsLazyQueryHookResult = ReturnType<typeof useEquipmentRepairRequestsLazyQuery>;
export type EquipmentRepairRequestsQueryResult = Apollo.QueryResult<EquipmentRepairRequestsQuery, EquipmentRepairRequestsQueryVariables>;
export function refetchEquipmentRepairRequestsQuery(variables?: EquipmentRepairRequestsQueryVariables) {
      return { query: EquipmentRepairRequestsDocument, variables: variables }
    }
export const ExportExternalOrderHistoryDocument = gql`
    query exportExternalOrderHistory($externalOrderId: Float!) {
  exportExternalOrderHistory(externalOrderId: $externalOrderId) {
    ...FileBasis
  }
}
    ${FileBasisFragmentDoc}`;

/**
 * __useExportExternalOrderHistoryQuery__
 *
 * To run a query within a React component, call `useExportExternalOrderHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportExternalOrderHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportExternalOrderHistoryQuery({
 *   variables: {
 *      externalOrderId: // value for 'externalOrderId'
 *   },
 * });
 */
export function useExportExternalOrderHistoryQuery(baseOptions: Apollo.QueryHookOptions<ExportExternalOrderHistoryQuery, ExportExternalOrderHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportExternalOrderHistoryQuery, ExportExternalOrderHistoryQueryVariables>(ExportExternalOrderHistoryDocument, options);
      }
export function useExportExternalOrderHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportExternalOrderHistoryQuery, ExportExternalOrderHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportExternalOrderHistoryQuery, ExportExternalOrderHistoryQueryVariables>(ExportExternalOrderHistoryDocument, options);
        }
export type ExportExternalOrderHistoryQueryHookResult = ReturnType<typeof useExportExternalOrderHistoryQuery>;
export type ExportExternalOrderHistoryLazyQueryHookResult = ReturnType<typeof useExportExternalOrderHistoryLazyQuery>;
export type ExportExternalOrderHistoryQueryResult = Apollo.QueryResult<ExportExternalOrderHistoryQuery, ExportExternalOrderHistoryQueryVariables>;
export function refetchExportExternalOrderHistoryQuery(variables: ExportExternalOrderHistoryQueryVariables) {
      return { query: ExportExternalOrderHistoryDocument, variables: variables }
    }
export const ExportRentedEquipmentExcelDocument = gql`
    mutation ExportRentedEquipmentExcel($input: ExportRentedEquipmentsExcelInput!) {
  exportRentedEquipmentExcel(input: $input) {
    isEquipmentsFound
    file {
      ...FileBasis
    }
  }
}
    ${FileBasisFragmentDoc}`;
export type ExportRentedEquipmentExcelMutationFn = Apollo.MutationFunction<ExportRentedEquipmentExcelMutation, ExportRentedEquipmentExcelMutationVariables>;

/**
 * __useExportRentedEquipmentExcelMutation__
 *
 * To run a mutation, you first call `useExportRentedEquipmentExcelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportRentedEquipmentExcelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportRentedEquipmentExcelMutation, { data, loading, error }] = useExportRentedEquipmentExcelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportRentedEquipmentExcelMutation(baseOptions?: Apollo.MutationHookOptions<ExportRentedEquipmentExcelMutation, ExportRentedEquipmentExcelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportRentedEquipmentExcelMutation, ExportRentedEquipmentExcelMutationVariables>(ExportRentedEquipmentExcelDocument, options);
      }
export type ExportRentedEquipmentExcelMutationHookResult = ReturnType<typeof useExportRentedEquipmentExcelMutation>;
export type ExportRentedEquipmentExcelMutationResult = Apollo.MutationResult<ExportRentedEquipmentExcelMutation>;
export type ExportRentedEquipmentExcelMutationOptions = Apollo.BaseMutationOptions<ExportRentedEquipmentExcelMutation, ExportRentedEquipmentExcelMutationVariables>;
export const ReplaceExternalOrderEquipmentDocument = gql`
    mutation replaceExternalOrderEquipment($input: ReplaceExternalOrderEquipmentInput!) {
  replaceExternalOrderEquipment(input: $input) {
    ...ExternalOrderFull
  }
}
    ${ExternalOrderFullFragmentDoc}`;
export type ReplaceExternalOrderEquipmentMutationFn = Apollo.MutationFunction<ReplaceExternalOrderEquipmentMutation, ReplaceExternalOrderEquipmentMutationVariables>;

/**
 * __useReplaceExternalOrderEquipmentMutation__
 *
 * To run a mutation, you first call `useReplaceExternalOrderEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceExternalOrderEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceExternalOrderEquipmentMutation, { data, loading, error }] = useReplaceExternalOrderEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceExternalOrderEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceExternalOrderEquipmentMutation, ReplaceExternalOrderEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceExternalOrderEquipmentMutation, ReplaceExternalOrderEquipmentMutationVariables>(ReplaceExternalOrderEquipmentDocument, options);
      }
export type ReplaceExternalOrderEquipmentMutationHookResult = ReturnType<typeof useReplaceExternalOrderEquipmentMutation>;
export type ReplaceExternalOrderEquipmentMutationResult = Apollo.MutationResult<ReplaceExternalOrderEquipmentMutation>;
export type ReplaceExternalOrderEquipmentMutationOptions = Apollo.BaseMutationOptions<ReplaceExternalOrderEquipmentMutation, ReplaceExternalOrderEquipmentMutationVariables>;
export const AcceptExternalOrderDocument = gql`
    mutation acceptExternalOrder($input: AcceptExternalOrdersInput!) {
  acceptExternalOrder(input: $input) {
    ...ExternalOrderFull
  }
}
    ${ExternalOrderFullFragmentDoc}`;
export type AcceptExternalOrderMutationFn = Apollo.MutationFunction<AcceptExternalOrderMutation, AcceptExternalOrderMutationVariables>;

/**
 * __useAcceptExternalOrderMutation__
 *
 * To run a mutation, you first call `useAcceptExternalOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptExternalOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptExternalOrderMutation, { data, loading, error }] = useAcceptExternalOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptExternalOrderMutation(baseOptions?: Apollo.MutationHookOptions<AcceptExternalOrderMutation, AcceptExternalOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptExternalOrderMutation, AcceptExternalOrderMutationVariables>(AcceptExternalOrderDocument, options);
      }
export type AcceptExternalOrderMutationHookResult = ReturnType<typeof useAcceptExternalOrderMutation>;
export type AcceptExternalOrderMutationResult = Apollo.MutationResult<AcceptExternalOrderMutation>;
export type AcceptExternalOrderMutationOptions = Apollo.BaseMutationOptions<AcceptExternalOrderMutation, AcceptExternalOrderMutationVariables>;
export const RemoveExternalOrderEquipmentDocument = gql`
    mutation removeExternalOrderEquipment($externalOrderRecordId: String!) {
  removeExternalOrderEquipment(externalOrderRecordId: $externalOrderRecordId) {
    ...ExternalOrderFull
  }
}
    ${ExternalOrderFullFragmentDoc}`;
export type RemoveExternalOrderEquipmentMutationFn = Apollo.MutationFunction<RemoveExternalOrderEquipmentMutation, RemoveExternalOrderEquipmentMutationVariables>;

/**
 * __useRemoveExternalOrderEquipmentMutation__
 *
 * To run a mutation, you first call `useRemoveExternalOrderEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalOrderEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExternalOrderEquipmentMutation, { data, loading, error }] = useRemoveExternalOrderEquipmentMutation({
 *   variables: {
 *      externalOrderRecordId: // value for 'externalOrderRecordId'
 *   },
 * });
 */
export function useRemoveExternalOrderEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExternalOrderEquipmentMutation, RemoveExternalOrderEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExternalOrderEquipmentMutation, RemoveExternalOrderEquipmentMutationVariables>(RemoveExternalOrderEquipmentDocument, options);
      }
export type RemoveExternalOrderEquipmentMutationHookResult = ReturnType<typeof useRemoveExternalOrderEquipmentMutation>;
export type RemoveExternalOrderEquipmentMutationResult = Apollo.MutationResult<RemoveExternalOrderEquipmentMutation>;
export type RemoveExternalOrderEquipmentMutationOptions = Apollo.BaseMutationOptions<RemoveExternalOrderEquipmentMutation, RemoveExternalOrderEquipmentMutationVariables>;
export const SendMessageDocument = gql`
    mutation sendMessage($input: SendMessageInput!) {
  sendMessage(input: $input) {
    ...ExternalOrderMessageFull
  }
}
    ${ExternalOrderMessageFullFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const ReplaceExternalOrderNotExistingEquipmentDocument = gql`
    mutation replaceExternalOrderNotExistingEquipment($input: ReplaceExternalOrderNotExistingEquipmentInput!) {
  replaceExternalOrderNotExistingEquipment(input: $input) {
    ...ExternalOrderFull
  }
}
    ${ExternalOrderFullFragmentDoc}`;
export type ReplaceExternalOrderNotExistingEquipmentMutationFn = Apollo.MutationFunction<ReplaceExternalOrderNotExistingEquipmentMutation, ReplaceExternalOrderNotExistingEquipmentMutationVariables>;

/**
 * __useReplaceExternalOrderNotExistingEquipmentMutation__
 *
 * To run a mutation, you first call `useReplaceExternalOrderNotExistingEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceExternalOrderNotExistingEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceExternalOrderNotExistingEquipmentMutation, { data, loading, error }] = useReplaceExternalOrderNotExistingEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceExternalOrderNotExistingEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceExternalOrderNotExistingEquipmentMutation, ReplaceExternalOrderNotExistingEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceExternalOrderNotExistingEquipmentMutation, ReplaceExternalOrderNotExistingEquipmentMutationVariables>(ReplaceExternalOrderNotExistingEquipmentDocument, options);
      }
export type ReplaceExternalOrderNotExistingEquipmentMutationHookResult = ReturnType<typeof useReplaceExternalOrderNotExistingEquipmentMutation>;
export type ReplaceExternalOrderNotExistingEquipmentMutationResult = Apollo.MutationResult<ReplaceExternalOrderNotExistingEquipmentMutation>;
export type ReplaceExternalOrderNotExistingEquipmentMutationOptions = Apollo.BaseMutationOptions<ReplaceExternalOrderNotExistingEquipmentMutation, ReplaceExternalOrderNotExistingEquipmentMutationVariables>;
export const RemoveExternalOrderNotExistingEquipmentDocument = gql`
    mutation removeExternalOrderNotExistingEquipment($notExistingRecordId: String!) {
  removeExternalOrderNotExistingEquipment(
    notExistingRecordId: $notExistingRecordId
  ) {
    ...ExternalOrderFull
  }
}
    ${ExternalOrderFullFragmentDoc}`;
export type RemoveExternalOrderNotExistingEquipmentMutationFn = Apollo.MutationFunction<RemoveExternalOrderNotExistingEquipmentMutation, RemoveExternalOrderNotExistingEquipmentMutationVariables>;

/**
 * __useRemoveExternalOrderNotExistingEquipmentMutation__
 *
 * To run a mutation, you first call `useRemoveExternalOrderNotExistingEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalOrderNotExistingEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExternalOrderNotExistingEquipmentMutation, { data, loading, error }] = useRemoveExternalOrderNotExistingEquipmentMutation({
 *   variables: {
 *      notExistingRecordId: // value for 'notExistingRecordId'
 *   },
 * });
 */
export function useRemoveExternalOrderNotExistingEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExternalOrderNotExistingEquipmentMutation, RemoveExternalOrderNotExistingEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExternalOrderNotExistingEquipmentMutation, RemoveExternalOrderNotExistingEquipmentMutationVariables>(RemoveExternalOrderNotExistingEquipmentDocument, options);
      }
export type RemoveExternalOrderNotExistingEquipmentMutationHookResult = ReturnType<typeof useRemoveExternalOrderNotExistingEquipmentMutation>;
export type RemoveExternalOrderNotExistingEquipmentMutationResult = Apollo.MutationResult<RemoveExternalOrderNotExistingEquipmentMutation>;
export type RemoveExternalOrderNotExistingEquipmentMutationOptions = Apollo.BaseMutationOptions<RemoveExternalOrderNotExistingEquipmentMutation, RemoveExternalOrderNotExistingEquipmentMutationVariables>;
export const ApproveExternalOrderDocument = gql`
    mutation approveExternalOrder($externalOrderId: Float!) {
  approveExternalOrder(externalOrderId: $externalOrderId) {
    ...ExternalOrderFull
  }
}
    ${ExternalOrderFullFragmentDoc}`;
export type ApproveExternalOrderMutationFn = Apollo.MutationFunction<ApproveExternalOrderMutation, ApproveExternalOrderMutationVariables>;

/**
 * __useApproveExternalOrderMutation__
 *
 * To run a mutation, you first call `useApproveExternalOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveExternalOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveExternalOrderMutation, { data, loading, error }] = useApproveExternalOrderMutation({
 *   variables: {
 *      externalOrderId: // value for 'externalOrderId'
 *   },
 * });
 */
export function useApproveExternalOrderMutation(baseOptions?: Apollo.MutationHookOptions<ApproveExternalOrderMutation, ApproveExternalOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveExternalOrderMutation, ApproveExternalOrderMutationVariables>(ApproveExternalOrderDocument, options);
      }
export type ApproveExternalOrderMutationHookResult = ReturnType<typeof useApproveExternalOrderMutation>;
export type ApproveExternalOrderMutationResult = Apollo.MutationResult<ApproveExternalOrderMutation>;
export type ApproveExternalOrderMutationOptions = Apollo.BaseMutationOptions<ApproveExternalOrderMutation, ApproveExternalOrderMutationVariables>;
export const RejectExternalOrderDocument = gql`
    mutation rejectExternalOrder($externalOrderId: Float!) {
  rejectExternalOrder(externalOrderId: $externalOrderId) {
    ...ExternalOrderFull
  }
}
    ${ExternalOrderFullFragmentDoc}`;
export type RejectExternalOrderMutationFn = Apollo.MutationFunction<RejectExternalOrderMutation, RejectExternalOrderMutationVariables>;

/**
 * __useRejectExternalOrderMutation__
 *
 * To run a mutation, you first call `useRejectExternalOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectExternalOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectExternalOrderMutation, { data, loading, error }] = useRejectExternalOrderMutation({
 *   variables: {
 *      externalOrderId: // value for 'externalOrderId'
 *   },
 * });
 */
export function useRejectExternalOrderMutation(baseOptions?: Apollo.MutationHookOptions<RejectExternalOrderMutation, RejectExternalOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectExternalOrderMutation, RejectExternalOrderMutationVariables>(RejectExternalOrderDocument, options);
      }
export type RejectExternalOrderMutationHookResult = ReturnType<typeof useRejectExternalOrderMutation>;
export type RejectExternalOrderMutationResult = Apollo.MutationResult<RejectExternalOrderMutation>;
export type RejectExternalOrderMutationOptions = Apollo.BaseMutationOptions<RejectExternalOrderMutation, RejectExternalOrderMutationVariables>;
export const GetOrdersDocument = gql`
    query getOrders($input: GetExternalOrdersInput!) {
  getOrders(input: $input) {
    ...ExternalOrderFull
  }
}
    ${ExternalOrderFullFragmentDoc}`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export function refetchGetOrdersQuery(variables: GetOrdersQueryVariables) {
      return { query: GetOrdersDocument, variables: variables }
    }
export const GetNotReturnedEquipmentDocument = gql`
    query getNotReturnedEquipment {
  getNotReturnedEquipment {
    equipment {
      ...SportEquipmentFull
    }
    comment
    id
    technicalCondition
    externalOrder {
      comments
      createdAt
      externalOrderOwner {
        ...UserBasic
      }
      giverName
      giverPhone
      id
      messages {
        ...ExternalOrderMessageFull
      }
      orderNumber
      receivingName
      receivingPhone
      receivingPosition
      status
      targetPointAddress
      vehicleType
    }
  }
}
    ${SportEquipmentFullFragmentDoc}
${UserBasicFragmentDoc}
${ExternalOrderMessageFullFragmentDoc}`;

/**
 * __useGetNotReturnedEquipmentQuery__
 *
 * To run a query within a React component, call `useGetNotReturnedEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotReturnedEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotReturnedEquipmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotReturnedEquipmentQuery(baseOptions?: Apollo.QueryHookOptions<GetNotReturnedEquipmentQuery, GetNotReturnedEquipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotReturnedEquipmentQuery, GetNotReturnedEquipmentQueryVariables>(GetNotReturnedEquipmentDocument, options);
      }
export function useGetNotReturnedEquipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotReturnedEquipmentQuery, GetNotReturnedEquipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotReturnedEquipmentQuery, GetNotReturnedEquipmentQueryVariables>(GetNotReturnedEquipmentDocument, options);
        }
export type GetNotReturnedEquipmentQueryHookResult = ReturnType<typeof useGetNotReturnedEquipmentQuery>;
export type GetNotReturnedEquipmentLazyQueryHookResult = ReturnType<typeof useGetNotReturnedEquipmentLazyQuery>;
export type GetNotReturnedEquipmentQueryResult = Apollo.QueryResult<GetNotReturnedEquipmentQuery, GetNotReturnedEquipmentQueryVariables>;
export function refetchGetNotReturnedEquipmentQuery(variables?: GetNotReturnedEquipmentQueryVariables) {
      return { query: GetNotReturnedEquipmentDocument, variables: variables }
    }
export const GetOrderByIdDocument = gql`
    query getOrderById($orderId: Float!) {
  getOrderById(orderId: $orderId) {
    ...ExternalOrderFull
  }
}
    ${ExternalOrderFullFragmentDoc}`;

/**
 * __useGetOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderByIdQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrderByIdQuery, GetOrderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderByIdQuery, GetOrderByIdQueryVariables>(GetOrderByIdDocument, options);
      }
export function useGetOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderByIdQuery, GetOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderByIdQuery, GetOrderByIdQueryVariables>(GetOrderByIdDocument, options);
        }
export type GetOrderByIdQueryHookResult = ReturnType<typeof useGetOrderByIdQuery>;
export type GetOrderByIdLazyQueryHookResult = ReturnType<typeof useGetOrderByIdLazyQuery>;
export type GetOrderByIdQueryResult = Apollo.QueryResult<GetOrderByIdQuery, GetOrderByIdQueryVariables>;
export function refetchGetOrderByIdQuery(variables: GetOrderByIdQueryVariables) {
      return { query: GetOrderByIdDocument, variables: variables }
    }
export const GetMessagesByOrderIdDocument = gql`
    query getMessagesByOrderId($orederId: Float!) {
  getOrderById(orderId: $orederId) {
    id
    orderNumber
    messages {
      ...ExternalOrderMessageFull
    }
  }
}
    ${ExternalOrderMessageFullFragmentDoc}`;

/**
 * __useGetMessagesByOrderIdQuery__
 *
 * To run a query within a React component, call `useGetMessagesByOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesByOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesByOrderIdQuery({
 *   variables: {
 *      orederId: // value for 'orederId'
 *   },
 * });
 */
export function useGetMessagesByOrderIdQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesByOrderIdQuery, GetMessagesByOrderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesByOrderIdQuery, GetMessagesByOrderIdQueryVariables>(GetMessagesByOrderIdDocument, options);
      }
export function useGetMessagesByOrderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesByOrderIdQuery, GetMessagesByOrderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesByOrderIdQuery, GetMessagesByOrderIdQueryVariables>(GetMessagesByOrderIdDocument, options);
        }
export type GetMessagesByOrderIdQueryHookResult = ReturnType<typeof useGetMessagesByOrderIdQuery>;
export type GetMessagesByOrderIdLazyQueryHookResult = ReturnType<typeof useGetMessagesByOrderIdLazyQuery>;
export type GetMessagesByOrderIdQueryResult = Apollo.QueryResult<GetMessagesByOrderIdQuery, GetMessagesByOrderIdQueryVariables>;
export function refetchGetMessagesByOrderIdQuery(variables: GetMessagesByOrderIdQueryVariables) {
      return { query: GetMessagesByOrderIdDocument, variables: variables }
    }
export const ExportExternalOrderDocument = gql`
    query exportExternalOrder($externalOrderId: Float!) {
  exportExternalOrder(externalOrderId: $externalOrderId) {
    id
    createdAt
    name
    ext
    description
    url
  }
}
    `;

/**
 * __useExportExternalOrderQuery__
 *
 * To run a query within a React component, call `useExportExternalOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportExternalOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportExternalOrderQuery({
 *   variables: {
 *      externalOrderId: // value for 'externalOrderId'
 *   },
 * });
 */
export function useExportExternalOrderQuery(baseOptions: Apollo.QueryHookOptions<ExportExternalOrderQuery, ExportExternalOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportExternalOrderQuery, ExportExternalOrderQueryVariables>(ExportExternalOrderDocument, options);
      }
export function useExportExternalOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportExternalOrderQuery, ExportExternalOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportExternalOrderQuery, ExportExternalOrderQueryVariables>(ExportExternalOrderDocument, options);
        }
export type ExportExternalOrderQueryHookResult = ReturnType<typeof useExportExternalOrderQuery>;
export type ExportExternalOrderLazyQueryHookResult = ReturnType<typeof useExportExternalOrderLazyQuery>;
export type ExportExternalOrderQueryResult = Apollo.QueryResult<ExportExternalOrderQuery, ExportExternalOrderQueryVariables>;
export function refetchExportExternalOrderQuery(variables: ExportExternalOrderQueryVariables) {
      return { query: ExportExternalOrderDocument, variables: variables }
    }
export const GetSportEquipmentHistoryDocument = gql`
    query getSportEquipmentHistory($id: String!) {
  getSportEquipmentHistoryByEquipmentId(id: $id) {
    ... on SportEquipmentHistoryEntity {
      id
      createdAt
      user {
        ...UserBasic
      }
      sportEquipmentHistoryJson {
        ...SportEquipmentFullForHistory
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${SportEquipmentFullForHistoryFragmentDoc}`;

/**
 * __useGetSportEquipmentHistoryQuery__
 *
 * To run a query within a React component, call `useGetSportEquipmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportEquipmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportEquipmentHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSportEquipmentHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetSportEquipmentHistoryQuery, GetSportEquipmentHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportEquipmentHistoryQuery, GetSportEquipmentHistoryQueryVariables>(GetSportEquipmentHistoryDocument, options);
      }
export function useGetSportEquipmentHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportEquipmentHistoryQuery, GetSportEquipmentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportEquipmentHistoryQuery, GetSportEquipmentHistoryQueryVariables>(GetSportEquipmentHistoryDocument, options);
        }
export type GetSportEquipmentHistoryQueryHookResult = ReturnType<typeof useGetSportEquipmentHistoryQuery>;
export type GetSportEquipmentHistoryLazyQueryHookResult = ReturnType<typeof useGetSportEquipmentHistoryLazyQuery>;
export type GetSportEquipmentHistoryQueryResult = Apollo.QueryResult<GetSportEquipmentHistoryQuery, GetSportEquipmentHistoryQueryVariables>;
export function refetchGetSportEquipmentHistoryQuery(variables: GetSportEquipmentHistoryQueryVariables) {
      return { query: GetSportEquipmentHistoryDocument, variables: variables }
    }
export const GetSportEquipmentHistoryByHistoryIdDocument = gql`
    query getSportEquipmentHistoryByHistoryId($id: String!) {
  getSportEquipmentHistoryByHistoryId(id: $id) {
    ... on SportEquipmentHistoryEntity {
      id
      createdAt
      user {
        ...UserBasic
      }
      sportEquipmentHistoryJson {
        ...SportEquipmentFullForHistory
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${SportEquipmentFullForHistoryFragmentDoc}`;

/**
 * __useGetSportEquipmentHistoryByHistoryIdQuery__
 *
 * To run a query within a React component, call `useGetSportEquipmentHistoryByHistoryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportEquipmentHistoryByHistoryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportEquipmentHistoryByHistoryIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSportEquipmentHistoryByHistoryIdQuery(baseOptions: Apollo.QueryHookOptions<GetSportEquipmentHistoryByHistoryIdQuery, GetSportEquipmentHistoryByHistoryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportEquipmentHistoryByHistoryIdQuery, GetSportEquipmentHistoryByHistoryIdQueryVariables>(GetSportEquipmentHistoryByHistoryIdDocument, options);
      }
export function useGetSportEquipmentHistoryByHistoryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportEquipmentHistoryByHistoryIdQuery, GetSportEquipmentHistoryByHistoryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportEquipmentHistoryByHistoryIdQuery, GetSportEquipmentHistoryByHistoryIdQueryVariables>(GetSportEquipmentHistoryByHistoryIdDocument, options);
        }
export type GetSportEquipmentHistoryByHistoryIdQueryHookResult = ReturnType<typeof useGetSportEquipmentHistoryByHistoryIdQuery>;
export type GetSportEquipmentHistoryByHistoryIdLazyQueryHookResult = ReturnType<typeof useGetSportEquipmentHistoryByHistoryIdLazyQuery>;
export type GetSportEquipmentHistoryByHistoryIdQueryResult = Apollo.QueryResult<GetSportEquipmentHistoryByHistoryIdQuery, GetSportEquipmentHistoryByHistoryIdQueryVariables>;
export function refetchGetSportEquipmentHistoryByHistoryIdQuery(variables: GetSportEquipmentHistoryByHistoryIdQueryVariables) {
      return { query: GetSportEquipmentHistoryByHistoryIdDocument, variables: variables }
    }
export const ExportSportEquipmentsInExcelDocument = gql`
    query exportSportEquipmentsInExcel($input: GetSportEquipmentInput!) {
  exportSportEquipmentsInExcel(input: $input) {
    ...FileBasis
  }
}
    ${FileBasisFragmentDoc}`;

/**
 * __useExportSportEquipmentsInExcelQuery__
 *
 * To run a query within a React component, call `useExportSportEquipmentsInExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSportEquipmentsInExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSportEquipmentsInExcelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportSportEquipmentsInExcelQuery(baseOptions: Apollo.QueryHookOptions<ExportSportEquipmentsInExcelQuery, ExportSportEquipmentsInExcelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSportEquipmentsInExcelQuery, ExportSportEquipmentsInExcelQueryVariables>(ExportSportEquipmentsInExcelDocument, options);
      }
export function useExportSportEquipmentsInExcelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSportEquipmentsInExcelQuery, ExportSportEquipmentsInExcelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSportEquipmentsInExcelQuery, ExportSportEquipmentsInExcelQueryVariables>(ExportSportEquipmentsInExcelDocument, options);
        }
export type ExportSportEquipmentsInExcelQueryHookResult = ReturnType<typeof useExportSportEquipmentsInExcelQuery>;
export type ExportSportEquipmentsInExcelLazyQueryHookResult = ReturnType<typeof useExportSportEquipmentsInExcelLazyQuery>;
export type ExportSportEquipmentsInExcelQueryResult = Apollo.QueryResult<ExportSportEquipmentsInExcelQuery, ExportSportEquipmentsInExcelQueryVariables>;
export function refetchExportSportEquipmentsInExcelQuery(variables: ExportSportEquipmentsInExcelQueryVariables) {
      return { query: ExportSportEquipmentsInExcelDocument, variables: variables }
    }
export const CreateSportObjectDocument = gql`
    mutation createSportObject($input: CreateSportObjectInput!) {
  createSportObject(createSportObjectInput: $input) {
    ...SportObjectBasis
  }
}
    ${SportObjectBasisFragmentDoc}`;
export type CreateSportObjectMutationFn = Apollo.MutationFunction<CreateSportObjectMutation, CreateSportObjectMutationVariables>;

/**
 * __useCreateSportObjectMutation__
 *
 * To run a mutation, you first call `useCreateSportObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSportObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSportObjectMutation, { data, loading, error }] = useCreateSportObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSportObjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateSportObjectMutation, CreateSportObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSportObjectMutation, CreateSportObjectMutationVariables>(CreateSportObjectDocument, options);
      }
export type CreateSportObjectMutationHookResult = ReturnType<typeof useCreateSportObjectMutation>;
export type CreateSportObjectMutationResult = Apollo.MutationResult<CreateSportObjectMutation>;
export type CreateSportObjectMutationOptions = Apollo.BaseMutationOptions<CreateSportObjectMutation, CreateSportObjectMutationVariables>;
export const UpdateSportObjectDocument = gql`
    mutation updateSportObject($input: UpdateSportObjectInput!) {
  updateSportObject(updateSportObjectInput: $input) {
    ...SportObjectBasis
  }
}
    ${SportObjectBasisFragmentDoc}`;
export type UpdateSportObjectMutationFn = Apollo.MutationFunction<UpdateSportObjectMutation, UpdateSportObjectMutationVariables>;

/**
 * __useUpdateSportObjectMutation__
 *
 * To run a mutation, you first call `useUpdateSportObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSportObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSportObjectMutation, { data, loading, error }] = useUpdateSportObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSportObjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSportObjectMutation, UpdateSportObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSportObjectMutation, UpdateSportObjectMutationVariables>(UpdateSportObjectDocument, options);
      }
export type UpdateSportObjectMutationHookResult = ReturnType<typeof useUpdateSportObjectMutation>;
export type UpdateSportObjectMutationResult = Apollo.MutationResult<UpdateSportObjectMutation>;
export type UpdateSportObjectMutationOptions = Apollo.BaseMutationOptions<UpdateSportObjectMutation, UpdateSportObjectMutationVariables>;
export const UpdateEquipmentRequestsStatusesDocument = gql`
    mutation updateEquipmentRequestsStatuses($input: UpdateEquipmentRequestsStatusesInput!) {
  equipmentRequest_updateEquipmentRequestsStatuses(input: $input) {
    ...EquipmentRequestBasis
  }
}
    ${EquipmentRequestBasisFragmentDoc}`;
export type UpdateEquipmentRequestsStatusesMutationFn = Apollo.MutationFunction<UpdateEquipmentRequestsStatusesMutation, UpdateEquipmentRequestsStatusesMutationVariables>;

/**
 * __useUpdateEquipmentRequestsStatusesMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentRequestsStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentRequestsStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentRequestsStatusesMutation, { data, loading, error }] = useUpdateEquipmentRequestsStatusesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEquipmentRequestsStatusesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentRequestsStatusesMutation, UpdateEquipmentRequestsStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentRequestsStatusesMutation, UpdateEquipmentRequestsStatusesMutationVariables>(UpdateEquipmentRequestsStatusesDocument, options);
      }
export type UpdateEquipmentRequestsStatusesMutationHookResult = ReturnType<typeof useUpdateEquipmentRequestsStatusesMutation>;
export type UpdateEquipmentRequestsStatusesMutationResult = Apollo.MutationResult<UpdateEquipmentRequestsStatusesMutation>;
export type UpdateEquipmentRequestsStatusesMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentRequestsStatusesMutation, UpdateEquipmentRequestsStatusesMutationVariables>;
export const DeleteSportObjectDocument = gql`
    mutation deleteSportObject($id: String!) {
  deleteSportObject(id: $id)
}
    `;
export type DeleteSportObjectMutationFn = Apollo.MutationFunction<DeleteSportObjectMutation, DeleteSportObjectMutationVariables>;

/**
 * __useDeleteSportObjectMutation__
 *
 * To run a mutation, you first call `useDeleteSportObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSportObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSportObjectMutation, { data, loading, error }] = useDeleteSportObjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSportObjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSportObjectMutation, DeleteSportObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSportObjectMutation, DeleteSportObjectMutationVariables>(DeleteSportObjectDocument, options);
      }
export type DeleteSportObjectMutationHookResult = ReturnType<typeof useDeleteSportObjectMutation>;
export type DeleteSportObjectMutationResult = Apollo.MutationResult<DeleteSportObjectMutation>;
export type DeleteSportObjectMutationOptions = Apollo.BaseMutationOptions<DeleteSportObjectMutation, DeleteSportObjectMutationVariables>;
export const GetAllSportObjectsDocument = gql`
    query getAllSportObjects {
  getAllSportObjects {
    ...fullSportObjectFragment
  }
}
    ${FullSportObjectFragmentFragmentDoc}`;

/**
 * __useGetAllSportObjectsQuery__
 *
 * To run a query within a React component, call `useGetAllSportObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSportObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSportObjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSportObjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSportObjectsQuery, GetAllSportObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSportObjectsQuery, GetAllSportObjectsQueryVariables>(GetAllSportObjectsDocument, options);
      }
export function useGetAllSportObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSportObjectsQuery, GetAllSportObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSportObjectsQuery, GetAllSportObjectsQueryVariables>(GetAllSportObjectsDocument, options);
        }
export type GetAllSportObjectsQueryHookResult = ReturnType<typeof useGetAllSportObjectsQuery>;
export type GetAllSportObjectsLazyQueryHookResult = ReturnType<typeof useGetAllSportObjectsLazyQuery>;
export type GetAllSportObjectsQueryResult = Apollo.QueryResult<GetAllSportObjectsQuery, GetAllSportObjectsQueryVariables>;
export function refetchGetAllSportObjectsQuery(variables?: GetAllSportObjectsQueryVariables) {
      return { query: GetAllSportObjectsDocument, variables: variables }
    }
export const GetSportObjectDocument = gql`
    query getSportObject($id: String!) {
  getSportObject(id: $id) {
    ...fullSportObjectFragment
  }
}
    ${FullSportObjectFragmentFragmentDoc}`;

/**
 * __useGetSportObjectQuery__
 *
 * To run a query within a React component, call `useGetSportObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportObjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSportObjectQuery(baseOptions: Apollo.QueryHookOptions<GetSportObjectQuery, GetSportObjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportObjectQuery, GetSportObjectQueryVariables>(GetSportObjectDocument, options);
      }
export function useGetSportObjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportObjectQuery, GetSportObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportObjectQuery, GetSportObjectQueryVariables>(GetSportObjectDocument, options);
        }
export type GetSportObjectQueryHookResult = ReturnType<typeof useGetSportObjectQuery>;
export type GetSportObjectLazyQueryHookResult = ReturnType<typeof useGetSportObjectLazyQuery>;
export type GetSportObjectQueryResult = Apollo.QueryResult<GetSportObjectQuery, GetSportObjectQueryVariables>;
export function refetchGetSportObjectQuery(variables: GetSportObjectQueryVariables) {
      return { query: GetSportObjectDocument, variables: variables }
    }
export const CreateSportZoneDocument = gql`
    mutation createSportZone($input: CreateSportZoneInput!) {
  createSportZone(createSportZoneInput: $input) {
    ...SportZoneBasis
  }
}
    ${SportZoneBasisFragmentDoc}`;
export type CreateSportZoneMutationFn = Apollo.MutationFunction<CreateSportZoneMutation, CreateSportZoneMutationVariables>;

/**
 * __useCreateSportZoneMutation__
 *
 * To run a mutation, you first call `useCreateSportZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSportZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSportZoneMutation, { data, loading, error }] = useCreateSportZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSportZoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateSportZoneMutation, CreateSportZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSportZoneMutation, CreateSportZoneMutationVariables>(CreateSportZoneDocument, options);
      }
export type CreateSportZoneMutationHookResult = ReturnType<typeof useCreateSportZoneMutation>;
export type CreateSportZoneMutationResult = Apollo.MutationResult<CreateSportZoneMutation>;
export type CreateSportZoneMutationOptions = Apollo.BaseMutationOptions<CreateSportZoneMutation, CreateSportZoneMutationVariables>;
export const UpdateSportZoneDocument = gql`
    mutation updateSportZone($input: UpdateSportZoneInput!) {
  updateSportZone(updateSportZoneInput: $input) {
    ...SportZoneBasis
  }
}
    ${SportZoneBasisFragmentDoc}`;
export type UpdateSportZoneMutationFn = Apollo.MutationFunction<UpdateSportZoneMutation, UpdateSportZoneMutationVariables>;

/**
 * __useUpdateSportZoneMutation__
 *
 * To run a mutation, you first call `useUpdateSportZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSportZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSportZoneMutation, { data, loading, error }] = useUpdateSportZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSportZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSportZoneMutation, UpdateSportZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSportZoneMutation, UpdateSportZoneMutationVariables>(UpdateSportZoneDocument, options);
      }
export type UpdateSportZoneMutationHookResult = ReturnType<typeof useUpdateSportZoneMutation>;
export type UpdateSportZoneMutationResult = Apollo.MutationResult<UpdateSportZoneMutation>;
export type UpdateSportZoneMutationOptions = Apollo.BaseMutationOptions<UpdateSportZoneMutation, UpdateSportZoneMutationVariables>;
export const DeleteSportZoneDocument = gql`
    mutation deleteSportZone($id: String!) {
  deleteSportZone(id: $id)
}
    `;
export type DeleteSportZoneMutationFn = Apollo.MutationFunction<DeleteSportZoneMutation, DeleteSportZoneMutationVariables>;

/**
 * __useDeleteSportZoneMutation__
 *
 * To run a mutation, you first call `useDeleteSportZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSportZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSportZoneMutation, { data, loading, error }] = useDeleteSportZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSportZoneMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSportZoneMutation, DeleteSportZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSportZoneMutation, DeleteSportZoneMutationVariables>(DeleteSportZoneDocument, options);
      }
export type DeleteSportZoneMutationHookResult = ReturnType<typeof useDeleteSportZoneMutation>;
export type DeleteSportZoneMutationResult = Apollo.MutationResult<DeleteSportZoneMutation>;
export type DeleteSportZoneMutationOptions = Apollo.BaseMutationOptions<DeleteSportZoneMutation, DeleteSportZoneMutationVariables>;
export const GetSportZonesByObjectIdDocument = gql`
    query getSportZonesByObjectId($sportObjectId: String!) {
  getSportZonesByObjectId(sportObjectId: $sportObjectId) {
    ...SportZoneFull
  }
}
    ${SportZoneFullFragmentDoc}`;

/**
 * __useGetSportZonesByObjectIdQuery__
 *
 * To run a query within a React component, call `useGetSportZonesByObjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportZonesByObjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportZonesByObjectIdQuery({
 *   variables: {
 *      sportObjectId: // value for 'sportObjectId'
 *   },
 * });
 */
export function useGetSportZonesByObjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetSportZonesByObjectIdQuery, GetSportZonesByObjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportZonesByObjectIdQuery, GetSportZonesByObjectIdQueryVariables>(GetSportZonesByObjectIdDocument, options);
      }
export function useGetSportZonesByObjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportZonesByObjectIdQuery, GetSportZonesByObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportZonesByObjectIdQuery, GetSportZonesByObjectIdQueryVariables>(GetSportZonesByObjectIdDocument, options);
        }
export type GetSportZonesByObjectIdQueryHookResult = ReturnType<typeof useGetSportZonesByObjectIdQuery>;
export type GetSportZonesByObjectIdLazyQueryHookResult = ReturnType<typeof useGetSportZonesByObjectIdLazyQuery>;
export type GetSportZonesByObjectIdQueryResult = Apollo.QueryResult<GetSportZonesByObjectIdQuery, GetSportZonesByObjectIdQueryVariables>;
export function refetchGetSportZonesByObjectIdQuery(variables: GetSportZonesByObjectIdQueryVariables) {
      return { query: GetSportZonesByObjectIdDocument, variables: variables }
    }
export const GetSportZoneDocument = gql`
    query getSportZone($id: String!) {
  getSportZone(id: $id) {
    ...SportZoneFull
  }
}
    ${SportZoneFullFragmentDoc}`;

/**
 * __useGetSportZoneQuery__
 *
 * To run a query within a React component, call `useGetSportZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportZoneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSportZoneQuery(baseOptions: Apollo.QueryHookOptions<GetSportZoneQuery, GetSportZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportZoneQuery, GetSportZoneQueryVariables>(GetSportZoneDocument, options);
      }
export function useGetSportZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportZoneQuery, GetSportZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportZoneQuery, GetSportZoneQueryVariables>(GetSportZoneDocument, options);
        }
export type GetSportZoneQueryHookResult = ReturnType<typeof useGetSportZoneQuery>;
export type GetSportZoneLazyQueryHookResult = ReturnType<typeof useGetSportZoneLazyQuery>;
export type GetSportZoneQueryResult = Apollo.QueryResult<GetSportZoneQuery, GetSportZoneQueryVariables>;
export function refetchGetSportZoneQuery(variables: GetSportZoneQueryVariables) {
      return { query: GetSportZoneDocument, variables: variables }
    }
export const CreateSportSubZoneDocument = gql`
    mutation createSportSubZone($input: CreateSportSubZoneInput!) {
  createSportSubZone(createSportSubZoneInput: $input) {
    ...SportSubZoneBasis
  }
}
    ${SportSubZoneBasisFragmentDoc}`;
export type CreateSportSubZoneMutationFn = Apollo.MutationFunction<CreateSportSubZoneMutation, CreateSportSubZoneMutationVariables>;

/**
 * __useCreateSportSubZoneMutation__
 *
 * To run a mutation, you first call `useCreateSportSubZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSportSubZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSportSubZoneMutation, { data, loading, error }] = useCreateSportSubZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSportSubZoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateSportSubZoneMutation, CreateSportSubZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSportSubZoneMutation, CreateSportSubZoneMutationVariables>(CreateSportSubZoneDocument, options);
      }
export type CreateSportSubZoneMutationHookResult = ReturnType<typeof useCreateSportSubZoneMutation>;
export type CreateSportSubZoneMutationResult = Apollo.MutationResult<CreateSportSubZoneMutation>;
export type CreateSportSubZoneMutationOptions = Apollo.BaseMutationOptions<CreateSportSubZoneMutation, CreateSportSubZoneMutationVariables>;
export const UpdateSportSubZoneDocument = gql`
    mutation updateSportSubZone($input: UpdateSportSubZoneInput!) {
  updateSportSubZone(updateSportSubZoneInput: $input) {
    ...SportSubZoneBasis
  }
}
    ${SportSubZoneBasisFragmentDoc}`;
export type UpdateSportSubZoneMutationFn = Apollo.MutationFunction<UpdateSportSubZoneMutation, UpdateSportSubZoneMutationVariables>;

/**
 * __useUpdateSportSubZoneMutation__
 *
 * To run a mutation, you first call `useUpdateSportSubZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSportSubZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSportSubZoneMutation, { data, loading, error }] = useUpdateSportSubZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSportSubZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSportSubZoneMutation, UpdateSportSubZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSportSubZoneMutation, UpdateSportSubZoneMutationVariables>(UpdateSportSubZoneDocument, options);
      }
export type UpdateSportSubZoneMutationHookResult = ReturnType<typeof useUpdateSportSubZoneMutation>;
export type UpdateSportSubZoneMutationResult = Apollo.MutationResult<UpdateSportSubZoneMutation>;
export type UpdateSportSubZoneMutationOptions = Apollo.BaseMutationOptions<UpdateSportSubZoneMutation, UpdateSportSubZoneMutationVariables>;
export const GetSportZonesByZoneIdDocument = gql`
    query getSportZonesByZoneId($sportZoneId: String!) {
  getSportSubZonesByZoneId(sportZoneId: $sportZoneId) {
    ...SportSubZoneBasis
  }
}
    ${SportSubZoneBasisFragmentDoc}`;

/**
 * __useGetSportZonesByZoneIdQuery__
 *
 * To run a query within a React component, call `useGetSportZonesByZoneIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportZonesByZoneIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportZonesByZoneIdQuery({
 *   variables: {
 *      sportZoneId: // value for 'sportZoneId'
 *   },
 * });
 */
export function useGetSportZonesByZoneIdQuery(baseOptions: Apollo.QueryHookOptions<GetSportZonesByZoneIdQuery, GetSportZonesByZoneIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportZonesByZoneIdQuery, GetSportZonesByZoneIdQueryVariables>(GetSportZonesByZoneIdDocument, options);
      }
export function useGetSportZonesByZoneIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportZonesByZoneIdQuery, GetSportZonesByZoneIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportZonesByZoneIdQuery, GetSportZonesByZoneIdQueryVariables>(GetSportZonesByZoneIdDocument, options);
        }
export type GetSportZonesByZoneIdQueryHookResult = ReturnType<typeof useGetSportZonesByZoneIdQuery>;
export type GetSportZonesByZoneIdLazyQueryHookResult = ReturnType<typeof useGetSportZonesByZoneIdLazyQuery>;
export type GetSportZonesByZoneIdQueryResult = Apollo.QueryResult<GetSportZonesByZoneIdQuery, GetSportZonesByZoneIdQueryVariables>;
export function refetchGetSportZonesByZoneIdQuery(variables: GetSportZonesByZoneIdQueryVariables) {
      return { query: GetSportZonesByZoneIdDocument, variables: variables }
    }
export const GetSportSubZoneDocument = gql`
    query getSportSubZone($id: String!) {
  getSportSubZone(id: $id) {
    ...SportSubZoneFull
  }
}
    ${SportSubZoneFullFragmentDoc}`;

/**
 * __useGetSportSubZoneQuery__
 *
 * To run a query within a React component, call `useGetSportSubZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportSubZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportSubZoneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSportSubZoneQuery(baseOptions: Apollo.QueryHookOptions<GetSportSubZoneQuery, GetSportSubZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportSubZoneQuery, GetSportSubZoneQueryVariables>(GetSportSubZoneDocument, options);
      }
export function useGetSportSubZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportSubZoneQuery, GetSportSubZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportSubZoneQuery, GetSportSubZoneQueryVariables>(GetSportSubZoneDocument, options);
        }
export type GetSportSubZoneQueryHookResult = ReturnType<typeof useGetSportSubZoneQuery>;
export type GetSportSubZoneLazyQueryHookResult = ReturnType<typeof useGetSportSubZoneLazyQuery>;
export type GetSportSubZoneQueryResult = Apollo.QueryResult<GetSportSubZoneQuery, GetSportSubZoneQueryVariables>;
export function refetchGetSportSubZoneQuery(variables: GetSportSubZoneQueryVariables) {
      return { query: GetSportSubZoneDocument, variables: variables }
    }
export const DeleteSportSubZoneDocument = gql`
    mutation deleteSportSubZone($id: String!) {
  deleteSportSubZone(id: $id)
}
    `;
export type DeleteSportSubZoneMutationFn = Apollo.MutationFunction<DeleteSportSubZoneMutation, DeleteSportSubZoneMutationVariables>;

/**
 * __useDeleteSportSubZoneMutation__
 *
 * To run a mutation, you first call `useDeleteSportSubZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSportSubZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSportSubZoneMutation, { data, loading, error }] = useDeleteSportSubZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSportSubZoneMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSportSubZoneMutation, DeleteSportSubZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSportSubZoneMutation, DeleteSportSubZoneMutationVariables>(DeleteSportSubZoneDocument, options);
      }
export type DeleteSportSubZoneMutationHookResult = ReturnType<typeof useDeleteSportSubZoneMutation>;
export type DeleteSportSubZoneMutationResult = Apollo.MutationResult<DeleteSportSubZoneMutation>;
export type DeleteSportSubZoneMutationOptions = Apollo.BaseMutationOptions<DeleteSportSubZoneMutation, DeleteSportSubZoneMutationVariables>;
export const CreateSportEquipmentDocument = gql`
    mutation createSportEquipment($input: CreateSportEquipmentInput!) {
  createSportEquipment(createSportEquipmentInput: $input) {
    ...SportEquipmentFullForCreate
  }
}
    ${SportEquipmentFullForCreateFragmentDoc}`;
export type CreateSportEquipmentMutationFn = Apollo.MutationFunction<CreateSportEquipmentMutation, CreateSportEquipmentMutationVariables>;

/**
 * __useCreateSportEquipmentMutation__
 *
 * To run a mutation, you first call `useCreateSportEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSportEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSportEquipmentMutation, { data, loading, error }] = useCreateSportEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSportEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSportEquipmentMutation, CreateSportEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSportEquipmentMutation, CreateSportEquipmentMutationVariables>(CreateSportEquipmentDocument, options);
      }
export type CreateSportEquipmentMutationHookResult = ReturnType<typeof useCreateSportEquipmentMutation>;
export type CreateSportEquipmentMutationResult = Apollo.MutationResult<CreateSportEquipmentMutation>;
export type CreateSportEquipmentMutationOptions = Apollo.BaseMutationOptions<CreateSportEquipmentMutation, CreateSportEquipmentMutationVariables>;
export const ImportSportEquipmentDocument = gql`
    mutation importSportEquipment($input: ImportSportEquipmentsInput!) {
  importSportEquipment(input: $input)
}
    `;
export type ImportSportEquipmentMutationFn = Apollo.MutationFunction<ImportSportEquipmentMutation, ImportSportEquipmentMutationVariables>;

/**
 * __useImportSportEquipmentMutation__
 *
 * To run a mutation, you first call `useImportSportEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportSportEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importSportEquipmentMutation, { data, loading, error }] = useImportSportEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportSportEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<ImportSportEquipmentMutation, ImportSportEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportSportEquipmentMutation, ImportSportEquipmentMutationVariables>(ImportSportEquipmentDocument, options);
      }
export type ImportSportEquipmentMutationHookResult = ReturnType<typeof useImportSportEquipmentMutation>;
export type ImportSportEquipmentMutationResult = Apollo.MutationResult<ImportSportEquipmentMutation>;
export type ImportSportEquipmentMutationOptions = Apollo.BaseMutationOptions<ImportSportEquipmentMutation, ImportSportEquipmentMutationVariables>;
export const SetEditableDocument = gql`
    mutation setEditable($input: SetEditableInput!) {
  setEditable(input: $input)
}
    `;
export type SetEditableMutationFn = Apollo.MutationFunction<SetEditableMutation, SetEditableMutationVariables>;

/**
 * __useSetEditableMutation__
 *
 * To run a mutation, you first call `useSetEditableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEditableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEditableMutation, { data, loading, error }] = useSetEditableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEditableMutation(baseOptions?: Apollo.MutationHookOptions<SetEditableMutation, SetEditableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEditableMutation, SetEditableMutationVariables>(SetEditableDocument, options);
      }
export type SetEditableMutationHookResult = ReturnType<typeof useSetEditableMutation>;
export type SetEditableMutationResult = Apollo.MutationResult<SetEditableMutation>;
export type SetEditableMutationOptions = Apollo.BaseMutationOptions<SetEditableMutation, SetEditableMutationVariables>;
export const UpdateSportEquipmentDocument = gql`
    mutation updateSportEquipment($input: UpdateSportEquipmentInput!) {
  updateSportEquipment(updateSportEquipmentInput: $input) {
    ...SportEquipmentFull
  }
}
    ${SportEquipmentFullFragmentDoc}`;
export type UpdateSportEquipmentMutationFn = Apollo.MutationFunction<UpdateSportEquipmentMutation, UpdateSportEquipmentMutationVariables>;

/**
 * __useUpdateSportEquipmentMutation__
 *
 * To run a mutation, you first call `useUpdateSportEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSportEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSportEquipmentMutation, { data, loading, error }] = useUpdateSportEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSportEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSportEquipmentMutation, UpdateSportEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSportEquipmentMutation, UpdateSportEquipmentMutationVariables>(UpdateSportEquipmentDocument, options);
      }
export type UpdateSportEquipmentMutationHookResult = ReturnType<typeof useUpdateSportEquipmentMutation>;
export type UpdateSportEquipmentMutationResult = Apollo.MutationResult<UpdateSportEquipmentMutation>;
export type UpdateSportEquipmentMutationOptions = Apollo.BaseMutationOptions<UpdateSportEquipmentMutation, UpdateSportEquipmentMutationVariables>;
export const DeleteSportEquipmentDocument = gql`
    mutation deleteSportEquipment($id: String!) {
  deleteSportEquipment(id: $id)
}
    `;
export type DeleteSportEquipmentMutationFn = Apollo.MutationFunction<DeleteSportEquipmentMutation, DeleteSportEquipmentMutationVariables>;

/**
 * __useDeleteSportEquipmentMutation__
 *
 * To run a mutation, you first call `useDeleteSportEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSportEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSportEquipmentMutation, { data, loading, error }] = useDeleteSportEquipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSportEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSportEquipmentMutation, DeleteSportEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSportEquipmentMutation, DeleteSportEquipmentMutationVariables>(DeleteSportEquipmentDocument, options);
      }
export type DeleteSportEquipmentMutationHookResult = ReturnType<typeof useDeleteSportEquipmentMutation>;
export type DeleteSportEquipmentMutationResult = Apollo.MutationResult<DeleteSportEquipmentMutation>;
export type DeleteSportEquipmentMutationOptions = Apollo.BaseMutationOptions<DeleteSportEquipmentMutation, DeleteSportEquipmentMutationVariables>;
export const CreateEquipmentServicePeriodDocument = gql`
    mutation createEquipmentServicePeriod($input: CreateEquipmentServicePeriodInput!) {
  createEquipmentServicePeriod(input: $input) {
    ...EquipmentServicePeriodFull
  }
}
    ${EquipmentServicePeriodFullFragmentDoc}`;
export type CreateEquipmentServicePeriodMutationFn = Apollo.MutationFunction<CreateEquipmentServicePeriodMutation, CreateEquipmentServicePeriodMutationVariables>;

/**
 * __useCreateEquipmentServicePeriodMutation__
 *
 * To run a mutation, you first call `useCreateEquipmentServicePeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEquipmentServicePeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEquipmentServicePeriodMutation, { data, loading, error }] = useCreateEquipmentServicePeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEquipmentServicePeriodMutation(baseOptions?: Apollo.MutationHookOptions<CreateEquipmentServicePeriodMutation, CreateEquipmentServicePeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEquipmentServicePeriodMutation, CreateEquipmentServicePeriodMutationVariables>(CreateEquipmentServicePeriodDocument, options);
      }
export type CreateEquipmentServicePeriodMutationHookResult = ReturnType<typeof useCreateEquipmentServicePeriodMutation>;
export type CreateEquipmentServicePeriodMutationResult = Apollo.MutationResult<CreateEquipmentServicePeriodMutation>;
export type CreateEquipmentServicePeriodMutationOptions = Apollo.BaseMutationOptions<CreateEquipmentServicePeriodMutation, CreateEquipmentServicePeriodMutationVariables>;
export const UpdateEquipmentServicePeriodDocument = gql`
    mutation updateEquipmentServicePeriod($input: UpdateEquipmentServicePeriodInput!) {
  updateEquipmentServicePeriod(input: $input) {
    ...EquipmentServicePeriodFull
  }
}
    ${EquipmentServicePeriodFullFragmentDoc}`;
export type UpdateEquipmentServicePeriodMutationFn = Apollo.MutationFunction<UpdateEquipmentServicePeriodMutation, UpdateEquipmentServicePeriodMutationVariables>;

/**
 * __useUpdateEquipmentServicePeriodMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentServicePeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentServicePeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentServicePeriodMutation, { data, loading, error }] = useUpdateEquipmentServicePeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEquipmentServicePeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentServicePeriodMutation, UpdateEquipmentServicePeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentServicePeriodMutation, UpdateEquipmentServicePeriodMutationVariables>(UpdateEquipmentServicePeriodDocument, options);
      }
export type UpdateEquipmentServicePeriodMutationHookResult = ReturnType<typeof useUpdateEquipmentServicePeriodMutation>;
export type UpdateEquipmentServicePeriodMutationResult = Apollo.MutationResult<UpdateEquipmentServicePeriodMutation>;
export type UpdateEquipmentServicePeriodMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentServicePeriodMutation, UpdateEquipmentServicePeriodMutationVariables>;
export const GetEquipmentServicePeriodsDocument = gql`
    query getEquipmentServicePeriods($id: String!) {
  getEquipmentServicePeriods(equipmentId: $id) {
    ...EquipmentServicePeriodFull
  }
}
    ${EquipmentServicePeriodFullFragmentDoc}`;

/**
 * __useGetEquipmentServicePeriodsQuery__
 *
 * To run a query within a React component, call `useGetEquipmentServicePeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentServicePeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentServicePeriodsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEquipmentServicePeriodsQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentServicePeriodsQuery, GetEquipmentServicePeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentServicePeriodsQuery, GetEquipmentServicePeriodsQueryVariables>(GetEquipmentServicePeriodsDocument, options);
      }
export function useGetEquipmentServicePeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentServicePeriodsQuery, GetEquipmentServicePeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentServicePeriodsQuery, GetEquipmentServicePeriodsQueryVariables>(GetEquipmentServicePeriodsDocument, options);
        }
export type GetEquipmentServicePeriodsQueryHookResult = ReturnType<typeof useGetEquipmentServicePeriodsQuery>;
export type GetEquipmentServicePeriodsLazyQueryHookResult = ReturnType<typeof useGetEquipmentServicePeriodsLazyQuery>;
export type GetEquipmentServicePeriodsQueryResult = Apollo.QueryResult<GetEquipmentServicePeriodsQuery, GetEquipmentServicePeriodsQueryVariables>;
export function refetchGetEquipmentServicePeriodsQuery(variables: GetEquipmentServicePeriodsQueryVariables) {
      return { query: GetEquipmentServicePeriodsDocument, variables: variables }
    }
export const DeleteEquipmentServicePeriodDocument = gql`
    mutation deleteEquipmentServicePeriod($id: String!) {
  deleteEquipmentServicePeriod(id: $id)
}
    `;
export type DeleteEquipmentServicePeriodMutationFn = Apollo.MutationFunction<DeleteEquipmentServicePeriodMutation, DeleteEquipmentServicePeriodMutationVariables>;

/**
 * __useDeleteEquipmentServicePeriodMutation__
 *
 * To run a mutation, you first call `useDeleteEquipmentServicePeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEquipmentServicePeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEquipmentServicePeriodMutation, { data, loading, error }] = useDeleteEquipmentServicePeriodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEquipmentServicePeriodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEquipmentServicePeriodMutation, DeleteEquipmentServicePeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEquipmentServicePeriodMutation, DeleteEquipmentServicePeriodMutationVariables>(DeleteEquipmentServicePeriodDocument, options);
      }
export type DeleteEquipmentServicePeriodMutationHookResult = ReturnType<typeof useDeleteEquipmentServicePeriodMutation>;
export type DeleteEquipmentServicePeriodMutationResult = Apollo.MutationResult<DeleteEquipmentServicePeriodMutation>;
export type DeleteEquipmentServicePeriodMutationOptions = Apollo.BaseMutationOptions<DeleteEquipmentServicePeriodMutation, DeleteEquipmentServicePeriodMutationVariables>;
export const GetEquipmentServiceJobsDocument = gql`
    query getEquipmentServiceJobs($input: GetEquipmentServiceJobsInput!) {
  getEquipmentServiceJobs(input: $input) {
    count
    equipmentServiceJobs {
      ...EquipmentServiceJobBasis
    }
  }
}
    ${EquipmentServiceJobBasisFragmentDoc}`;

/**
 * __useGetEquipmentServiceJobsQuery__
 *
 * To run a query within a React component, call `useGetEquipmentServiceJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentServiceJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentServiceJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEquipmentServiceJobsQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentServiceJobsQuery, GetEquipmentServiceJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentServiceJobsQuery, GetEquipmentServiceJobsQueryVariables>(GetEquipmentServiceJobsDocument, options);
      }
export function useGetEquipmentServiceJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentServiceJobsQuery, GetEquipmentServiceJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentServiceJobsQuery, GetEquipmentServiceJobsQueryVariables>(GetEquipmentServiceJobsDocument, options);
        }
export type GetEquipmentServiceJobsQueryHookResult = ReturnType<typeof useGetEquipmentServiceJobsQuery>;
export type GetEquipmentServiceJobsLazyQueryHookResult = ReturnType<typeof useGetEquipmentServiceJobsLazyQuery>;
export type GetEquipmentServiceJobsQueryResult = Apollo.QueryResult<GetEquipmentServiceJobsQuery, GetEquipmentServiceJobsQueryVariables>;
export function refetchGetEquipmentServiceJobsQuery(variables: GetEquipmentServiceJobsQueryVariables) {
      return { query: GetEquipmentServiceJobsDocument, variables: variables }
    }
export const GetEquipmentServiceJobsBySportObjectDocument = gql`
    query getEquipmentServiceJobsBySportObject($sportObjectId: String!) {
  getEquipmentServiceJobsBySportObject(sportObjectId: $sportObjectId) {
    ...EquipmentServiceJobBasis
  }
}
    ${EquipmentServiceJobBasisFragmentDoc}`;

/**
 * __useGetEquipmentServiceJobsBySportObjectQuery__
 *
 * To run a query within a React component, call `useGetEquipmentServiceJobsBySportObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentServiceJobsBySportObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentServiceJobsBySportObjectQuery({
 *   variables: {
 *      sportObjectId: // value for 'sportObjectId'
 *   },
 * });
 */
export function useGetEquipmentServiceJobsBySportObjectQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentServiceJobsBySportObjectQuery, GetEquipmentServiceJobsBySportObjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentServiceJobsBySportObjectQuery, GetEquipmentServiceJobsBySportObjectQueryVariables>(GetEquipmentServiceJobsBySportObjectDocument, options);
      }
export function useGetEquipmentServiceJobsBySportObjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentServiceJobsBySportObjectQuery, GetEquipmentServiceJobsBySportObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentServiceJobsBySportObjectQuery, GetEquipmentServiceJobsBySportObjectQueryVariables>(GetEquipmentServiceJobsBySportObjectDocument, options);
        }
export type GetEquipmentServiceJobsBySportObjectQueryHookResult = ReturnType<typeof useGetEquipmentServiceJobsBySportObjectQuery>;
export type GetEquipmentServiceJobsBySportObjectLazyQueryHookResult = ReturnType<typeof useGetEquipmentServiceJobsBySportObjectLazyQuery>;
export type GetEquipmentServiceJobsBySportObjectQueryResult = Apollo.QueryResult<GetEquipmentServiceJobsBySportObjectQuery, GetEquipmentServiceJobsBySportObjectQueryVariables>;
export function refetchGetEquipmentServiceJobsBySportObjectQuery(variables: GetEquipmentServiceJobsBySportObjectQueryVariables) {
      return { query: GetEquipmentServiceJobsBySportObjectDocument, variables: variables }
    }
export const GetEquipmentServiceJobsBySportObjectsDocument = gql`
    query getEquipmentServiceJobsBySportObjects($sportObjectIds: [String!]!) {
  getEquipmentServiceJobsBySportObjects(sportObjectIds: $sportObjectIds) {
    ...EquipmentServiceJobBasis
  }
}
    ${EquipmentServiceJobBasisFragmentDoc}`;

/**
 * __useGetEquipmentServiceJobsBySportObjectsQuery__
 *
 * To run a query within a React component, call `useGetEquipmentServiceJobsBySportObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentServiceJobsBySportObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentServiceJobsBySportObjectsQuery({
 *   variables: {
 *      sportObjectIds: // value for 'sportObjectIds'
 *   },
 * });
 */
export function useGetEquipmentServiceJobsBySportObjectsQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentServiceJobsBySportObjectsQuery, GetEquipmentServiceJobsBySportObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentServiceJobsBySportObjectsQuery, GetEquipmentServiceJobsBySportObjectsQueryVariables>(GetEquipmentServiceJobsBySportObjectsDocument, options);
      }
export function useGetEquipmentServiceJobsBySportObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentServiceJobsBySportObjectsQuery, GetEquipmentServiceJobsBySportObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentServiceJobsBySportObjectsQuery, GetEquipmentServiceJobsBySportObjectsQueryVariables>(GetEquipmentServiceJobsBySportObjectsDocument, options);
        }
export type GetEquipmentServiceJobsBySportObjectsQueryHookResult = ReturnType<typeof useGetEquipmentServiceJobsBySportObjectsQuery>;
export type GetEquipmentServiceJobsBySportObjectsLazyQueryHookResult = ReturnType<typeof useGetEquipmentServiceJobsBySportObjectsLazyQuery>;
export type GetEquipmentServiceJobsBySportObjectsQueryResult = Apollo.QueryResult<GetEquipmentServiceJobsBySportObjectsQuery, GetEquipmentServiceJobsBySportObjectsQueryVariables>;
export function refetchGetEquipmentServiceJobsBySportObjectsQuery(variables: GetEquipmentServiceJobsBySportObjectsQueryVariables) {
      return { query: GetEquipmentServiceJobsBySportObjectsDocument, variables: variables }
    }
export const GetArchivedEquipmentServiceJobsBySportObjectDocument = gql`
    query getArchivedEquipmentServiceJobsBySportObject($sportObjectId: String!) {
  getArchivedEquipmentServiceJobsBySportObject(sportObjectId: $sportObjectId) {
    ...EquipmentServiceJobBasis
  }
}
    ${EquipmentServiceJobBasisFragmentDoc}`;

/**
 * __useGetArchivedEquipmentServiceJobsBySportObjectQuery__
 *
 * To run a query within a React component, call `useGetArchivedEquipmentServiceJobsBySportObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedEquipmentServiceJobsBySportObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedEquipmentServiceJobsBySportObjectQuery({
 *   variables: {
 *      sportObjectId: // value for 'sportObjectId'
 *   },
 * });
 */
export function useGetArchivedEquipmentServiceJobsBySportObjectQuery(baseOptions: Apollo.QueryHookOptions<GetArchivedEquipmentServiceJobsBySportObjectQuery, GetArchivedEquipmentServiceJobsBySportObjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivedEquipmentServiceJobsBySportObjectQuery, GetArchivedEquipmentServiceJobsBySportObjectQueryVariables>(GetArchivedEquipmentServiceJobsBySportObjectDocument, options);
      }
export function useGetArchivedEquipmentServiceJobsBySportObjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivedEquipmentServiceJobsBySportObjectQuery, GetArchivedEquipmentServiceJobsBySportObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivedEquipmentServiceJobsBySportObjectQuery, GetArchivedEquipmentServiceJobsBySportObjectQueryVariables>(GetArchivedEquipmentServiceJobsBySportObjectDocument, options);
        }
export type GetArchivedEquipmentServiceJobsBySportObjectQueryHookResult = ReturnType<typeof useGetArchivedEquipmentServiceJobsBySportObjectQuery>;
export type GetArchivedEquipmentServiceJobsBySportObjectLazyQueryHookResult = ReturnType<typeof useGetArchivedEquipmentServiceJobsBySportObjectLazyQuery>;
export type GetArchivedEquipmentServiceJobsBySportObjectQueryResult = Apollo.QueryResult<GetArchivedEquipmentServiceJobsBySportObjectQuery, GetArchivedEquipmentServiceJobsBySportObjectQueryVariables>;
export function refetchGetArchivedEquipmentServiceJobsBySportObjectQuery(variables: GetArchivedEquipmentServiceJobsBySportObjectQueryVariables) {
      return { query: GetArchivedEquipmentServiceJobsBySportObjectDocument, variables: variables }
    }
export const GetArchivedEquipmentServiceJobsBySportObjectsDocument = gql`
    query getArchivedEquipmentServiceJobsBySportObjects($sportObjectIds: [String!]!) {
  getArchivedEquipmentServiceJobsBySportObjects(sportObjectIds: $sportObjectIds) {
    ...EquipmentServiceJobBasis
  }
}
    ${EquipmentServiceJobBasisFragmentDoc}`;

/**
 * __useGetArchivedEquipmentServiceJobsBySportObjectsQuery__
 *
 * To run a query within a React component, call `useGetArchivedEquipmentServiceJobsBySportObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedEquipmentServiceJobsBySportObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedEquipmentServiceJobsBySportObjectsQuery({
 *   variables: {
 *      sportObjectIds: // value for 'sportObjectIds'
 *   },
 * });
 */
export function useGetArchivedEquipmentServiceJobsBySportObjectsQuery(baseOptions: Apollo.QueryHookOptions<GetArchivedEquipmentServiceJobsBySportObjectsQuery, GetArchivedEquipmentServiceJobsBySportObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivedEquipmentServiceJobsBySportObjectsQuery, GetArchivedEquipmentServiceJobsBySportObjectsQueryVariables>(GetArchivedEquipmentServiceJobsBySportObjectsDocument, options);
      }
export function useGetArchivedEquipmentServiceJobsBySportObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivedEquipmentServiceJobsBySportObjectsQuery, GetArchivedEquipmentServiceJobsBySportObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivedEquipmentServiceJobsBySportObjectsQuery, GetArchivedEquipmentServiceJobsBySportObjectsQueryVariables>(GetArchivedEquipmentServiceJobsBySportObjectsDocument, options);
        }
export type GetArchivedEquipmentServiceJobsBySportObjectsQueryHookResult = ReturnType<typeof useGetArchivedEquipmentServiceJobsBySportObjectsQuery>;
export type GetArchivedEquipmentServiceJobsBySportObjectsLazyQueryHookResult = ReturnType<typeof useGetArchivedEquipmentServiceJobsBySportObjectsLazyQuery>;
export type GetArchivedEquipmentServiceJobsBySportObjectsQueryResult = Apollo.QueryResult<GetArchivedEquipmentServiceJobsBySportObjectsQuery, GetArchivedEquipmentServiceJobsBySportObjectsQueryVariables>;
export function refetchGetArchivedEquipmentServiceJobsBySportObjectsQuery(variables: GetArchivedEquipmentServiceJobsBySportObjectsQueryVariables) {
      return { query: GetArchivedEquipmentServiceJobsBySportObjectsDocument, variables: variables }
    }
export const UpdateEquipmentServiceJobDocument = gql`
    mutation updateEquipmentServiceJob($input: UpdateEquipmentServiceJobInput!) {
  updateEquipmentServiceJob(input: $input) {
    id
  }
}
    `;
export type UpdateEquipmentServiceJobMutationFn = Apollo.MutationFunction<UpdateEquipmentServiceJobMutation, UpdateEquipmentServiceJobMutationVariables>;

/**
 * __useUpdateEquipmentServiceJobMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentServiceJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentServiceJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentServiceJobMutation, { data, loading, error }] = useUpdateEquipmentServiceJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEquipmentServiceJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentServiceJobMutation, UpdateEquipmentServiceJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentServiceJobMutation, UpdateEquipmentServiceJobMutationVariables>(UpdateEquipmentServiceJobDocument, options);
      }
export type UpdateEquipmentServiceJobMutationHookResult = ReturnType<typeof useUpdateEquipmentServiceJobMutation>;
export type UpdateEquipmentServiceJobMutationResult = Apollo.MutationResult<UpdateEquipmentServiceJobMutation>;
export type UpdateEquipmentServiceJobMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentServiceJobMutation, UpdateEquipmentServiceJobMutationVariables>;
export const DeleteEquipmentServiceJobDocument = gql`
    mutation deleteEquipmentServiceJob($id: String!) {
  deleteEquipmentServiceJob(id: $id)
}
    `;
export type DeleteEquipmentServiceJobMutationFn = Apollo.MutationFunction<DeleteEquipmentServiceJobMutation, DeleteEquipmentServiceJobMutationVariables>;

/**
 * __useDeleteEquipmentServiceJobMutation__
 *
 * To run a mutation, you first call `useDeleteEquipmentServiceJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEquipmentServiceJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEquipmentServiceJobMutation, { data, loading, error }] = useDeleteEquipmentServiceJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEquipmentServiceJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEquipmentServiceJobMutation, DeleteEquipmentServiceJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEquipmentServiceJobMutation, DeleteEquipmentServiceJobMutationVariables>(DeleteEquipmentServiceJobDocument, options);
      }
export type DeleteEquipmentServiceJobMutationHookResult = ReturnType<typeof useDeleteEquipmentServiceJobMutation>;
export type DeleteEquipmentServiceJobMutationResult = Apollo.MutationResult<DeleteEquipmentServiceJobMutation>;
export type DeleteEquipmentServiceJobMutationOptions = Apollo.BaseMutationOptions<DeleteEquipmentServiceJobMutation, DeleteEquipmentServiceJobMutationVariables>;
export const GetAllEquipmentRequestsDocument = gql`
    query getAllEquipmentRequests {
  getAllEquipmentRequests {
    ...EquipmentRequestBasis
  }
}
    ${EquipmentRequestBasisFragmentDoc}`;

/**
 * __useGetAllEquipmentRequestsQuery__
 *
 * To run a query within a React component, call `useGetAllEquipmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEquipmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEquipmentRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEquipmentRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEquipmentRequestsQuery, GetAllEquipmentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEquipmentRequestsQuery, GetAllEquipmentRequestsQueryVariables>(GetAllEquipmentRequestsDocument, options);
      }
export function useGetAllEquipmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEquipmentRequestsQuery, GetAllEquipmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEquipmentRequestsQuery, GetAllEquipmentRequestsQueryVariables>(GetAllEquipmentRequestsDocument, options);
        }
export type GetAllEquipmentRequestsQueryHookResult = ReturnType<typeof useGetAllEquipmentRequestsQuery>;
export type GetAllEquipmentRequestsLazyQueryHookResult = ReturnType<typeof useGetAllEquipmentRequestsLazyQuery>;
export type GetAllEquipmentRequestsQueryResult = Apollo.QueryResult<GetAllEquipmentRequestsQuery, GetAllEquipmentRequestsQueryVariables>;
export function refetchGetAllEquipmentRequestsQuery(variables?: GetAllEquipmentRequestsQueryVariables) {
      return { query: GetAllEquipmentRequestsDocument, variables: variables }
    }
export const GetEquipmentRequestsBySportObjectIdDocument = gql`
    query getEquipmentRequestsBySportObjectId($sportObjectId: String!) {
  getEquipmentRequestsBySportObjectId(sportObjectId: $sportObjectId) {
    ...EquipmentRequestBasis
  }
}
    ${EquipmentRequestBasisFragmentDoc}`;

/**
 * __useGetEquipmentRequestsBySportObjectIdQuery__
 *
 * To run a query within a React component, call `useGetEquipmentRequestsBySportObjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentRequestsBySportObjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentRequestsBySportObjectIdQuery({
 *   variables: {
 *      sportObjectId: // value for 'sportObjectId'
 *   },
 * });
 */
export function useGetEquipmentRequestsBySportObjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentRequestsBySportObjectIdQuery, GetEquipmentRequestsBySportObjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentRequestsBySportObjectIdQuery, GetEquipmentRequestsBySportObjectIdQueryVariables>(GetEquipmentRequestsBySportObjectIdDocument, options);
      }
export function useGetEquipmentRequestsBySportObjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentRequestsBySportObjectIdQuery, GetEquipmentRequestsBySportObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentRequestsBySportObjectIdQuery, GetEquipmentRequestsBySportObjectIdQueryVariables>(GetEquipmentRequestsBySportObjectIdDocument, options);
        }
export type GetEquipmentRequestsBySportObjectIdQueryHookResult = ReturnType<typeof useGetEquipmentRequestsBySportObjectIdQuery>;
export type GetEquipmentRequestsBySportObjectIdLazyQueryHookResult = ReturnType<typeof useGetEquipmentRequestsBySportObjectIdLazyQuery>;
export type GetEquipmentRequestsBySportObjectIdQueryResult = Apollo.QueryResult<GetEquipmentRequestsBySportObjectIdQuery, GetEquipmentRequestsBySportObjectIdQueryVariables>;
export function refetchGetEquipmentRequestsBySportObjectIdQuery(variables: GetEquipmentRequestsBySportObjectIdQueryVariables) {
      return { query: GetEquipmentRequestsBySportObjectIdDocument, variables: variables }
    }
export const GetAllEquipmentRequestsByStatusesDocument = gql`
    query getAllEquipmentRequestsByStatuses($statuses: [EquipmentRequestStatusEnum!]!) {
  getAllEquipmentRequestsByStatuses(statuses: $statuses) {
    ...EquipmentRequestBasis
  }
}
    ${EquipmentRequestBasisFragmentDoc}`;

/**
 * __useGetAllEquipmentRequestsByStatusesQuery__
 *
 * To run a query within a React component, call `useGetAllEquipmentRequestsByStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEquipmentRequestsByStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEquipmentRequestsByStatusesQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetAllEquipmentRequestsByStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetAllEquipmentRequestsByStatusesQuery, GetAllEquipmentRequestsByStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEquipmentRequestsByStatusesQuery, GetAllEquipmentRequestsByStatusesQueryVariables>(GetAllEquipmentRequestsByStatusesDocument, options);
      }
export function useGetAllEquipmentRequestsByStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEquipmentRequestsByStatusesQuery, GetAllEquipmentRequestsByStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEquipmentRequestsByStatusesQuery, GetAllEquipmentRequestsByStatusesQueryVariables>(GetAllEquipmentRequestsByStatusesDocument, options);
        }
export type GetAllEquipmentRequestsByStatusesQueryHookResult = ReturnType<typeof useGetAllEquipmentRequestsByStatusesQuery>;
export type GetAllEquipmentRequestsByStatusesLazyQueryHookResult = ReturnType<typeof useGetAllEquipmentRequestsByStatusesLazyQuery>;
export type GetAllEquipmentRequestsByStatusesQueryResult = Apollo.QueryResult<GetAllEquipmentRequestsByStatusesQuery, GetAllEquipmentRequestsByStatusesQueryVariables>;
export function refetchGetAllEquipmentRequestsByStatusesQuery(variables: GetAllEquipmentRequestsByStatusesQueryVariables) {
      return { query: GetAllEquipmentRequestsByStatusesDocument, variables: variables }
    }
export const CreateEquipmentRequestDocument = gql`
    mutation createEquipmentRequest($input: CreateEquipmentRequestInput!) {
  createEquipmentRequest(input: $input) {
    ...EquipmentRequestBasis
  }
}
    ${EquipmentRequestBasisFragmentDoc}`;
export type CreateEquipmentRequestMutationFn = Apollo.MutationFunction<CreateEquipmentRequestMutation, CreateEquipmentRequestMutationVariables>;

/**
 * __useCreateEquipmentRequestMutation__
 *
 * To run a mutation, you first call `useCreateEquipmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEquipmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEquipmentRequestMutation, { data, loading, error }] = useCreateEquipmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEquipmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateEquipmentRequestMutation, CreateEquipmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEquipmentRequestMutation, CreateEquipmentRequestMutationVariables>(CreateEquipmentRequestDocument, options);
      }
export type CreateEquipmentRequestMutationHookResult = ReturnType<typeof useCreateEquipmentRequestMutation>;
export type CreateEquipmentRequestMutationResult = Apollo.MutationResult<CreateEquipmentRequestMutation>;
export type CreateEquipmentRequestMutationOptions = Apollo.BaseMutationOptions<CreateEquipmentRequestMutation, CreateEquipmentRequestMutationVariables>;
export const UpdateEquipmentRequestDocument = gql`
    mutation updateEquipmentRequest($input: UpdateEquipmentRequestInput!) {
  updateEquipmentRequest(input: $input) {
    ...EquipmentRequestBasis
  }
}
    ${EquipmentRequestBasisFragmentDoc}`;
export type UpdateEquipmentRequestMutationFn = Apollo.MutationFunction<UpdateEquipmentRequestMutation, UpdateEquipmentRequestMutationVariables>;

/**
 * __useUpdateEquipmentRequestMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentRequestMutation, { data, loading, error }] = useUpdateEquipmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEquipmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentRequestMutation, UpdateEquipmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentRequestMutation, UpdateEquipmentRequestMutationVariables>(UpdateEquipmentRequestDocument, options);
      }
export type UpdateEquipmentRequestMutationHookResult = ReturnType<typeof useUpdateEquipmentRequestMutation>;
export type UpdateEquipmentRequestMutationResult = Apollo.MutationResult<UpdateEquipmentRequestMutation>;
export type UpdateEquipmentRequestMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentRequestMutation, UpdateEquipmentRequestMutationVariables>;
export const DeleteEquipmentRequestDocument = gql`
    mutation deleteEquipmentRequest($id: String!) {
  deleteEquipmentRequest(id: $id)
}
    `;
export type DeleteEquipmentRequestMutationFn = Apollo.MutationFunction<DeleteEquipmentRequestMutation, DeleteEquipmentRequestMutationVariables>;

/**
 * __useDeleteEquipmentRequestMutation__
 *
 * To run a mutation, you first call `useDeleteEquipmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEquipmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEquipmentRequestMutation, { data, loading, error }] = useDeleteEquipmentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEquipmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEquipmentRequestMutation, DeleteEquipmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEquipmentRequestMutation, DeleteEquipmentRequestMutationVariables>(DeleteEquipmentRequestDocument, options);
      }
export type DeleteEquipmentRequestMutationHookResult = ReturnType<typeof useDeleteEquipmentRequestMutation>;
export type DeleteEquipmentRequestMutationResult = Apollo.MutationResult<DeleteEquipmentRequestMutation>;
export type DeleteEquipmentRequestMutationOptions = Apollo.BaseMutationOptions<DeleteEquipmentRequestMutation, DeleteEquipmentRequestMutationVariables>;
export const LoginDocument = gql`
    query login($input: LoginUserInput!) {
  login(input: $input) {
    user {
      ...UserFull
    }
    token
  }
}
    ${UserFullFragmentDoc}`;

/**
 * __useLoginQuery__
 *
 * To run a query within a React component, call `useLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginQuery(baseOptions: Apollo.QueryHookOptions<LoginQuery, LoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
      }
export function useLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginQuery, LoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
        }
export type LoginQueryHookResult = ReturnType<typeof useLoginQuery>;
export type LoginLazyQueryHookResult = ReturnType<typeof useLoginLazyQuery>;
export type LoginQueryResult = Apollo.QueryResult<LoginQuery, LoginQueryVariables>;
export function refetchLoginQuery(variables: LoginQueryVariables) {
      return { query: LoginDocument, variables: variables }
    }
export const UsersDocument = gql`
    query users {
  users {
    ...UserBasic
  }
}
    ${UserBasicFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export function refetchUsersQuery(variables?: UsersQueryVariables) {
      return { query: UsersDocument, variables: variables }
    }
export const GetRelocationRequestsDocument = gql`
    query getRelocationRequests($input: GetRelocationRequestsInput!) {
  getRelocationRequests(input: $input) {
    ...GetRelocationRequests
  }
}
    ${GetRelocationRequestsFragmentDoc}`;

/**
 * __useGetRelocationRequestsQuery__
 *
 * To run a query within a React component, call `useGetRelocationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelocationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelocationRequestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRelocationRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetRelocationRequestsQuery, GetRelocationRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelocationRequestsQuery, GetRelocationRequestsQueryVariables>(GetRelocationRequestsDocument, options);
      }
export function useGetRelocationRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelocationRequestsQuery, GetRelocationRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelocationRequestsQuery, GetRelocationRequestsQueryVariables>(GetRelocationRequestsDocument, options);
        }
export type GetRelocationRequestsQueryHookResult = ReturnType<typeof useGetRelocationRequestsQuery>;
export type GetRelocationRequestsLazyQueryHookResult = ReturnType<typeof useGetRelocationRequestsLazyQuery>;
export type GetRelocationRequestsQueryResult = Apollo.QueryResult<GetRelocationRequestsQuery, GetRelocationRequestsQueryVariables>;
export function refetchGetRelocationRequestsQuery(variables: GetRelocationRequestsQueryVariables) {
      return { query: GetRelocationRequestsDocument, variables: variables }
    }
export const GetEquipmentRelocationRequestByIdsDocument = gql`
    query getEquipmentRelocationRequestByIds($ids: [String!]!) {
  getEquipmentRelocationRequestByIds(ids: $ids) {
    ...EquipmentRelocationRequestBasis
  }
}
    ${EquipmentRelocationRequestBasisFragmentDoc}`;

/**
 * __useGetEquipmentRelocationRequestByIdsQuery__
 *
 * To run a query within a React component, call `useGetEquipmentRelocationRequestByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentRelocationRequestByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentRelocationRequestByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetEquipmentRelocationRequestByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentRelocationRequestByIdsQuery, GetEquipmentRelocationRequestByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentRelocationRequestByIdsQuery, GetEquipmentRelocationRequestByIdsQueryVariables>(GetEquipmentRelocationRequestByIdsDocument, options);
      }
export function useGetEquipmentRelocationRequestByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentRelocationRequestByIdsQuery, GetEquipmentRelocationRequestByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentRelocationRequestByIdsQuery, GetEquipmentRelocationRequestByIdsQueryVariables>(GetEquipmentRelocationRequestByIdsDocument, options);
        }
export type GetEquipmentRelocationRequestByIdsQueryHookResult = ReturnType<typeof useGetEquipmentRelocationRequestByIdsQuery>;
export type GetEquipmentRelocationRequestByIdsLazyQueryHookResult = ReturnType<typeof useGetEquipmentRelocationRequestByIdsLazyQuery>;
export type GetEquipmentRelocationRequestByIdsQueryResult = Apollo.QueryResult<GetEquipmentRelocationRequestByIdsQuery, GetEquipmentRelocationRequestByIdsQueryVariables>;
export function refetchGetEquipmentRelocationRequestByIdsQuery(variables: GetEquipmentRelocationRequestByIdsQueryVariables) {
      return { query: GetEquipmentRelocationRequestByIdsDocument, variables: variables }
    }
export const AcceptRequestDocument = gql`
    mutation acceptRequest($input: AcceptRequestInput!) {
  acceptRequestByCommercialDepartment(input: $input) {
    id
  }
}
    `;
export type AcceptRequestMutationFn = Apollo.MutationFunction<AcceptRequestMutation, AcceptRequestMutationVariables>;

/**
 * __useAcceptRequestMutation__
 *
 * To run a mutation, you first call `useAcceptRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptRequestMutation, { data, loading, error }] = useAcceptRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptRequestMutation, AcceptRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptRequestMutation, AcceptRequestMutationVariables>(AcceptRequestDocument, options);
      }
export type AcceptRequestMutationHookResult = ReturnType<typeof useAcceptRequestMutation>;
export type AcceptRequestMutationResult = Apollo.MutationResult<AcceptRequestMutation>;
export type AcceptRequestMutationOptions = Apollo.BaseMutationOptions<AcceptRequestMutation, AcceptRequestMutationVariables>;
export const AcceptRequestBySportObjectDocument = gql`
    mutation acceptRequestBySportObject($input: AcceptRequestBySportObjectInput!) {
  acceptRequestBySportObject(input: $input) {
    ...EquipmentRelocationRequestBasis
  }
}
    ${EquipmentRelocationRequestBasisFragmentDoc}`;
export type AcceptRequestBySportObjectMutationFn = Apollo.MutationFunction<AcceptRequestBySportObjectMutation, AcceptRequestBySportObjectMutationVariables>;

/**
 * __useAcceptRequestBySportObjectMutation__
 *
 * To run a mutation, you first call `useAcceptRequestBySportObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptRequestBySportObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptRequestBySportObjectMutation, { data, loading, error }] = useAcceptRequestBySportObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptRequestBySportObjectMutation(baseOptions?: Apollo.MutationHookOptions<AcceptRequestBySportObjectMutation, AcceptRequestBySportObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptRequestBySportObjectMutation, AcceptRequestBySportObjectMutationVariables>(AcceptRequestBySportObjectDocument, options);
      }
export type AcceptRequestBySportObjectMutationHookResult = ReturnType<typeof useAcceptRequestBySportObjectMutation>;
export type AcceptRequestBySportObjectMutationResult = Apollo.MutationResult<AcceptRequestBySportObjectMutation>;
export type AcceptRequestBySportObjectMutationOptions = Apollo.BaseMutationOptions<AcceptRequestBySportObjectMutation, AcceptRequestBySportObjectMutationVariables>;
export const RejectRequestDocument = gql`
    mutation rejectRequest($input: RejectRequestInput!) {
  rejectRequestByCommercialDepartment(input: $input) {
    id
  }
}
    `;
export type RejectRequestMutationFn = Apollo.MutationFunction<RejectRequestMutation, RejectRequestMutationVariables>;

/**
 * __useRejectRequestMutation__
 *
 * To run a mutation, you first call `useRejectRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRequestMutation, { data, loading, error }] = useRejectRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectRequestMutation, RejectRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectRequestMutation, RejectRequestMutationVariables>(RejectRequestDocument, options);
      }
export type RejectRequestMutationHookResult = ReturnType<typeof useRejectRequestMutation>;
export type RejectRequestMutationResult = Apollo.MutationResult<RejectRequestMutation>;
export type RejectRequestMutationOptions = Apollo.BaseMutationOptions<RejectRequestMutation, RejectRequestMutationVariables>;
export const AcceptByMaintenanceDepartmentDocument = gql`
    mutation acceptByMaintenanceDepartment($input: AcceptByMaintananceDepartmentInput!) {
  acceptByMaintenanceDepartment(input: $input) {
    id
  }
}
    `;
export type AcceptByMaintenanceDepartmentMutationFn = Apollo.MutationFunction<AcceptByMaintenanceDepartmentMutation, AcceptByMaintenanceDepartmentMutationVariables>;

/**
 * __useAcceptByMaintenanceDepartmentMutation__
 *
 * To run a mutation, you first call `useAcceptByMaintenanceDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptByMaintenanceDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptByMaintenanceDepartmentMutation, { data, loading, error }] = useAcceptByMaintenanceDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptByMaintenanceDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<AcceptByMaintenanceDepartmentMutation, AcceptByMaintenanceDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptByMaintenanceDepartmentMutation, AcceptByMaintenanceDepartmentMutationVariables>(AcceptByMaintenanceDepartmentDocument, options);
      }
export type AcceptByMaintenanceDepartmentMutationHookResult = ReturnType<typeof useAcceptByMaintenanceDepartmentMutation>;
export type AcceptByMaintenanceDepartmentMutationResult = Apollo.MutationResult<AcceptByMaintenanceDepartmentMutation>;
export type AcceptByMaintenanceDepartmentMutationOptions = Apollo.BaseMutationOptions<AcceptByMaintenanceDepartmentMutation, AcceptByMaintenanceDepartmentMutationVariables>;
export const RejectRequestByAcceptanceDepartmentDocument = gql`
    mutation rejectRequestByAcceptanceDepartment($input: RejectRequestByAcceptanceDepartmentInput!) {
  rejectRequestByAcceptanceDepartment(input: $input) {
    id
  }
}
    `;
export type RejectRequestByAcceptanceDepartmentMutationFn = Apollo.MutationFunction<RejectRequestByAcceptanceDepartmentMutation, RejectRequestByAcceptanceDepartmentMutationVariables>;

/**
 * __useRejectRequestByAcceptanceDepartmentMutation__
 *
 * To run a mutation, you first call `useRejectRequestByAcceptanceDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRequestByAcceptanceDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRequestByAcceptanceDepartmentMutation, { data, loading, error }] = useRejectRequestByAcceptanceDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectRequestByAcceptanceDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<RejectRequestByAcceptanceDepartmentMutation, RejectRequestByAcceptanceDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectRequestByAcceptanceDepartmentMutation, RejectRequestByAcceptanceDepartmentMutationVariables>(RejectRequestByAcceptanceDepartmentDocument, options);
      }
export type RejectRequestByAcceptanceDepartmentMutationHookResult = ReturnType<typeof useRejectRequestByAcceptanceDepartmentMutation>;
export type RejectRequestByAcceptanceDepartmentMutationResult = Apollo.MutationResult<RejectRequestByAcceptanceDepartmentMutation>;
export type RejectRequestByAcceptanceDepartmentMutationOptions = Apollo.BaseMutationOptions<RejectRequestByAcceptanceDepartmentMutation, RejectRequestByAcceptanceDepartmentMutationVariables>;
export const RelocateEquipmentDocument = gql`
    mutation relocateEquipment($input: RelocateEquipmentInput!) {
  relocateEquipment(input: $input) {
    id
  }
}
    `;
export type RelocateEquipmentMutationFn = Apollo.MutationFunction<RelocateEquipmentMutation, RelocateEquipmentMutationVariables>;

/**
 * __useRelocateEquipmentMutation__
 *
 * To run a mutation, you first call `useRelocateEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelocateEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relocateEquipmentMutation, { data, loading, error }] = useRelocateEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRelocateEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<RelocateEquipmentMutation, RelocateEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RelocateEquipmentMutation, RelocateEquipmentMutationVariables>(RelocateEquipmentDocument, options);
      }
export type RelocateEquipmentMutationHookResult = ReturnType<typeof useRelocateEquipmentMutation>;
export type RelocateEquipmentMutationResult = Apollo.MutationResult<RelocateEquipmentMutation>;
export type RelocateEquipmentMutationOptions = Apollo.BaseMutationOptions<RelocateEquipmentMutation, RelocateEquipmentMutationVariables>;
export const StartEquipmentRelocationDocument = gql`
    mutation startEquipmentRelocation($input: StartEquipmentRelocationInput!) {
  startEquipmentRelocation(input: $input) {
    id
  }
}
    `;
export type StartEquipmentRelocationMutationFn = Apollo.MutationFunction<StartEquipmentRelocationMutation, StartEquipmentRelocationMutationVariables>;

/**
 * __useStartEquipmentRelocationMutation__
 *
 * To run a mutation, you first call `useStartEquipmentRelocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEquipmentRelocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEquipmentRelocationMutation, { data, loading, error }] = useStartEquipmentRelocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartEquipmentRelocationMutation(baseOptions?: Apollo.MutationHookOptions<StartEquipmentRelocationMutation, StartEquipmentRelocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartEquipmentRelocationMutation, StartEquipmentRelocationMutationVariables>(StartEquipmentRelocationDocument, options);
      }
export type StartEquipmentRelocationMutationHookResult = ReturnType<typeof useStartEquipmentRelocationMutation>;
export type StartEquipmentRelocationMutationResult = Apollo.MutationResult<StartEquipmentRelocationMutation>;
export type StartEquipmentRelocationMutationOptions = Apollo.BaseMutationOptions<StartEquipmentRelocationMutation, StartEquipmentRelocationMutationVariables>;
export const GetAllSportKindDictionaryDocument = gql`
    query getAllSportKindDictionary {
  getAllSportKindDictionary {
    sportCategories {
      id
      name
      createdAt
    }
    sportKinds {
      id
      name
      createdAt
      sportCategoryId
      sportCategory {
        name
      }
    }
    equipmentTypes {
      id
      name
      sportKindId
      createdAt
      sportKind {
        name
      }
    }
    equipmentSpecifications {
      equipmentTypeId
    }
  }
}
    `;

/**
 * __useGetAllSportKindDictionaryQuery__
 *
 * To run a query within a React component, call `useGetAllSportKindDictionaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSportKindDictionaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSportKindDictionaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSportKindDictionaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSportKindDictionaryQuery, GetAllSportKindDictionaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSportKindDictionaryQuery, GetAllSportKindDictionaryQueryVariables>(GetAllSportKindDictionaryDocument, options);
      }
export function useGetAllSportKindDictionaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSportKindDictionaryQuery, GetAllSportKindDictionaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSportKindDictionaryQuery, GetAllSportKindDictionaryQueryVariables>(GetAllSportKindDictionaryDocument, options);
        }
export type GetAllSportKindDictionaryQueryHookResult = ReturnType<typeof useGetAllSportKindDictionaryQuery>;
export type GetAllSportKindDictionaryLazyQueryHookResult = ReturnType<typeof useGetAllSportKindDictionaryLazyQuery>;
export type GetAllSportKindDictionaryQueryResult = Apollo.QueryResult<GetAllSportKindDictionaryQuery, GetAllSportKindDictionaryQueryVariables>;
export function refetchGetAllSportKindDictionaryQuery(variables?: GetAllSportKindDictionaryQueryVariables) {
      return { query: GetAllSportKindDictionaryDocument, variables: variables }
    }
export const GetAllSportCategoryDictionaryDocument = gql`
    query getAllSportCategoryDictionary {
  getAllSportCategoryDictionary {
    ...SportCategory
  }
}
    ${SportCategoryFragmentDoc}`;

/**
 * __useGetAllSportCategoryDictionaryQuery__
 *
 * To run a query within a React component, call `useGetAllSportCategoryDictionaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSportCategoryDictionaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSportCategoryDictionaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSportCategoryDictionaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSportCategoryDictionaryQuery, GetAllSportCategoryDictionaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSportCategoryDictionaryQuery, GetAllSportCategoryDictionaryQueryVariables>(GetAllSportCategoryDictionaryDocument, options);
      }
export function useGetAllSportCategoryDictionaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSportCategoryDictionaryQuery, GetAllSportCategoryDictionaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSportCategoryDictionaryQuery, GetAllSportCategoryDictionaryQueryVariables>(GetAllSportCategoryDictionaryDocument, options);
        }
export type GetAllSportCategoryDictionaryQueryHookResult = ReturnType<typeof useGetAllSportCategoryDictionaryQuery>;
export type GetAllSportCategoryDictionaryLazyQueryHookResult = ReturnType<typeof useGetAllSportCategoryDictionaryLazyQuery>;
export type GetAllSportCategoryDictionaryQueryResult = Apollo.QueryResult<GetAllSportCategoryDictionaryQuery, GetAllSportCategoryDictionaryQueryVariables>;
export function refetchGetAllSportCategoryDictionaryQuery(variables?: GetAllSportCategoryDictionaryQueryVariables) {
      return { query: GetAllSportCategoryDictionaryDocument, variables: variables }
    }
export const GetAllDictionariesDocument = gql`
    query getAllDictionaries {
  getAllSportKindDictionary {
    ... on GetAllSportKindsResponse {
      sportCategories {
        id
        name
        createdAt
        sportKinds {
          id
        }
      }
      sportKinds {
        id
        name
        sportCategoryId
        sportCategory {
          name
        }
        createdAt
      }
      equipmentTypes {
        id
        name
        sportKindId
        sportKind {
          name
        }
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetAllDictionariesQuery__
 *
 * To run a query within a React component, call `useGetAllDictionariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDictionariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDictionariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDictionariesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDictionariesQuery, GetAllDictionariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDictionariesQuery, GetAllDictionariesQueryVariables>(GetAllDictionariesDocument, options);
      }
export function useGetAllDictionariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDictionariesQuery, GetAllDictionariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDictionariesQuery, GetAllDictionariesQueryVariables>(GetAllDictionariesDocument, options);
        }
export type GetAllDictionariesQueryHookResult = ReturnType<typeof useGetAllDictionariesQuery>;
export type GetAllDictionariesLazyQueryHookResult = ReturnType<typeof useGetAllDictionariesLazyQuery>;
export type GetAllDictionariesQueryResult = Apollo.QueryResult<GetAllDictionariesQuery, GetAllDictionariesQueryVariables>;
export function refetchGetAllDictionariesQuery(variables?: GetAllDictionariesQueryVariables) {
      return { query: GetAllDictionariesDocument, variables: variables }
    }
export const AddSportCategoryDictionaryDocument = gql`
    mutation addSportCategoryDictionary($input: CreateSportCategoryDictionaryInput!) {
  addSportCategoryDictionary(input: $input) {
    ...SportCategory
  }
}
    ${SportCategoryFragmentDoc}`;
export type AddSportCategoryDictionaryMutationFn = Apollo.MutationFunction<AddSportCategoryDictionaryMutation, AddSportCategoryDictionaryMutationVariables>;

/**
 * __useAddSportCategoryDictionaryMutation__
 *
 * To run a mutation, you first call `useAddSportCategoryDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSportCategoryDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSportCategoryDictionaryMutation, { data, loading, error }] = useAddSportCategoryDictionaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSportCategoryDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<AddSportCategoryDictionaryMutation, AddSportCategoryDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSportCategoryDictionaryMutation, AddSportCategoryDictionaryMutationVariables>(AddSportCategoryDictionaryDocument, options);
      }
export type AddSportCategoryDictionaryMutationHookResult = ReturnType<typeof useAddSportCategoryDictionaryMutation>;
export type AddSportCategoryDictionaryMutationResult = Apollo.MutationResult<AddSportCategoryDictionaryMutation>;
export type AddSportCategoryDictionaryMutationOptions = Apollo.BaseMutationOptions<AddSportCategoryDictionaryMutation, AddSportCategoryDictionaryMutationVariables>;
export const UpdateSportCategoryDictionaryDocument = gql`
    mutation updateSportCategoryDictionary($input: UpdateSportCategoryDictionaryInput!) {
  updateSportCategoryDictionary(input: $input) {
    ...SportCategory
  }
}
    ${SportCategoryFragmentDoc}`;
export type UpdateSportCategoryDictionaryMutationFn = Apollo.MutationFunction<UpdateSportCategoryDictionaryMutation, UpdateSportCategoryDictionaryMutationVariables>;

/**
 * __useUpdateSportCategoryDictionaryMutation__
 *
 * To run a mutation, you first call `useUpdateSportCategoryDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSportCategoryDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSportCategoryDictionaryMutation, { data, loading, error }] = useUpdateSportCategoryDictionaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSportCategoryDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSportCategoryDictionaryMutation, UpdateSportCategoryDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSportCategoryDictionaryMutation, UpdateSportCategoryDictionaryMutationVariables>(UpdateSportCategoryDictionaryDocument, options);
      }
export type UpdateSportCategoryDictionaryMutationHookResult = ReturnType<typeof useUpdateSportCategoryDictionaryMutation>;
export type UpdateSportCategoryDictionaryMutationResult = Apollo.MutationResult<UpdateSportCategoryDictionaryMutation>;
export type UpdateSportCategoryDictionaryMutationOptions = Apollo.BaseMutationOptions<UpdateSportCategoryDictionaryMutation, UpdateSportCategoryDictionaryMutationVariables>;
export const DeleteSportCategoryDictionaryDocument = gql`
    mutation deleteSportCategoryDictionary($id: String!) {
  deleteSportCategoryDictionary(id: $id)
}
    `;
export type DeleteSportCategoryDictionaryMutationFn = Apollo.MutationFunction<DeleteSportCategoryDictionaryMutation, DeleteSportCategoryDictionaryMutationVariables>;

/**
 * __useDeleteSportCategoryDictionaryMutation__
 *
 * To run a mutation, you first call `useDeleteSportCategoryDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSportCategoryDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSportCategoryDictionaryMutation, { data, loading, error }] = useDeleteSportCategoryDictionaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSportCategoryDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSportCategoryDictionaryMutation, DeleteSportCategoryDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSportCategoryDictionaryMutation, DeleteSportCategoryDictionaryMutationVariables>(DeleteSportCategoryDictionaryDocument, options);
      }
export type DeleteSportCategoryDictionaryMutationHookResult = ReturnType<typeof useDeleteSportCategoryDictionaryMutation>;
export type DeleteSportCategoryDictionaryMutationResult = Apollo.MutationResult<DeleteSportCategoryDictionaryMutation>;
export type DeleteSportCategoryDictionaryMutationOptions = Apollo.BaseMutationOptions<DeleteSportCategoryDictionaryMutation, DeleteSportCategoryDictionaryMutationVariables>;
export const AddSportKindDictionaryDocument = gql`
    mutation addSportKindDictionary($input: CreateSportKindDictionaryInput!) {
  addSportKindDictionary(input: $input) {
    id
  }
}
    `;
export type AddSportKindDictionaryMutationFn = Apollo.MutationFunction<AddSportKindDictionaryMutation, AddSportKindDictionaryMutationVariables>;

/**
 * __useAddSportKindDictionaryMutation__
 *
 * To run a mutation, you first call `useAddSportKindDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSportKindDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSportKindDictionaryMutation, { data, loading, error }] = useAddSportKindDictionaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSportKindDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<AddSportKindDictionaryMutation, AddSportKindDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSportKindDictionaryMutation, AddSportKindDictionaryMutationVariables>(AddSportKindDictionaryDocument, options);
      }
export type AddSportKindDictionaryMutationHookResult = ReturnType<typeof useAddSportKindDictionaryMutation>;
export type AddSportKindDictionaryMutationResult = Apollo.MutationResult<AddSportKindDictionaryMutation>;
export type AddSportKindDictionaryMutationOptions = Apollo.BaseMutationOptions<AddSportKindDictionaryMutation, AddSportKindDictionaryMutationVariables>;
export const UpdateSportKindDictionaryDocument = gql`
    mutation updateSportKindDictionary($input: UpdateSportKindDictionaryInput!) {
  updateSportKindDictionary(input: $input) {
    id
  }
}
    `;
export type UpdateSportKindDictionaryMutationFn = Apollo.MutationFunction<UpdateSportKindDictionaryMutation, UpdateSportKindDictionaryMutationVariables>;

/**
 * __useUpdateSportKindDictionaryMutation__
 *
 * To run a mutation, you first call `useUpdateSportKindDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSportKindDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSportKindDictionaryMutation, { data, loading, error }] = useUpdateSportKindDictionaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSportKindDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSportKindDictionaryMutation, UpdateSportKindDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSportKindDictionaryMutation, UpdateSportKindDictionaryMutationVariables>(UpdateSportKindDictionaryDocument, options);
      }
export type UpdateSportKindDictionaryMutationHookResult = ReturnType<typeof useUpdateSportKindDictionaryMutation>;
export type UpdateSportKindDictionaryMutationResult = Apollo.MutationResult<UpdateSportKindDictionaryMutation>;
export type UpdateSportKindDictionaryMutationOptions = Apollo.BaseMutationOptions<UpdateSportKindDictionaryMutation, UpdateSportKindDictionaryMutationVariables>;
export const DeleteSportKindDictionaryDocument = gql`
    mutation deleteSportKindDictionary($id: String!) {
  deleteSportKindDictionary(id: $id)
}
    `;
export type DeleteSportKindDictionaryMutationFn = Apollo.MutationFunction<DeleteSportKindDictionaryMutation, DeleteSportKindDictionaryMutationVariables>;

/**
 * __useDeleteSportKindDictionaryMutation__
 *
 * To run a mutation, you first call `useDeleteSportKindDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSportKindDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSportKindDictionaryMutation, { data, loading, error }] = useDeleteSportKindDictionaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSportKindDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSportKindDictionaryMutation, DeleteSportKindDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSportKindDictionaryMutation, DeleteSportKindDictionaryMutationVariables>(DeleteSportKindDictionaryDocument, options);
      }
export type DeleteSportKindDictionaryMutationHookResult = ReturnType<typeof useDeleteSportKindDictionaryMutation>;
export type DeleteSportKindDictionaryMutationResult = Apollo.MutationResult<DeleteSportKindDictionaryMutation>;
export type DeleteSportKindDictionaryMutationOptions = Apollo.BaseMutationOptions<DeleteSportKindDictionaryMutation, DeleteSportKindDictionaryMutationVariables>;
export const GetAllEquipmentTypeDictionaryDocument = gql`
    query getAllEquipmentTypeDictionary {
  getAllEquipmentTypeDictionary {
    id
    name
    createdAt
    sportKind {
      id
      name
      sportCategoryId
    }
  }
}
    `;

/**
 * __useGetAllEquipmentTypeDictionaryQuery__
 *
 * To run a query within a React component, call `useGetAllEquipmentTypeDictionaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEquipmentTypeDictionaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEquipmentTypeDictionaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEquipmentTypeDictionaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEquipmentTypeDictionaryQuery, GetAllEquipmentTypeDictionaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEquipmentTypeDictionaryQuery, GetAllEquipmentTypeDictionaryQueryVariables>(GetAllEquipmentTypeDictionaryDocument, options);
      }
export function useGetAllEquipmentTypeDictionaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEquipmentTypeDictionaryQuery, GetAllEquipmentTypeDictionaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEquipmentTypeDictionaryQuery, GetAllEquipmentTypeDictionaryQueryVariables>(GetAllEquipmentTypeDictionaryDocument, options);
        }
export type GetAllEquipmentTypeDictionaryQueryHookResult = ReturnType<typeof useGetAllEquipmentTypeDictionaryQuery>;
export type GetAllEquipmentTypeDictionaryLazyQueryHookResult = ReturnType<typeof useGetAllEquipmentTypeDictionaryLazyQuery>;
export type GetAllEquipmentTypeDictionaryQueryResult = Apollo.QueryResult<GetAllEquipmentTypeDictionaryQuery, GetAllEquipmentTypeDictionaryQueryVariables>;
export function refetchGetAllEquipmentTypeDictionaryQuery(variables?: GetAllEquipmentTypeDictionaryQueryVariables) {
      return { query: GetAllEquipmentTypeDictionaryDocument, variables: variables }
    }
export const GetEquipmentTypeDictionaryBySportKindIdDocument = gql`
    query getEquipmentTypeDictionaryBySportKindId($id: String!) {
  getEquipmentTypeDictionaryBySportKindId(sportKindId: $id) {
    id
    name
    createdAt
    sportKind {
      id
      name
      sportCategoryId
    }
  }
}
    `;

/**
 * __useGetEquipmentTypeDictionaryBySportKindIdQuery__
 *
 * To run a query within a React component, call `useGetEquipmentTypeDictionaryBySportKindIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentTypeDictionaryBySportKindIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentTypeDictionaryBySportKindIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEquipmentTypeDictionaryBySportKindIdQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentTypeDictionaryBySportKindIdQuery, GetEquipmentTypeDictionaryBySportKindIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentTypeDictionaryBySportKindIdQuery, GetEquipmentTypeDictionaryBySportKindIdQueryVariables>(GetEquipmentTypeDictionaryBySportKindIdDocument, options);
      }
export function useGetEquipmentTypeDictionaryBySportKindIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentTypeDictionaryBySportKindIdQuery, GetEquipmentTypeDictionaryBySportKindIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentTypeDictionaryBySportKindIdQuery, GetEquipmentTypeDictionaryBySportKindIdQueryVariables>(GetEquipmentTypeDictionaryBySportKindIdDocument, options);
        }
export type GetEquipmentTypeDictionaryBySportKindIdQueryHookResult = ReturnType<typeof useGetEquipmentTypeDictionaryBySportKindIdQuery>;
export type GetEquipmentTypeDictionaryBySportKindIdLazyQueryHookResult = ReturnType<typeof useGetEquipmentTypeDictionaryBySportKindIdLazyQuery>;
export type GetEquipmentTypeDictionaryBySportKindIdQueryResult = Apollo.QueryResult<GetEquipmentTypeDictionaryBySportKindIdQuery, GetEquipmentTypeDictionaryBySportKindIdQueryVariables>;
export function refetchGetEquipmentTypeDictionaryBySportKindIdQuery(variables: GetEquipmentTypeDictionaryBySportKindIdQueryVariables) {
      return { query: GetEquipmentTypeDictionaryBySportKindIdDocument, variables: variables }
    }
export const AddEquipmentTypeDictionaryDocument = gql`
    mutation addEquipmentTypeDictionary($input: CreateEquipmentTypeDictionaryInput!) {
  addEquipmentTypeDictionary(input: $input) {
    id
  }
}
    `;
export type AddEquipmentTypeDictionaryMutationFn = Apollo.MutationFunction<AddEquipmentTypeDictionaryMutation, AddEquipmentTypeDictionaryMutationVariables>;

/**
 * __useAddEquipmentTypeDictionaryMutation__
 *
 * To run a mutation, you first call `useAddEquipmentTypeDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEquipmentTypeDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEquipmentTypeDictionaryMutation, { data, loading, error }] = useAddEquipmentTypeDictionaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEquipmentTypeDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<AddEquipmentTypeDictionaryMutation, AddEquipmentTypeDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEquipmentTypeDictionaryMutation, AddEquipmentTypeDictionaryMutationVariables>(AddEquipmentTypeDictionaryDocument, options);
      }
export type AddEquipmentTypeDictionaryMutationHookResult = ReturnType<typeof useAddEquipmentTypeDictionaryMutation>;
export type AddEquipmentTypeDictionaryMutationResult = Apollo.MutationResult<AddEquipmentTypeDictionaryMutation>;
export type AddEquipmentTypeDictionaryMutationOptions = Apollo.BaseMutationOptions<AddEquipmentTypeDictionaryMutation, AddEquipmentTypeDictionaryMutationVariables>;
export const UpdateEquipmentTypeDictionaryDocument = gql`
    mutation updateEquipmentTypeDictionary($input: UpdateEquipmentTypeDictionaryInput!) {
  updateEquipmentTypeDictionary(input: $input) {
    id
  }
}
    `;
export type UpdateEquipmentTypeDictionaryMutationFn = Apollo.MutationFunction<UpdateEquipmentTypeDictionaryMutation, UpdateEquipmentTypeDictionaryMutationVariables>;

/**
 * __useUpdateEquipmentTypeDictionaryMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentTypeDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentTypeDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentTypeDictionaryMutation, { data, loading, error }] = useUpdateEquipmentTypeDictionaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEquipmentTypeDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentTypeDictionaryMutation, UpdateEquipmentTypeDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentTypeDictionaryMutation, UpdateEquipmentTypeDictionaryMutationVariables>(UpdateEquipmentTypeDictionaryDocument, options);
      }
export type UpdateEquipmentTypeDictionaryMutationHookResult = ReturnType<typeof useUpdateEquipmentTypeDictionaryMutation>;
export type UpdateEquipmentTypeDictionaryMutationResult = Apollo.MutationResult<UpdateEquipmentTypeDictionaryMutation>;
export type UpdateEquipmentTypeDictionaryMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentTypeDictionaryMutation, UpdateEquipmentTypeDictionaryMutationVariables>;
export const DeleteEquipmentTypeDictionaryDocument = gql`
    mutation deleteEquipmentTypeDictionary($id: String!) {
  deleteEquipmentTypeDictionary(id: $id)
}
    `;
export type DeleteEquipmentTypeDictionaryMutationFn = Apollo.MutationFunction<DeleteEquipmentTypeDictionaryMutation, DeleteEquipmentTypeDictionaryMutationVariables>;

/**
 * __useDeleteEquipmentTypeDictionaryMutation__
 *
 * To run a mutation, you first call `useDeleteEquipmentTypeDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEquipmentTypeDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEquipmentTypeDictionaryMutation, { data, loading, error }] = useDeleteEquipmentTypeDictionaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEquipmentTypeDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEquipmentTypeDictionaryMutation, DeleteEquipmentTypeDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEquipmentTypeDictionaryMutation, DeleteEquipmentTypeDictionaryMutationVariables>(DeleteEquipmentTypeDictionaryDocument, options);
      }
export type DeleteEquipmentTypeDictionaryMutationHookResult = ReturnType<typeof useDeleteEquipmentTypeDictionaryMutation>;
export type DeleteEquipmentTypeDictionaryMutationResult = Apollo.MutationResult<DeleteEquipmentTypeDictionaryMutation>;
export type DeleteEquipmentTypeDictionaryMutationOptions = Apollo.BaseMutationOptions<DeleteEquipmentTypeDictionaryMutation, DeleteEquipmentTypeDictionaryMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($input: UpdateUserSettingsInput!) {
  updateUserSettings(input: $input) {
    id
  }
}
    `;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const GetAllEquipmentSpecificationDictionaryDocument = gql`
    query getAllEquipmentSpecificationDictionary {
  getAllEquipmentSpecificationDictionary {
    id
    name
    equipmentType {
      id
      name
    }
    createdAt
  }
}
    `;

/**
 * __useGetAllEquipmentSpecificationDictionaryQuery__
 *
 * To run a query within a React component, call `useGetAllEquipmentSpecificationDictionaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEquipmentSpecificationDictionaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEquipmentSpecificationDictionaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEquipmentSpecificationDictionaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEquipmentSpecificationDictionaryQuery, GetAllEquipmentSpecificationDictionaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEquipmentSpecificationDictionaryQuery, GetAllEquipmentSpecificationDictionaryQueryVariables>(GetAllEquipmentSpecificationDictionaryDocument, options);
      }
export function useGetAllEquipmentSpecificationDictionaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEquipmentSpecificationDictionaryQuery, GetAllEquipmentSpecificationDictionaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEquipmentSpecificationDictionaryQuery, GetAllEquipmentSpecificationDictionaryQueryVariables>(GetAllEquipmentSpecificationDictionaryDocument, options);
        }
export type GetAllEquipmentSpecificationDictionaryQueryHookResult = ReturnType<typeof useGetAllEquipmentSpecificationDictionaryQuery>;
export type GetAllEquipmentSpecificationDictionaryLazyQueryHookResult = ReturnType<typeof useGetAllEquipmentSpecificationDictionaryLazyQuery>;
export type GetAllEquipmentSpecificationDictionaryQueryResult = Apollo.QueryResult<GetAllEquipmentSpecificationDictionaryQuery, GetAllEquipmentSpecificationDictionaryQueryVariables>;
export function refetchGetAllEquipmentSpecificationDictionaryQuery(variables?: GetAllEquipmentSpecificationDictionaryQueryVariables) {
      return { query: GetAllEquipmentSpecificationDictionaryDocument, variables: variables }
    }
export const GetEquipmentSpecificationDictionaryByEquipmentTypeIdDocument = gql`
    query getEquipmentSpecificationDictionaryByEquipmentTypeId($equipmentTypeId: String!) {
  getEquipmentSpecificationDictionaryByEquipmentTypeId(
    equipmentTypeId: $equipmentTypeId
  ) {
    id
    name
    equipmentType {
      id
      name
    }
    createdAt
  }
}
    `;

/**
 * __useGetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery__
 *
 * To run a query within a React component, call `useGetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery({
 *   variables: {
 *      equipmentTypeId: // value for 'equipmentTypeId'
 *   },
 * });
 */
export function useGetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery, GetEquipmentSpecificationDictionaryByEquipmentTypeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery, GetEquipmentSpecificationDictionaryByEquipmentTypeIdQueryVariables>(GetEquipmentSpecificationDictionaryByEquipmentTypeIdDocument, options);
      }
export function useGetEquipmentSpecificationDictionaryByEquipmentTypeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery, GetEquipmentSpecificationDictionaryByEquipmentTypeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery, GetEquipmentSpecificationDictionaryByEquipmentTypeIdQueryVariables>(GetEquipmentSpecificationDictionaryByEquipmentTypeIdDocument, options);
        }
export type GetEquipmentSpecificationDictionaryByEquipmentTypeIdQueryHookResult = ReturnType<typeof useGetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery>;
export type GetEquipmentSpecificationDictionaryByEquipmentTypeIdLazyQueryHookResult = ReturnType<typeof useGetEquipmentSpecificationDictionaryByEquipmentTypeIdLazyQuery>;
export type GetEquipmentSpecificationDictionaryByEquipmentTypeIdQueryResult = Apollo.QueryResult<GetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery, GetEquipmentSpecificationDictionaryByEquipmentTypeIdQueryVariables>;
export function refetchGetEquipmentSpecificationDictionaryByEquipmentTypeIdQuery(variables: GetEquipmentSpecificationDictionaryByEquipmentTypeIdQueryVariables) {
      return { query: GetEquipmentSpecificationDictionaryByEquipmentTypeIdDocument, variables: variables }
    }
export const AddEquipmentSpecificationDictionaryDocument = gql`
    mutation addEquipmentSpecificationDictionary($input: CreateEquipmentSpecificationDictionaryInput!) {
  addEquipmentSpecificationDictionary(input: $input) {
    id
  }
}
    `;
export type AddEquipmentSpecificationDictionaryMutationFn = Apollo.MutationFunction<AddEquipmentSpecificationDictionaryMutation, AddEquipmentSpecificationDictionaryMutationVariables>;

/**
 * __useAddEquipmentSpecificationDictionaryMutation__
 *
 * To run a mutation, you first call `useAddEquipmentSpecificationDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEquipmentSpecificationDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEquipmentSpecificationDictionaryMutation, { data, loading, error }] = useAddEquipmentSpecificationDictionaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEquipmentSpecificationDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<AddEquipmentSpecificationDictionaryMutation, AddEquipmentSpecificationDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEquipmentSpecificationDictionaryMutation, AddEquipmentSpecificationDictionaryMutationVariables>(AddEquipmentSpecificationDictionaryDocument, options);
      }
export type AddEquipmentSpecificationDictionaryMutationHookResult = ReturnType<typeof useAddEquipmentSpecificationDictionaryMutation>;
export type AddEquipmentSpecificationDictionaryMutationResult = Apollo.MutationResult<AddEquipmentSpecificationDictionaryMutation>;
export type AddEquipmentSpecificationDictionaryMutationOptions = Apollo.BaseMutationOptions<AddEquipmentSpecificationDictionaryMutation, AddEquipmentSpecificationDictionaryMutationVariables>;
export const UpdateEquipmentSpecificationDictionaryDocument = gql`
    mutation updateEquipmentSpecificationDictionary($input: UpdateEquipmentSpecificationDictionaryInput!) {
  updateEquipmentSpecificationDictionary(input: $input) {
    id
  }
}
    `;
export type UpdateEquipmentSpecificationDictionaryMutationFn = Apollo.MutationFunction<UpdateEquipmentSpecificationDictionaryMutation, UpdateEquipmentSpecificationDictionaryMutationVariables>;

/**
 * __useUpdateEquipmentSpecificationDictionaryMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentSpecificationDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentSpecificationDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentSpecificationDictionaryMutation, { data, loading, error }] = useUpdateEquipmentSpecificationDictionaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEquipmentSpecificationDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentSpecificationDictionaryMutation, UpdateEquipmentSpecificationDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentSpecificationDictionaryMutation, UpdateEquipmentSpecificationDictionaryMutationVariables>(UpdateEquipmentSpecificationDictionaryDocument, options);
      }
export type UpdateEquipmentSpecificationDictionaryMutationHookResult = ReturnType<typeof useUpdateEquipmentSpecificationDictionaryMutation>;
export type UpdateEquipmentSpecificationDictionaryMutationResult = Apollo.MutationResult<UpdateEquipmentSpecificationDictionaryMutation>;
export type UpdateEquipmentSpecificationDictionaryMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentSpecificationDictionaryMutation, UpdateEquipmentSpecificationDictionaryMutationVariables>;
export const DeleteEquipmentSpecificationDictionaryDocument = gql`
    mutation deleteEquipmentSpecificationDictionary($id: String!) {
  deleteEquipmentSpecificationDictionary(id: $id)
}
    `;
export type DeleteEquipmentSpecificationDictionaryMutationFn = Apollo.MutationFunction<DeleteEquipmentSpecificationDictionaryMutation, DeleteEquipmentSpecificationDictionaryMutationVariables>;

/**
 * __useDeleteEquipmentSpecificationDictionaryMutation__
 *
 * To run a mutation, you first call `useDeleteEquipmentSpecificationDictionaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEquipmentSpecificationDictionaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEquipmentSpecificationDictionaryMutation, { data, loading, error }] = useDeleteEquipmentSpecificationDictionaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEquipmentSpecificationDictionaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEquipmentSpecificationDictionaryMutation, DeleteEquipmentSpecificationDictionaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEquipmentSpecificationDictionaryMutation, DeleteEquipmentSpecificationDictionaryMutationVariables>(DeleteEquipmentSpecificationDictionaryDocument, options);
      }
export type DeleteEquipmentSpecificationDictionaryMutationHookResult = ReturnType<typeof useDeleteEquipmentSpecificationDictionaryMutation>;
export type DeleteEquipmentSpecificationDictionaryMutationResult = Apollo.MutationResult<DeleteEquipmentSpecificationDictionaryMutation>;
export type DeleteEquipmentSpecificationDictionaryMutationOptions = Apollo.BaseMutationOptions<DeleteEquipmentSpecificationDictionaryMutation, DeleteEquipmentSpecificationDictionaryMutationVariables>;
export const GetSpecificationsDocument = gql`
    query getSpecifications {
  getSpecifications {
    id
    name
    specificationType
    specificationListValues {
      id
      name
      value
    }
    unit {
      id
      name
      shortName
    }
  }
}
    `;

/**
 * __useGetSpecificationsQuery__
 *
 * To run a query within a React component, call `useGetSpecificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSpecificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetSpecificationsQuery, GetSpecificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecificationsQuery, GetSpecificationsQueryVariables>(GetSpecificationsDocument, options);
      }
export function useGetSpecificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecificationsQuery, GetSpecificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecificationsQuery, GetSpecificationsQueryVariables>(GetSpecificationsDocument, options);
        }
export type GetSpecificationsQueryHookResult = ReturnType<typeof useGetSpecificationsQuery>;
export type GetSpecificationsLazyQueryHookResult = ReturnType<typeof useGetSpecificationsLazyQuery>;
export type GetSpecificationsQueryResult = Apollo.QueryResult<GetSpecificationsQuery, GetSpecificationsQueryVariables>;
export function refetchGetSpecificationsQuery(variables?: GetSpecificationsQueryVariables) {
      return { query: GetSpecificationsDocument, variables: variables }
    }
export const SetMainPhotoDocument = gql`
    mutation setMainPhoto($input: SetMainPhotoInput!) {
  setMainPhoto(input: $input)
}
    `;
export type SetMainPhotoMutationFn = Apollo.MutationFunction<SetMainPhotoMutation, SetMainPhotoMutationVariables>;

/**
 * __useSetMainPhotoMutation__
 *
 * To run a mutation, you first call `useSetMainPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMainPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMainPhotoMutation, { data, loading, error }] = useSetMainPhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMainPhotoMutation(baseOptions?: Apollo.MutationHookOptions<SetMainPhotoMutation, SetMainPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMainPhotoMutation, SetMainPhotoMutationVariables>(SetMainPhotoDocument, options);
      }
export type SetMainPhotoMutationHookResult = ReturnType<typeof useSetMainPhotoMutation>;
export type SetMainPhotoMutationResult = Apollo.MutationResult<SetMainPhotoMutation>;
export type SetMainPhotoMutationOptions = Apollo.BaseMutationOptions<SetMainPhotoMutation, SetMainPhotoMutationVariables>;
export const ChangeCategoriesDocument = gql`
    mutation changeCategories($input: ChangeCategoriesInput!) {
  changeCategories(input: $input)
}
    `;
export type ChangeCategoriesMutationFn = Apollo.MutationFunction<ChangeCategoriesMutation, ChangeCategoriesMutationVariables>;

/**
 * __useChangeCategoriesMutation__
 *
 * To run a mutation, you first call `useChangeCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCategoriesMutation, { data, loading, error }] = useChangeCategoriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCategoriesMutation, ChangeCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCategoriesMutation, ChangeCategoriesMutationVariables>(ChangeCategoriesDocument, options);
      }
export type ChangeCategoriesMutationHookResult = ReturnType<typeof useChangeCategoriesMutation>;
export type ChangeCategoriesMutationResult = Apollo.MutationResult<ChangeCategoriesMutation>;
export type ChangeCategoriesMutationOptions = Apollo.BaseMutationOptions<ChangeCategoriesMutation, ChangeCategoriesMutationVariables>;
export const ChangeSportObjectDocument = gql`
    mutation changeSportObject($input: ChangeSportObjectInput!) {
  changeSportObject(input: $input)
}
    `;
export type ChangeSportObjectMutationFn = Apollo.MutationFunction<ChangeSportObjectMutation, ChangeSportObjectMutationVariables>;

/**
 * __useChangeSportObjectMutation__
 *
 * To run a mutation, you first call `useChangeSportObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSportObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSportObjectMutation, { data, loading, error }] = useChangeSportObjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeSportObjectMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSportObjectMutation, ChangeSportObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSportObjectMutation, ChangeSportObjectMutationVariables>(ChangeSportObjectDocument, options);
      }
export type ChangeSportObjectMutationHookResult = ReturnType<typeof useChangeSportObjectMutation>;
export type ChangeSportObjectMutationResult = Apollo.MutationResult<ChangeSportObjectMutation>;
export type ChangeSportObjectMutationOptions = Apollo.BaseMutationOptions<ChangeSportObjectMutation, ChangeSportObjectMutationVariables>;
export const GetCoordsByAddressDocument = gql`
    query getCoordsByAddress($address: String!) {
  getCoordsByAddress(address: $address) {
    address
    longitude
    latitude
  }
}
    `;

/**
 * __useGetCoordsByAddressQuery__
 *
 * To run a query within a React component, call `useGetCoordsByAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoordsByAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoordsByAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetCoordsByAddressQuery(baseOptions: Apollo.QueryHookOptions<GetCoordsByAddressQuery, GetCoordsByAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoordsByAddressQuery, GetCoordsByAddressQueryVariables>(GetCoordsByAddressDocument, options);
      }
export function useGetCoordsByAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoordsByAddressQuery, GetCoordsByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoordsByAddressQuery, GetCoordsByAddressQueryVariables>(GetCoordsByAddressDocument, options);
        }
export type GetCoordsByAddressQueryHookResult = ReturnType<typeof useGetCoordsByAddressQuery>;
export type GetCoordsByAddressLazyQueryHookResult = ReturnType<typeof useGetCoordsByAddressLazyQuery>;
export type GetCoordsByAddressQueryResult = Apollo.QueryResult<GetCoordsByAddressQuery, GetCoordsByAddressQueryVariables>;
export function refetchGetCoordsByAddressQuery(variables: GetCoordsByAddressQueryVariables) {
      return { query: GetCoordsByAddressDocument, variables: variables }
    }
export const ExportEquipmentRequestsDocument = gql`
    mutation ExportEquipmentRequests($ids: [String!], $order: SortOrder) {
  exportedFile: exportEquipmentRequests(equipmentRequestIds: $ids, order: $order) {
    id
    ext
    name
    url
    description
    createdAt
  }
}
    `;
export type ExportEquipmentRequestsMutationFn = Apollo.MutationFunction<ExportEquipmentRequestsMutation, ExportEquipmentRequestsMutationVariables>;

/**
 * __useExportEquipmentRequestsMutation__
 *
 * To run a mutation, you first call `useExportEquipmentRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEquipmentRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEquipmentRequestsMutation, { data, loading, error }] = useExportEquipmentRequestsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useExportEquipmentRequestsMutation(baseOptions?: Apollo.MutationHookOptions<ExportEquipmentRequestsMutation, ExportEquipmentRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEquipmentRequestsMutation, ExportEquipmentRequestsMutationVariables>(ExportEquipmentRequestsDocument, options);
      }
export type ExportEquipmentRequestsMutationHookResult = ReturnType<typeof useExportEquipmentRequestsMutation>;
export type ExportEquipmentRequestsMutationResult = Apollo.MutationResult<ExportEquipmentRequestsMutation>;
export type ExportEquipmentRequestsMutationOptions = Apollo.BaseMutationOptions<ExportEquipmentRequestsMutation, ExportEquipmentRequestsMutationVariables>;
export const EquipmentRequestsAcceptForProcessingDocument = gql`
    mutation EquipmentRequestsAcceptForProcessing($input: EquipmentRequestsAcceptForProcessingInput!) {
  equipmentRequestsAcceptForProcessing(input: $input) {
    id
  }
}
    `;
export type EquipmentRequestsAcceptForProcessingMutationFn = Apollo.MutationFunction<EquipmentRequestsAcceptForProcessingMutation, EquipmentRequestsAcceptForProcessingMutationVariables>;

/**
 * __useEquipmentRequestsAcceptForProcessingMutation__
 *
 * To run a mutation, you first call `useEquipmentRequestsAcceptForProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipmentRequestsAcceptForProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipmentRequestsAcceptForProcessingMutation, { data, loading, error }] = useEquipmentRequestsAcceptForProcessingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipmentRequestsAcceptForProcessingMutation(baseOptions?: Apollo.MutationHookOptions<EquipmentRequestsAcceptForProcessingMutation, EquipmentRequestsAcceptForProcessingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EquipmentRequestsAcceptForProcessingMutation, EquipmentRequestsAcceptForProcessingMutationVariables>(EquipmentRequestsAcceptForProcessingDocument, options);
      }
export type EquipmentRequestsAcceptForProcessingMutationHookResult = ReturnType<typeof useEquipmentRequestsAcceptForProcessingMutation>;
export type EquipmentRequestsAcceptForProcessingMutationResult = Apollo.MutationResult<EquipmentRequestsAcceptForProcessingMutation>;
export type EquipmentRequestsAcceptForProcessingMutationOptions = Apollo.BaseMutationOptions<EquipmentRequestsAcceptForProcessingMutation, EquipmentRequestsAcceptForProcessingMutationVariables>;
export const DeleteCombinedEquipmentRequestDocument = gql`
    mutation deleteCombinedEquipmentRequest($id: String!) {
  deleteCombinedEquipmentRequest(id: $id)
}
    `;
export type DeleteCombinedEquipmentRequestMutationFn = Apollo.MutationFunction<DeleteCombinedEquipmentRequestMutation, DeleteCombinedEquipmentRequestMutationVariables>;

/**
 * __useDeleteCombinedEquipmentRequestMutation__
 *
 * To run a mutation, you first call `useDeleteCombinedEquipmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCombinedEquipmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCombinedEquipmentRequestMutation, { data, loading, error }] = useDeleteCombinedEquipmentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCombinedEquipmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCombinedEquipmentRequestMutation, DeleteCombinedEquipmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCombinedEquipmentRequestMutation, DeleteCombinedEquipmentRequestMutationVariables>(DeleteCombinedEquipmentRequestDocument, options);
      }
export type DeleteCombinedEquipmentRequestMutationHookResult = ReturnType<typeof useDeleteCombinedEquipmentRequestMutation>;
export type DeleteCombinedEquipmentRequestMutationResult = Apollo.MutationResult<DeleteCombinedEquipmentRequestMutation>;
export type DeleteCombinedEquipmentRequestMutationOptions = Apollo.BaseMutationOptions<DeleteCombinedEquipmentRequestMutation, DeleteCombinedEquipmentRequestMutationVariables>;
export const UpdateCombinedEquipmentRequestDocument = gql`
    mutation updateCombinedEquipmentRequest($input: UpdateCombinedEquipmentRequestInput!) {
  updateCombinedEquipmentRequest(input: $input) {
    id
  }
}
    `;
export type UpdateCombinedEquipmentRequestMutationFn = Apollo.MutationFunction<UpdateCombinedEquipmentRequestMutation, UpdateCombinedEquipmentRequestMutationVariables>;

/**
 * __useUpdateCombinedEquipmentRequestMutation__
 *
 * To run a mutation, you first call `useUpdateCombinedEquipmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCombinedEquipmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCombinedEquipmentRequestMutation, { data, loading, error }] = useUpdateCombinedEquipmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCombinedEquipmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCombinedEquipmentRequestMutation, UpdateCombinedEquipmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCombinedEquipmentRequestMutation, UpdateCombinedEquipmentRequestMutationVariables>(UpdateCombinedEquipmentRequestDocument, options);
      }
export type UpdateCombinedEquipmentRequestMutationHookResult = ReturnType<typeof useUpdateCombinedEquipmentRequestMutation>;
export type UpdateCombinedEquipmentRequestMutationResult = Apollo.MutationResult<UpdateCombinedEquipmentRequestMutation>;
export type UpdateCombinedEquipmentRequestMutationOptions = Apollo.BaseMutationOptions<UpdateCombinedEquipmentRequestMutation, UpdateCombinedEquipmentRequestMutationVariables>;
export const CreateCombinedEquipmentRequestDocument = gql`
    mutation createCombinedEquipmentRequest($input: CombineRequestsInput!) {
  createCombinedEquipmentRequest(input: $input) {
    id
  }
}
    `;
export type CreateCombinedEquipmentRequestMutationFn = Apollo.MutationFunction<CreateCombinedEquipmentRequestMutation, CreateCombinedEquipmentRequestMutationVariables>;

/**
 * __useCreateCombinedEquipmentRequestMutation__
 *
 * To run a mutation, you first call `useCreateCombinedEquipmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCombinedEquipmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCombinedEquipmentRequestMutation, { data, loading, error }] = useCreateCombinedEquipmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCombinedEquipmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateCombinedEquipmentRequestMutation, CreateCombinedEquipmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCombinedEquipmentRequestMutation, CreateCombinedEquipmentRequestMutationVariables>(CreateCombinedEquipmentRequestDocument, options);
      }
export type CreateCombinedEquipmentRequestMutationHookResult = ReturnType<typeof useCreateCombinedEquipmentRequestMutation>;
export type CreateCombinedEquipmentRequestMutationResult = Apollo.MutationResult<CreateCombinedEquipmentRequestMutation>;
export type CreateCombinedEquipmentRequestMutationOptions = Apollo.BaseMutationOptions<CreateCombinedEquipmentRequestMutation, CreateCombinedEquipmentRequestMutationVariables>;
export const GetEquipmentRequestsDocument = gql`
    query getEquipmentRequests($input: GetEquipmentRequestsInput!) {
  getEquipmentRequests(input: $input) {
    ...GetEquipmentRequests
  }
}
    ${GetEquipmentRequestsFragmentDoc}`;

/**
 * __useGetEquipmentRequestsQuery__
 *
 * To run a query within a React component, call `useGetEquipmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentRequestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEquipmentRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentRequestsQuery, GetEquipmentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentRequestsQuery, GetEquipmentRequestsQueryVariables>(GetEquipmentRequestsDocument, options);
      }
export function useGetEquipmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentRequestsQuery, GetEquipmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentRequestsQuery, GetEquipmentRequestsQueryVariables>(GetEquipmentRequestsDocument, options);
        }
export type GetEquipmentRequestsQueryHookResult = ReturnType<typeof useGetEquipmentRequestsQuery>;
export type GetEquipmentRequestsLazyQueryHookResult = ReturnType<typeof useGetEquipmentRequestsLazyQuery>;
export type GetEquipmentRequestsQueryResult = Apollo.QueryResult<GetEquipmentRequestsQuery, GetEquipmentRequestsQueryVariables>;
export function refetchGetEquipmentRequestsQuery(variables: GetEquipmentRequestsQueryVariables) {
      return { query: GetEquipmentRequestsDocument, variables: variables }
    }
export const GetCombinedEquipmentRequestByIdDocument = gql`
    query getCombinedEquipmentRequestById($id: String!) {
  getCombinedEquipmentRequestById(id: $id) {
    ...CombinedEquipmentRequest
  }
}
    ${CombinedEquipmentRequestFragmentDoc}`;

/**
 * __useGetCombinedEquipmentRequestByIdQuery__
 *
 * To run a query within a React component, call `useGetCombinedEquipmentRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCombinedEquipmentRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCombinedEquipmentRequestByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCombinedEquipmentRequestByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCombinedEquipmentRequestByIdQuery, GetCombinedEquipmentRequestByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCombinedEquipmentRequestByIdQuery, GetCombinedEquipmentRequestByIdQueryVariables>(GetCombinedEquipmentRequestByIdDocument, options);
      }
export function useGetCombinedEquipmentRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCombinedEquipmentRequestByIdQuery, GetCombinedEquipmentRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCombinedEquipmentRequestByIdQuery, GetCombinedEquipmentRequestByIdQueryVariables>(GetCombinedEquipmentRequestByIdDocument, options);
        }
export type GetCombinedEquipmentRequestByIdQueryHookResult = ReturnType<typeof useGetCombinedEquipmentRequestByIdQuery>;
export type GetCombinedEquipmentRequestByIdLazyQueryHookResult = ReturnType<typeof useGetCombinedEquipmentRequestByIdLazyQuery>;
export type GetCombinedEquipmentRequestByIdQueryResult = Apollo.QueryResult<GetCombinedEquipmentRequestByIdQuery, GetCombinedEquipmentRequestByIdQueryVariables>;
export function refetchGetCombinedEquipmentRequestByIdQuery(variables: GetCombinedEquipmentRequestByIdQueryVariables) {
      return { query: GetCombinedEquipmentRequestByIdDocument, variables: variables }
    }
export const EquipmentRequestCreateHistoryRecordDocument = gql`
    mutation equipmentRequestCreateHistoryRecord($input: EquipmentRequestCreateHistoryRecordInput!) {
  equipmentRequestCreateHistoryRecord(input: $input) {
    ...EquipmentRequestHistoryRecordFragmentBasis
  }
}
    ${EquipmentRequestHistoryRecordFragmentBasisFragmentDoc}`;
export type EquipmentRequestCreateHistoryRecordMutationFn = Apollo.MutationFunction<EquipmentRequestCreateHistoryRecordMutation, EquipmentRequestCreateHistoryRecordMutationVariables>;

/**
 * __useEquipmentRequestCreateHistoryRecordMutation__
 *
 * To run a mutation, you first call `useEquipmentRequestCreateHistoryRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEquipmentRequestCreateHistoryRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [equipmentRequestCreateHistoryRecordMutation, { data, loading, error }] = useEquipmentRequestCreateHistoryRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEquipmentRequestCreateHistoryRecordMutation(baseOptions?: Apollo.MutationHookOptions<EquipmentRequestCreateHistoryRecordMutation, EquipmentRequestCreateHistoryRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EquipmentRequestCreateHistoryRecordMutation, EquipmentRequestCreateHistoryRecordMutationVariables>(EquipmentRequestCreateHistoryRecordDocument, options);
      }
export type EquipmentRequestCreateHistoryRecordMutationHookResult = ReturnType<typeof useEquipmentRequestCreateHistoryRecordMutation>;
export type EquipmentRequestCreateHistoryRecordMutationResult = Apollo.MutationResult<EquipmentRequestCreateHistoryRecordMutation>;
export type EquipmentRequestCreateHistoryRecordMutationOptions = Apollo.BaseMutationOptions<EquipmentRequestCreateHistoryRecordMutation, EquipmentRequestCreateHistoryRecordMutationVariables>;
export const GetEquipmentRequestHistoryDocument = gql`
    query getEquipmentRequestHistory($input: GetEquipmentRequestHistoryInput!) {
  getEquipmentRequestHistory(input: $input) {
    ...EquipmentRequestHistoryRecordFragment
  }
}
    ${EquipmentRequestHistoryRecordFragmentFragmentDoc}`;

/**
 * __useGetEquipmentRequestHistoryQuery__
 *
 * To run a query within a React component, call `useGetEquipmentRequestHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentRequestHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentRequestHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEquipmentRequestHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentRequestHistoryQuery, GetEquipmentRequestHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentRequestHistoryQuery, GetEquipmentRequestHistoryQueryVariables>(GetEquipmentRequestHistoryDocument, options);
      }
export function useGetEquipmentRequestHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentRequestHistoryQuery, GetEquipmentRequestHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentRequestHistoryQuery, GetEquipmentRequestHistoryQueryVariables>(GetEquipmentRequestHistoryDocument, options);
        }
export type GetEquipmentRequestHistoryQueryHookResult = ReturnType<typeof useGetEquipmentRequestHistoryQuery>;
export type GetEquipmentRequestHistoryLazyQueryHookResult = ReturnType<typeof useGetEquipmentRequestHistoryLazyQuery>;
export type GetEquipmentRequestHistoryQueryResult = Apollo.QueryResult<GetEquipmentRequestHistoryQuery, GetEquipmentRequestHistoryQueryVariables>;
export function refetchGetEquipmentRequestHistoryQuery(variables: GetEquipmentRequestHistoryQueryVariables) {
      return { query: GetEquipmentRequestHistoryDocument, variables: variables }
    }
export const SportEquipmentWriteOffCancelDocument = gql`
    mutation SportEquipmentWriteOffCancel($sportEquipmentId: UUID!) {
  sportEquipmentWriteOffCancel(sportEquipmentId: $sportEquipmentId) {
    ...SportEquipmentBasis
  }
}
    ${SportEquipmentBasisFragmentDoc}`;
export type SportEquipmentWriteOffCancelMutationFn = Apollo.MutationFunction<SportEquipmentWriteOffCancelMutation, SportEquipmentWriteOffCancelMutationVariables>;

/**
 * __useSportEquipmentWriteOffCancelMutation__
 *
 * To run a mutation, you first call `useSportEquipmentWriteOffCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSportEquipmentWriteOffCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sportEquipmentWriteOffCancelMutation, { data, loading, error }] = useSportEquipmentWriteOffCancelMutation({
 *   variables: {
 *      sportEquipmentId: // value for 'sportEquipmentId'
 *   },
 * });
 */
export function useSportEquipmentWriteOffCancelMutation(baseOptions?: Apollo.MutationHookOptions<SportEquipmentWriteOffCancelMutation, SportEquipmentWriteOffCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SportEquipmentWriteOffCancelMutation, SportEquipmentWriteOffCancelMutationVariables>(SportEquipmentWriteOffCancelDocument, options);
      }
export type SportEquipmentWriteOffCancelMutationHookResult = ReturnType<typeof useSportEquipmentWriteOffCancelMutation>;
export type SportEquipmentWriteOffCancelMutationResult = Apollo.MutationResult<SportEquipmentWriteOffCancelMutation>;
export type SportEquipmentWriteOffCancelMutationOptions = Apollo.BaseMutationOptions<SportEquipmentWriteOffCancelMutation, SportEquipmentWriteOffCancelMutationVariables>;
export const SportEquipmentWriteOffDocument = gql`
    mutation SportEquipmentWriteOff($sportEquipmentId: UUID!, $wroteOffCertificateId: UUID!) {
  sportEquipmentWriteOff(
    sportEquipmentId: $sportEquipmentId
    wroteOffCertificateId: $wroteOffCertificateId
  ) {
    ...SportEquipmentBasis
  }
}
    ${SportEquipmentBasisFragmentDoc}`;
export type SportEquipmentWriteOffMutationFn = Apollo.MutationFunction<SportEquipmentWriteOffMutation, SportEquipmentWriteOffMutationVariables>;

/**
 * __useSportEquipmentWriteOffMutation__
 *
 * To run a mutation, you first call `useSportEquipmentWriteOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSportEquipmentWriteOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sportEquipmentWriteOffMutation, { data, loading, error }] = useSportEquipmentWriteOffMutation({
 *   variables: {
 *      sportEquipmentId: // value for 'sportEquipmentId'
 *      wroteOffCertificateId: // value for 'wroteOffCertificateId'
 *   },
 * });
 */
export function useSportEquipmentWriteOffMutation(baseOptions?: Apollo.MutationHookOptions<SportEquipmentWriteOffMutation, SportEquipmentWriteOffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SportEquipmentWriteOffMutation, SportEquipmentWriteOffMutationVariables>(SportEquipmentWriteOffDocument, options);
      }
export type SportEquipmentWriteOffMutationHookResult = ReturnType<typeof useSportEquipmentWriteOffMutation>;
export type SportEquipmentWriteOffMutationResult = Apollo.MutationResult<SportEquipmentWriteOffMutation>;
export type SportEquipmentWriteOffMutationOptions = Apollo.BaseMutationOptions<SportEquipmentWriteOffMutation, SportEquipmentWriteOffMutationVariables>;
export const GetSelectedSportObjectIdsDocument = gql`
    query GetSelectedSportObjectIds {
  selectedSportObjectIds @client
}
    `;

/**
 * __useGetSelectedSportObjectIdsQuery__
 *
 * To run a query within a React component, call `useGetSelectedSportObjectIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedSportObjectIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedSportObjectIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSelectedSportObjectIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetSelectedSportObjectIdsQuery, GetSelectedSportObjectIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectedSportObjectIdsQuery, GetSelectedSportObjectIdsQueryVariables>(GetSelectedSportObjectIdsDocument, options);
      }
export function useGetSelectedSportObjectIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectedSportObjectIdsQuery, GetSelectedSportObjectIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectedSportObjectIdsQuery, GetSelectedSportObjectIdsQueryVariables>(GetSelectedSportObjectIdsDocument, options);
        }
export type GetSelectedSportObjectIdsQueryHookResult = ReturnType<typeof useGetSelectedSportObjectIdsQuery>;
export type GetSelectedSportObjectIdsLazyQueryHookResult = ReturnType<typeof useGetSelectedSportObjectIdsLazyQuery>;
export type GetSelectedSportObjectIdsQueryResult = Apollo.QueryResult<GetSelectedSportObjectIdsQuery, GetSelectedSportObjectIdsQueryVariables>;
export function refetchGetSelectedSportObjectIdsQuery(variables?: GetSelectedSportObjectIdsQueryVariables) {
      return { query: GetSelectedSportObjectIdsDocument, variables: variables }
    }
export const GetSportObjectsByIdsDocument = gql`
    query getSportObjectsByIds($ids: [String!]!) {
  getSportObjects(ids: $ids) {
    ...SportObjectFull
  }
}
    ${SportObjectFullFragmentDoc}`;

/**
 * __useGetSportObjectsByIdsQuery__
 *
 * To run a query within a React component, call `useGetSportObjectsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportObjectsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportObjectsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetSportObjectsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetSportObjectsByIdsQuery, GetSportObjectsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportObjectsByIdsQuery, GetSportObjectsByIdsQueryVariables>(GetSportObjectsByIdsDocument, options);
      }
export function useGetSportObjectsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportObjectsByIdsQuery, GetSportObjectsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportObjectsByIdsQuery, GetSportObjectsByIdsQueryVariables>(GetSportObjectsByIdsDocument, options);
        }
export type GetSportObjectsByIdsQueryHookResult = ReturnType<typeof useGetSportObjectsByIdsQuery>;
export type GetSportObjectsByIdsLazyQueryHookResult = ReturnType<typeof useGetSportObjectsByIdsLazyQuery>;
export type GetSportObjectsByIdsQueryResult = Apollo.QueryResult<GetSportObjectsByIdsQuery, GetSportObjectsByIdsQueryVariables>;
export function refetchGetSportObjectsByIdsQuery(variables: GetSportObjectsByIdsQueryVariables) {
      return { query: GetSportObjectsByIdsDocument, variables: variables }
    }
export const GetSportEquipmentsDocument = gql`
    query getSportEquipments($input: GetSportEquipmentInput!) {
  getSportEquipments(input: $input) {
    ...SportEquipments
  }
}
    ${SportEquipmentsFragmentDoc}`;

/**
 * __useGetSportEquipmentsQuery__
 *
 * To run a query within a React component, call `useGetSportEquipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportEquipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportEquipmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSportEquipmentsQuery(baseOptions: Apollo.QueryHookOptions<GetSportEquipmentsQuery, GetSportEquipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportEquipmentsQuery, GetSportEquipmentsQueryVariables>(GetSportEquipmentsDocument, options);
      }
export function useGetSportEquipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportEquipmentsQuery, GetSportEquipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportEquipmentsQuery, GetSportEquipmentsQueryVariables>(GetSportEquipmentsDocument, options);
        }
export type GetSportEquipmentsQueryHookResult = ReturnType<typeof useGetSportEquipmentsQuery>;
export type GetSportEquipmentsLazyQueryHookResult = ReturnType<typeof useGetSportEquipmentsLazyQuery>;
export type GetSportEquipmentsQueryResult = Apollo.QueryResult<GetSportEquipmentsQuery, GetSportEquipmentsQueryVariables>;
export function refetchGetSportEquipmentsQuery(variables: GetSportEquipmentsQueryVariables) {
      return { query: GetSportEquipmentsDocument, variables: variables }
    }
export const GetSportEquipmentByIdDocument = gql`
    query getSportEquipmentById($id: String!) {
  getSportEquipmentById(id: $id) {
    ...SportEquipmentFull
  }
}
    ${SportEquipmentFullFragmentDoc}`;

/**
 * __useGetSportEquipmentByIdQuery__
 *
 * To run a query within a React component, call `useGetSportEquipmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportEquipmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportEquipmentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSportEquipmentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSportEquipmentByIdQuery, GetSportEquipmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportEquipmentByIdQuery, GetSportEquipmentByIdQueryVariables>(GetSportEquipmentByIdDocument, options);
      }
export function useGetSportEquipmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportEquipmentByIdQuery, GetSportEquipmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportEquipmentByIdQuery, GetSportEquipmentByIdQueryVariables>(GetSportEquipmentByIdDocument, options);
        }
export type GetSportEquipmentByIdQueryHookResult = ReturnType<typeof useGetSportEquipmentByIdQuery>;
export type GetSportEquipmentByIdLazyQueryHookResult = ReturnType<typeof useGetSportEquipmentByIdLazyQuery>;
export type GetSportEquipmentByIdQueryResult = Apollo.QueryResult<GetSportEquipmentByIdQuery, GetSportEquipmentByIdQueryVariables>;
export function refetchGetSportEquipmentByIdQuery(variables: GetSportEquipmentByIdQueryVariables) {
      return { query: GetSportEquipmentByIdDocument, variables: variables }
    }
export const GetUsersOfSportObjectDocument = gql`
    query GetUsersOfSportObject($sportObjectId: UUID!) {
  usersOfSportObject(sportObjectId: $sportObjectId) {
    ... on UserOfSportObjectResponse {
      email
      login
      userId
    }
  }
}
    `;

/**
 * __useGetUsersOfSportObjectQuery__
 *
 * To run a query within a React component, call `useGetUsersOfSportObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersOfSportObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersOfSportObjectQuery({
 *   variables: {
 *      sportObjectId: // value for 'sportObjectId'
 *   },
 * });
 */
export function useGetUsersOfSportObjectQuery(baseOptions: Apollo.QueryHookOptions<GetUsersOfSportObjectQuery, GetUsersOfSportObjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersOfSportObjectQuery, GetUsersOfSportObjectQueryVariables>(GetUsersOfSportObjectDocument, options);
      }
export function useGetUsersOfSportObjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersOfSportObjectQuery, GetUsersOfSportObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersOfSportObjectQuery, GetUsersOfSportObjectQueryVariables>(GetUsersOfSportObjectDocument, options);
        }
export type GetUsersOfSportObjectQueryHookResult = ReturnType<typeof useGetUsersOfSportObjectQuery>;
export type GetUsersOfSportObjectLazyQueryHookResult = ReturnType<typeof useGetUsersOfSportObjectLazyQuery>;
export type GetUsersOfSportObjectQueryResult = Apollo.QueryResult<GetUsersOfSportObjectQuery, GetUsersOfSportObjectQueryVariables>;
export function refetchGetUsersOfSportObjectQuery(variables: GetUsersOfSportObjectQueryVariables) {
      return { query: GetUsersOfSportObjectDocument, variables: variables }
    }
